//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addressesPOST(body: AddAddressCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addressesPUT(body: UpdateAddressCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    addressesDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Addresses/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    addressesGET(id: string): Observable<AddressModelResponse> {
        let url_ = this.baseUrl + "/api/Addresses/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModelResponse>;
        }));
    }

    protected processAddressesGET(response: HttpResponseBase): Observable<AddressModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<AddressModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Addresses/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressModelPaginationResultResponse>;
        }));
    }

    protected processPageable(response: HttpResponseBase): Observable<AddressModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressModelPaginationResultResponse>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getAddressesForSelect(customerId: string | null | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/Addresses/getAddressesForSelect?";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressesForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetAddressesForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    carsPOST(body: AddCarCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Cars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCarsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCarsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCarsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    carsPUT(body: UpdateCarCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Cars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCarsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCarsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCarsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param typesIds (optional) 
     * @param nodesIds (optional) 
     * @return Success
     */
    carsGET(typesIds: string[] | null | undefined, nodesIds: string[] | null | undefined): Observable<CarModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Cars?";
        if (typesIds !== undefined && typesIds !== null)
            typesIds && typesIds.forEach(item => { url_ += "TypesIds=" + encodeURIComponent("" + item) + "&"; });
        if (nodesIds !== undefined && nodesIds !== null)
            nodesIds && nodesIds.forEach(item => { url_ += "NodesIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCarsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCarsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelIEnumerableResponse>;
        }));
    }

    protected processCarsGET(response: HttpResponseBase): Observable<CarModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    carsDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Cars/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCarsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCarsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCarsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    carsGET2(id: string): Observable<CarModelResponse> {
        let url_ = this.baseUrl + "/api/Cars/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCarsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCarsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelResponse>;
        }));
    }

    protected processCarsGET2(response: HttpResponseBase): Observable<CarModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable2(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<CarModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Cars/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelPaginationResultResponse>;
        }));
    }

    protected processPageable2(response: HttpResponseBase): Observable<CarModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelPaginationResultResponse>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getCarTypesForSelect(query: GetCarTypesForSelectQuery | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/Cars/getCarTypesForSelect?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarTypesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarTypesForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetCarTypesForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param typeIds (optional) 
     * @return Success
     */
    getCarTypesPump(typeIds: string[] | null | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/Cars/getCarTypesPump?";
        if (typeIds !== undefined && typeIds !== null)
            typeIds && typeIds.forEach(item => { url_ += "TypeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarTypesPump(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarTypesPump(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetCarTypesPump(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param nodeId (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    forNodeAndType(nodeId: string | undefined, typeId: string | undefined): Observable<CarModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Cars/forNodeAndType?";
        if (nodeId === null)
            throw new Error("The parameter 'nodeId' cannot be null.");
        else if (nodeId !== undefined)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForNodeAndType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForNodeAndType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelIEnumerableResponse>;
        }));
    }

    protected processForNodeAndType(response: HttpResponseBase): Observable<CarModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelIEnumerableResponse>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getConcreteMixer(nodeId: string, dateFrom: Date, dateTo: Date, orderId: string | null | undefined): Observable<CarModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Cars/getConcreteMixer/{NodeId}/{DateFrom}/{DateTo}?";
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{NodeId}", encodeURIComponent("" + nodeId));
        if (dateFrom === undefined || dateFrom === null)
            throw new Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{DateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{DateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (orderId !== undefined && orderId !== null)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConcreteMixer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConcreteMixer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelIEnumerableResponse>;
        }));
    }

    protected processGetConcreteMixer(response: HttpResponseBase): Observable<CarModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelIEnumerableResponse>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param word (optional) 
     * @return Success
     */
    getRegistrationNumbersForCustomerForSelect(customerId: string | undefined, word: string | null | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/Cars/getRegistrationNumbersForCustomerForSelect?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (word !== undefined && word !== null)
            url_ += "Word=" + encodeURIComponent("" + word) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationNumbersForCustomerForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationNumbersForCustomerForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetRegistrationNumbersForCustomerForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerPOST(body: AddCustomerCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomerPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerPUT(body: UpdateCustomerCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomerPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    customerGET(): Observable<CustomerModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModelIEnumerableResponse>;
        }));
    }

    protected processCustomerGET(response: HttpResponseBase): Observable<CustomerModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerModelIEnumerableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    alias(body: AddCustomerAliasCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer/alias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAlias(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    customerGET2(id: string): Observable<CustomerModelResponse> {
        let url_ = this.baseUrl + "/api/Customer/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModelResponse>;
        }));
    }

    protected processCustomerGET2(response: HttpResponseBase): Observable<CustomerModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    fromGus(nip: number): Observable<ContractorExternalViewModelResponse> {
        let url_ = this.baseUrl + "/api/Customer/{nip}/from-gus";
        if (nip === undefined || nip === null)
            throw new Error("The parameter 'nip' must be defined.");
        url_ = url_.replace("{nip}", encodeURIComponent("" + nip));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFromGus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFromGus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractorExternalViewModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractorExternalViewModelResponse>;
        }));
    }

    protected processFromGus(response: HttpResponseBase): Observable<ContractorExternalViewModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractorExternalViewModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractorExternalViewModelResponse>(null as any);
    }

    /**
     * @param excludeId (optional) 
     * @param nip (optional) 
     * @return Success
     */
    doesCustomerWithNipExist(excludeId: string | null | undefined, nip: number | undefined): Observable<BooleanResponse> {
        let url_ = this.baseUrl + "/api/Customer/DoesCustomerWithNipExist?";
        if (excludeId !== undefined && excludeId !== null)
            url_ += "ExcludeId=" + encodeURIComponent("" + excludeId) + "&";
        if (nip === null)
            throw new Error("The parameter 'nip' cannot be null.");
        else if (nip !== undefined)
            url_ += "Nip=" + encodeURIComponent("" + nip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesCustomerWithNipExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesCustomerWithNipExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponse>;
        }));
    }

    protected processDoesCustomerWithNipExist(response: HttpResponseBase): Observable<BooleanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanResponse>(null as any);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    isCustomerWithPhoneNumberExist(phoneNumber: string | null | undefined): Observable<BooleanResponse> {
        let url_ = this.baseUrl + "/api/Customer/IsCustomerWithPhoneNumberExist?";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCustomerWithPhoneNumberExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCustomerWithPhoneNumberExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponse>;
        }));
    }

    protected processIsCustomerWithPhoneNumberExist(response: HttpResponseBase): Observable<BooleanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param customerType (optional) 
     * @return Success
     */
    pageable3(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, customerType: string | null | undefined): Observable<CustomerModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Customer/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (customerType !== undefined && customerType !== null)
            url_ += "CustomerType=" + encodeURIComponent("" + customerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerModelPaginationResultResponse>;
        }));
    }

    protected processPageable3(response: HttpResponseBase): Observable<CustomerModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerModelPaginationResultResponse>(null as any);
    }

    /**
     * @param filterWords (optional) 
     * @return Success
     */
    searchModel(filterWords: string | null | undefined): Observable<SearchModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Customer/search-model?";
        if (filterWords !== undefined && filterWords !== null)
            url_ += "FilterWords=" + encodeURIComponent("" + filterWords) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchModelIEnumerableResponse>;
        }));
    }

    protected processSearchModel(response: HttpResponseBase): Observable<SearchModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchModelIEnumerableResponse>(null as any);
    }

    /**
     * @param filterWords (optional) 
     * @return Success
     */
    searchCustomerModel(filterWords: string | null | undefined): Observable<SearchModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Customer/search-customer-model?";
        if (filterWords !== undefined && filterWords !== null)
            url_ += "FilterWords=" + encodeURIComponent("" + filterWords) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCustomerModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomerModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchModelIEnumerableResponse>;
        }));
    }

    protected processSearchCustomerModel(response: HttpResponseBase): Observable<SearchModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchModelIEnumerableResponse>(null as any);
    }

    /**
     * @param uniqueAbbreviation (optional) 
     * @return Success
     */
    checkCustomerWithUniqueAbbreviation(uniqueAbbreviation: string | null | undefined): Observable<BooleanResponse> {
        let url_ = this.baseUrl + "/api/Customer/CheckCustomerWithUniqueAbbreviation?";
        if (uniqueAbbreviation !== undefined && uniqueAbbreviation !== null)
            url_ += "UniqueAbbreviation=" + encodeURIComponent("" + uniqueAbbreviation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCustomerWithUniqueAbbreviation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCustomerWithUniqueAbbreviation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponse>;
        }));
    }

    protected processCheckCustomerWithUniqueAbbreviation(response: HttpResponseBase): Observable<BooleanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignDeliveriesByOrderItem(body: AssignDeliveriesByOrderItemCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DeliveryCalendar/AssignDeliveriesByOrderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignDeliveriesByOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignDeliveriesByOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignDeliveriesByOrderItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param date (optional) 
     * @param nodes (optional) 
     * @return Success
     */
    getUnassignedDeliveryItemsForDate(date: Date | undefined, nodes: string[] | null | undefined): Observable<DeliveryItemModelResponse> {
        let url_ = this.baseUrl + "/api/DeliveryCalendar/GetUnassignedDeliveryItemsForDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (nodes !== undefined && nodes !== null)
            nodes && nodes.forEach(item => { url_ += "Nodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedDeliveryItemsForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedDeliveryItemsForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryItemModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryItemModelResponse>;
        }));
    }

    protected processGetUnassignedDeliveryItemsForDate(response: HttpResponseBase): Observable<DeliveryItemModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryItemModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryItemModelResponse>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    getExistingDeliveryItemsForDate(date: Date | undefined): Observable<ExistingDeliveryModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/DeliveryCalendar/GetExistingDeliveryItemsForDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingDeliveryItemsForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingDeliveryItemsForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistingDeliveryModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistingDeliveryModelIEnumerableResponse>;
        }));
    }

    protected processGetExistingDeliveryItemsForDate(response: HttpResponseBase): Observable<ExistingDeliveryModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistingDeliveryModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExistingDeliveryModelIEnumerableResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param date (optional) 
     * @param nodes (optional) 
     * @return Success
     */
    getPageableUnassignedDeliveryItemsForDate(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, date: Date | undefined, nodes: string[] | null | undefined): Observable<DeliveryItemModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/DeliveryCalendar/GetPageableUnassignedDeliveryItemsForDate?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (nodes !== undefined && nodes !== null)
            nodes && nodes.forEach(item => { url_ += "Nodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPageableUnassignedDeliveryItemsForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPageableUnassignedDeliveryItemsForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryItemModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryItemModelPaginationResultResponse>;
        }));
    }

    protected processGetPageableUnassignedDeliveryItemsForDate(response: HttpResponseBase): Observable<DeliveryItemModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryItemModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryItemModelPaginationResultResponse>(null as any);
    }

    /**
     * @param date (optional) 
     * @param nodeId (optional) 
     * @param carTypeId (optional) 
     * @return Success
     */
    getPumpOccupancyByNodeQuery(date: Date | undefined, nodeId: string | undefined, carTypeId: string | undefined): Observable<DeliveriesAssignedToPumpModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/DeliveryCalendar/GetPumpOccupancyByNodeQuery?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (nodeId === null)
            throw new Error("The parameter 'nodeId' cannot be null.");
        else if (nodeId !== undefined)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (carTypeId === null)
            throw new Error("The parameter 'carTypeId' cannot be null.");
        else if (carTypeId !== undefined)
            url_ += "CarTypeId=" + encodeURIComponent("" + carTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPumpOccupancyByNodeQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPumpOccupancyByNodeQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveriesAssignedToPumpModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveriesAssignedToPumpModelIEnumerableResponse>;
        }));
    }

    protected processGetPumpOccupancyByNodeQuery(response: HttpResponseBase): Observable<DeliveriesAssignedToPumpModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveriesAssignedToPumpModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveriesAssignedToPumpModelIEnumerableResponse>(null as any);
    }

    /**
     * @param registrationNumber (optional) 
     * @return Success
     */
    getDeliveryItemsForRegistrationNumber(registrationNumber: string | null | undefined): Observable<DeliveryItemModelResponse> {
        let url_ = this.baseUrl + "/api/DeliveryCalendar/GetDeliveryItemsForRegistrationNumber?";
        if (registrationNumber !== undefined && registrationNumber !== null)
            url_ += "RegistrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryItemsForRegistrationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryItemsForRegistrationNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryItemModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryItemModelResponse>;
        }));
    }

    protected processGetDeliveryItemsForRegistrationNumber(response: HttpResponseBase): Observable<DeliveryItemModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryItemModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryItemModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ingredientsPOST(body: AddIngredientCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Ingredients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngredientsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngredientsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIngredientsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ingredientsPUT(body: UpdateIngredientCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Ingredients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngredientsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngredientsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIngredientsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    ingredientsDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Ingredients/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngredientsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngredientsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIngredientsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    ingredientsGET(id: string): Observable<IngredientModelResponse> {
        let url_ = this.baseUrl + "/api/Ingredients/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngredientsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngredientsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientModelResponse>;
        }));
    }

    protected processIngredientsGET(response: HttpResponseBase): Observable<IngredientModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngredientModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngredientModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable4(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<IngredientModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Ingredients/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientModelPaginationResultResponse>;
        }));
    }

    protected processPageable4(response: HttpResponseBase): Observable<IngredientModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngredientModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngredientModelPaginationResultResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable5(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<IngredientTypeModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/IngredientTypes/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientTypeModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientTypeModelPaginationResultResponse>;
        }));
    }

    protected processPageable5(response: HttpResponseBase): Observable<IngredientTypeModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngredientTypeModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngredientTypeModelPaginationResultResponse>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    ingredientTypes(query: GetAllIngredientTypesQuery | undefined): Observable<IngredientTypeModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/IngredientTypes?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngredientTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngredientTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientTypeModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientTypeModelIEnumerableResponse>;
        }));
    }

    protected processIngredientTypes(response: HttpResponseBase): Observable<IngredientTypeModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngredientTypeModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngredientTypeModelIEnumerableResponse>(null as any);
    }

    /**
     * @param nodeId (optional) 
     * @return Success
     */
    forNode(nodeId: string | null | undefined): Observable<IngredientTypeModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/IngredientTypes/for-node?";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientTypeModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientTypeModelIEnumerableResponse>;
        }));
    }

    protected processForNode(response: HttpResponseBase): Observable<IngredientTypeModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngredientTypeModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngredientTypeModelIEnumerableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    itemsPOST(body: AddItemCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processItemsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    itemsPUT(body: UpdateItemCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processItemsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    itemsGET(): Observable<ItemModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Items";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemModelIEnumerableResponse>;
        }));
    }

    protected processItemsGET(response: HttpResponseBase): Observable<ItemModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    itemsDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Items/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processItemsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    itemsGET2(id: string): Observable<ItemModelResponse> {
        let url_ = this.baseUrl + "/api/Items/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemModelResponse>;
        }));
    }

    protected processItemsGET2(response: HttpResponseBase): Observable<ItemModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param customerId (optional) 
     * @param isProduct (optional) 
     * @param isService (optional) 
     * @param onlyNullCustomer (optional) 
     * @return Success
     */
    pageable6(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, customerId: string | null | undefined, isProduct: boolean | null | undefined, isService: boolean | null | undefined, onlyNullCustomer: boolean | null | undefined): Observable<ItemModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Items/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (isProduct !== undefined && isProduct !== null)
            url_ += "IsProduct=" + encodeURIComponent("" + isProduct) + "&";
        if (isService !== undefined && isService !== null)
            url_ += "IsService=" + encodeURIComponent("" + isService) + "&";
        if (onlyNullCustomer !== undefined && onlyNullCustomer !== null)
            url_ += "OnlyNullCustomer=" + encodeURIComponent("" + onlyNullCustomer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemModelPaginationResultResponse>;
        }));
    }

    protected processPageable6(response: HttpResponseBase): Observable<ItemModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemModelPaginationResultResponse>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getItemTypesForSelect(query: GetItemTypesForSelectQuery | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/Items/getItemTypesForSelect?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemTypesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemTypesForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetItemTypesForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @return Success
     */
    getItemsProduct(): Observable<ItemModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Items/getItemsProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemsProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemsProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemModelIEnumerableResponse>;
        }));
    }

    protected processGetItemsProduct(response: HttpResponseBase): Observable<ItemModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemModelIEnumerableResponse>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getItemsService(customerId: string | null | undefined): Observable<ItemModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Items/getItemsService?";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemsService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemsService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemModelIEnumerableResponse>;
        }));
    }

    protected processGetItemsService(response: HttpResponseBase): Observable<ItemModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProductsByNode(nodeId: string): Observable<ItemByNodeModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Items/getProductsByNode/{NodeId}";
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{NodeId}", encodeURIComponent("" + nodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsByNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsByNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemByNodeModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemByNodeModelIEnumerableResponse>;
        }));
    }

    protected processGetProductsByNode(response: HttpResponseBase): Observable<ItemByNodeModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemByNodeModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemByNodeModelIEnumerableResponse>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param nodeId (optional) 
     * @return Success
     */
    getProductsByCustomer(customerId: string | undefined, nodeId: string | null | undefined): Observable<ItemByCustomerModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Items/getProductsByCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemByCustomerModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemByCustomerModelIEnumerableResponse>;
        }));
    }

    protected processGetProductsByCustomer(response: HttpResponseBase): Observable<ItemByCustomerModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemByCustomerModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemByCustomerModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerItems(customerId: string): Observable<ItemModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Items/getCustomerItems/{CustomerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{CustomerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemModelIEnumerableResponse>;
        }));
    }

    protected processGetCustomerItems(response: HttpResponseBase): Observable<ItemModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemModelIEnumerableResponse>(null as any);
    }

    /**
     * @param nodeId (optional) 
     * @param isProduct (optional) 
     * @param isService (optional) 
     * @return Success
     */
    getForSelect(nodeId: string | null | undefined, isProduct: boolean | null | undefined, isService: boolean | null | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/Items/getForSelect?";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (isProduct !== undefined && isProduct !== null)
            url_ += "IsProduct=" + encodeURIComponent("" + isProduct) + "&";
        if (isService !== undefined && isService !== null)
            url_ += "IsService=" + encodeURIComponent("" + isService) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param nodeId (optional) 
     * @param customerId (optional) 
     * @param addressId (optional) 
     * @param name (optional) 
     * @return Success
     */
    getItemNameExists(nodeId: string | null | undefined, customerId: string | null | undefined, addressId: string | null | undefined, name: string | null | undefined): Observable<BooleanResponse> {
        let url_ = this.baseUrl + "/api/Items/getItemNameExists?";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (addressId !== undefined && addressId !== null)
            url_ += "AddressId=" + encodeURIComponent("" + addressId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemNameExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponse>;
        }));
    }

    protected processGetItemNameExists(response: HttpResponseBase): Observable<BooleanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param version (optional) 
     * @return Success
     */
    mobileVersionPOST(file: FileParameter | null | undefined, version: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/MobileVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (version !== null && version !== undefined)
            content_.append("Version", version.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileVersionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileVersionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMobileVersionPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    mobileVersionGET(): Observable<MobileVersionModelResponse> {
        let url_ = this.baseUrl + "/api/MobileVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileVersionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileVersionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MobileVersionModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MobileVersionModelResponse>;
        }));
    }

    protected processMobileVersionGET(response: HttpResponseBase): Observable<MobileVersionModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileVersionModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileVersionModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    download(): Observable<void> {
        let url_ = this.baseUrl + "/api/MobileVersion/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    nodesPOST(body: AddNodeCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Nodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNodesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNodesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNodesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    nodesPUT(body: UpdateNodeCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Nodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNodesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNodesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNodesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    nodesGET(): Observable<NodeModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Nodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNodesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNodesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NodeModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NodeModelIEnumerableResponse>;
        }));
    }

    protected processNodesGET(response: HttpResponseBase): Observable<NodeModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodeModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NodeModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    nodesDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Nodes/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNodesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNodesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNodesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    nodesGET2(id: string): Observable<NodeModelResponse> {
        let url_ = this.baseUrl + "/api/Nodes/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNodesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNodesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NodeModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NodeModelResponse>;
        }));
    }

    protected processNodesGET2(response: HttpResponseBase): Observable<NodeModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodeModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NodeModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable7(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<NodeModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Nodes/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NodeModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NodeModelPaginationResultResponse>;
        }));
    }

    protected processPageable7(response: HttpResponseBase): Observable<NodeModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodeModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NodeModelPaginationResultResponse>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getForSelect2(query: GetNodesForSelectQuery | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/Nodes/getForSelect?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSelect2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSelect2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetForSelect2(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    offersPOST(body: CreateOfferCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Offers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOffersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOffersPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    offersPUT(body: UpdateOfferCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Offers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOffersPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffersPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOffersPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    offersGET(id: string): Observable<OfferModelResponse> {
        let url_ = this.baseUrl + "/api/Offers/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOffersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferModelResponse>;
        }));
    }

    protected processOffersGET(response: HttpResponseBase): Observable<OfferModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfferModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable8(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<OfferModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Offers/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferModelPaginationResultResponse>;
        }));
    }

    protected processPageable8(response: HttpResponseBase): Observable<OfferModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfferModelPaginationResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    nextNumber(): Observable<StringResponse> {
        let url_ = this.baseUrl + "/api/Offers/nextNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNextNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNextNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringResponse>;
        }));
    }

    protected processNextNumber(response: HttpResponseBase): Observable<StringResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringResponse>(null as any);
    }

    /**
     * @return Success
     */
    pdf(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Offers/{Id}/pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendpdf(body: SendOfferPdfByMailCommand | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Offers/sendpdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendpdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendpdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendpdf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderExecutionQueuePOST(body: CreateOrderExecutionQueueItemCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderExecutionQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderExecutionQueuePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderExecutionQueuePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderExecutionQueuePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderExecutionQueuePUT(body: UpdateOrderExecutionQueueItemCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderExecutionQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderExecutionQueuePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderExecutionQueuePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderExecutionQueuePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nodeId (optional) 
     * @param date (optional) 
     * @return Success
     */
    orderExecutionQueueGET(nodeId: string | undefined, date: Date | undefined): Observable<OrderExecutionQueueItemModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/OrderExecutionQueue?";
        if (nodeId === null)
            throw new Error("The parameter 'nodeId' cannot be null.");
        else if (nodeId !== undefined)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderExecutionQueueGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderExecutionQueueGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderExecutionQueueItemModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderExecutionQueueItemModelIEnumerableResponse>;
        }));
    }

    protected processOrderExecutionQueueGET(response: HttpResponseBase): Observable<OrderExecutionQueueItemModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderExecutionQueueItemModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderExecutionQueueItemModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    orderExecutionQueueDELETE(id: string | null, orderId: string | null, supplyId: string | null, useTransaction: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderExecutionQueue/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{OrderId}", encodeURIComponent("" + orderId));
        if (supplyId === undefined || supplyId === null)
            throw new Error("The parameter 'supplyId' must be defined.");
        url_ = url_.replace("{SupplyId}", encodeURIComponent("" + supplyId));
        if (useTransaction === undefined || useTransaction === null)
            throw new Error("The parameter 'useTransaction' must be defined.");
        url_ = url_.replace("{UseTransaction}", encodeURIComponent("" + useTransaction));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderExecutionQueueDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderExecutionQueueDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderExecutionQueueDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ordersPOST(body: AddOrderCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrdersPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ordersPUT(body: UpdateOrderCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrdersPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    ordersGET(): Observable<OrderModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelIEnumerableResponse>;
        }));
    }

    protected processOrdersGET(response: HttpResponseBase): Observable<OrderModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModelIEnumerableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCopyOrder(body: AddCopyOrderCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/AddCopyOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCopyOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCopyOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCopyOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDate(body: UpdateOrderDateCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateState(body: UpdateOrderStateCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSettlement(body: UpdateOrderSettlementCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateSettlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSettlement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    ordersDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrdersDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    ordersGET2(id: string): Observable<OrderModelResponse> {
        let url_ = this.baseUrl + "/api/Orders/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelResponse>;
        }));
    }

    protected processOrdersGET2(response: HttpResponseBase): Observable<OrderModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCommentOfDay(body: AddCommentOfDayCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/AddCommentOfDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCommentOfDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCommentOfDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddCommentOfDay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCancellationReason(body: UpdateCancellationReasonCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateCancellationReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCancellationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCancellationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCancellationReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRegistrationNumber(body: UpdateRegistrationNumberCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateRegistrationNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRegistrationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRegistrationNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRegistrationNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderActivation(body: OrderActivationCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/OrderActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderActivation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    withRemainingMass(id: string, supplyId: string | null): Observable<OrderModelResponse> {
        let url_ = this.baseUrl + "/api/Orders/{Id}/WithRemainingMass";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (supplyId === undefined || supplyId === null)
            throw new Error("The parameter 'supplyId' must be defined.");
        url_ = url_.replace("{SupplyId}", encodeURIComponent("" + supplyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithRemainingMass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithRemainingMass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelResponse>;
        }));
    }

    protected processWithRemainingMass(response: HttpResponseBase): Observable<OrderModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    withRemainingMass2(id: string, supplyId: string | null): Observable<OrderModelResponse> {
        let url_ = this.baseUrl + "/api/Orders/{Id}/WithRemainingMass/{SupplyId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (supplyId === undefined || supplyId === null)
            throw new Error("The parameter 'supplyId' must be defined.");
        url_ = url_.replace("{SupplyId}", encodeURIComponent("" + supplyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithRemainingMass2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithRemainingMass2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelResponse>;
        }));
    }

    protected processWithRemainingMass2(response: HttpResponseBase): Observable<OrderModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable9(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<OrderModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Orders/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable9(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable9(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPaginationResultResponse>;
        }));
    }

    protected processPageable9(response: HttpResponseBase): Observable<OrderModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModelPaginationResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    ordersGET3(dateFrom: Date, dateTo: Date, nodeId: string, customerId: string | null): Observable<OrderModelByDateResponse> {
        let url_ = this.baseUrl + "/api/Orders/{NodeId}/{DateFrom}/{DateTo}/{CustomerId}";
        if (dateFrom === undefined || dateFrom === null)
            throw new Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{DateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{DateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{NodeId}", encodeURIComponent("" + nodeId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{CustomerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelByDateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelByDateResponse>;
        }));
    }

    protected processOrdersGET3(response: HttpResponseBase): Observable<OrderModelByDateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelByDateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModelByDateResponse>(null as any);
    }

    /**
     * @return Success
     */
    inProggress(dateFrom: Date, dateTo: Date, nodeId: string): Observable<OrderModelByDateResponse> {
        let url_ = this.baseUrl + "/api/Orders/InProggress/{NodeId}/{DateFrom}/{DateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{DateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{DateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{NodeId}", encodeURIComponent("" + nodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInProggress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInProggress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelByDateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelByDateResponse>;
        }));
    }

    protected processInProggress(response: HttpResponseBase): Observable<OrderModelByDateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelByDateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModelByDateResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAll(dateFrom: Date, dateTo: Date, nodeId: string): Observable<ForDeliveryStatusesOrderModelResponse> {
        let url_ = this.baseUrl + "/api/Orders/GetAll/{NodeId}/{DateFrom}/{DateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{DateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{DateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{NodeId}", encodeURIComponent("" + nodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForDeliveryStatusesOrderModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForDeliveryStatusesOrderModelResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ForDeliveryStatusesOrderModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForDeliveryStatusesOrderModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForDeliveryStatusesOrderModelResponse>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param nodeId (optional) 
     * @return Success
     */
    getForHoursRanges(dateFrom: Date | undefined, dateTo: Date | undefined, nodeId: string | null | undefined): Observable<OrdersByHourModelResponse> {
        let url_ = this.baseUrl + "/api/Orders/GetForHoursRanges?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForHoursRanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForHoursRanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersByHourModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersByHourModelResponse>;
        }));
    }

    protected processGetForHoursRanges(response: HttpResponseBase): Observable<OrdersByHourModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrdersByHourModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersByHourModelResponse>(null as any);
    }

    /**
     * @param dateOfComments (optional) 
     * @return Success
     */
    getCommentsOfDay(dateOfComments: Date | undefined): Observable<CommentsOfDayModelResponse> {
        let url_ = this.baseUrl + "/api/Orders/GetCommentsOfDay?";
        if (dateOfComments === null)
            throw new Error("The parameter 'dateOfComments' cannot be null.");
        else if (dateOfComments !== undefined)
            url_ += "DateOfComments=" + encodeURIComponent(dateOfComments ? "" + dateOfComments.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentsOfDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentsOfDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentsOfDayModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentsOfDayModelResponse>;
        }));
    }

    protected processGetCommentsOfDay(response: HttpResponseBase): Observable<CommentsOfDayModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentsOfDayModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommentsOfDayModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerOrdersHistory(customerId: string): Observable<CustomerOrdersHistoryModelResponse> {
        let url_ = this.baseUrl + "/api/Orders/GetCustomerOrdersHistory/{CustomerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{CustomerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerOrdersHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerOrdersHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOrdersHistoryModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOrdersHistoryModelResponse>;
        }));
    }

    protected processGetCustomerOrdersHistory(response: HttpResponseBase): Observable<CustomerOrdersHistoryModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerOrdersHistoryModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerOrdersHistoryModelResponse>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param nodeId (optional) 
     * @param isIndividualPrice (optional) 
     * @param onlyEmptyPrice (optional) 
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    ordersCatalog(dateFrom: Date | undefined, dateTo: Date | undefined, nodeId: string | null | undefined, isIndividualPrice: boolean | null | undefined, onlyEmptyPrice: boolean | null | undefined, desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<SimpleOrderModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Orders/orders-catalog?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (isIndividualPrice !== undefined && isIndividualPrice !== null)
            url_ += "IsIndividualPrice=" + encodeURIComponent("" + isIndividualPrice) + "&";
        if (onlyEmptyPrice !== undefined && onlyEmptyPrice !== null)
            url_ += "OnlyEmptyPrice=" + encodeURIComponent("" + onlyEmptyPrice) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleOrderModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleOrderModelPaginationResultResponse>;
        }));
    }

    protected processOrdersCatalog(response: HttpResponseBase): Observable<SimpleOrderModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleOrderModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SimpleOrderModelPaginationResultResponse>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param nodeId (optional) 
     * @param customerId (optional) 
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    ordersWebSale(dateFrom: Date | undefined, dateTo: Date | undefined, nodeId: string | null | undefined, customerId: string | undefined, desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<ExternalUserOrderModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Orders/orders-web-sale?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrdersWebSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrdersWebSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalUserOrderModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalUserOrderModelPaginationResultResponse>;
        }));
    }

    protected processOrdersWebSale(response: HttpResponseBase): Observable<ExternalUserOrderModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalUserOrderModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalUserOrderModelPaginationResultResponse>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    nodesCallendar(date: Date | undefined): Observable<OrdersByNodesCallendarModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Orders/nodes-callendar?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNodesCallendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNodesCallendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersByNodesCallendarModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersByNodesCallendarModelIEnumerableResponse>;
        }));
    }

    protected processNodesCallendar(response: HttpResponseBase): Observable<OrdersByNodesCallendarModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrdersByNodesCallendarModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersByNodesCallendarModelIEnumerableResponse>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    pageableEditHistory(orderId: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, desc: boolean | undefined, orderBy: string | null | undefined): Observable<OrderEditHistoryModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Orders/GetEditHistory/Pageable?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderEditHistoryModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderEditHistoryModelPaginationResultResponse>;
        }));
    }

    protected processPageableEditHistory(response: HttpResponseBase): Observable<OrderEditHistoryModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderEditHistoryModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderEditHistoryModelPaginationResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderStatusesPOST(body: AddOrderStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderStatusesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderStatusesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderStatusesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderStatusesPUT(body: UpdateOrderStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderStatusesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderStatusesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderStatusesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    orderStatusesGET(): Observable<OrderStatusModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/OrderStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderStatusesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderStatusesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderStatusModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderStatusModelIEnumerableResponse>;
        }));
    }

    protected processOrderStatusesGET(response: HttpResponseBase): Observable<OrderStatusModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStatusModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStatusModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    orderStatusesDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderStatuses/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderStatusesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderStatusesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderStatusesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    orderStatusesGET2(id: string): Observable<OrderStatusModelResponse> {
        let url_ = this.baseUrl + "/api/OrderStatuses/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderStatusesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderStatusesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderStatusModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderStatusModelResponse>;
        }));
    }

    protected processOrderStatusesGET2(response: HttpResponseBase): Observable<OrderStatusModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStatusModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStatusModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable10(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<OrderStatusModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/OrderStatuses/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable10(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable10(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderStatusModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderStatusModelPaginationResultResponse>;
        }));
    }

    protected processPageable10(response: HttpResponseBase): Observable<OrderStatusModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStatusModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStatusModelPaginationResultResponse>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getOrderStatusesForSelect(query: GetOrderStatusesForSelectQuery | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/OrderStatuses/getOrderStatusesForSelect?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderStatusesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatusesForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetOrderStatusesForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @return Success
     */
    paymentType(): Observable<PaymentTypeModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/PaymentType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentTypeModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentTypeModelIEnumerableResponse>;
        }));
    }

    protected processPaymentType(response: HttpResponseBase): Observable<PaymentTypeModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentTypeModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentTypeModelIEnumerableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recipeCostsPOST(body: AddRecipeCostCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RecipeCosts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecipeCostsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecipeCostsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecipeCostsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recipeCostsPUT(body: UpdateRecipeCostCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RecipeCosts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecipeCostsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecipeCostsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecipeCostsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    recipeCostsDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/RecipeCosts/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecipeCostsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecipeCostsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecipeCostsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    recipeCostsGET(id: string): Observable<RecipeCostModelResponse> {
        let url_ = this.baseUrl + "/api/RecipeCosts/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecipeCostsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecipeCostsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeCostModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeCostModelResponse>;
        }));
    }

    protected processRecipeCostsGET(response: HttpResponseBase): Observable<RecipeCostModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeCostModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecipeCostModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable11(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<RecipeCostModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/RecipeCosts/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable11(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable11(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipeCostModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipeCostModelPaginationResultResponse>;
        }));
    }

    protected processPageable11(response: HttpResponseBase): Observable<RecipeCostModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecipeCostModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecipeCostModelPaginationResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settlementsPOST(body: CreateSettlementCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Settlements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettlementsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettlementsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSettlementsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settlementsPUT(body: UpdateSettlementCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Settlements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettlementsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettlementsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSettlementsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nodeId (optional) 
     * @param files (optional) 
     * @return Success
     */
    createFromFiles(nodeId: string | undefined, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Settlements/create-from-files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (nodeId === null || nodeId === undefined)
            throw new Error("The parameter 'nodeId' cannot be null.");
        else
            content_.append("NodeId", nodeId.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateFromFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nodeId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param status (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    pageable12(nodeId: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, status: SettlementStatuses | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, desc: boolean | undefined, orderBy: string | null | undefined): Observable<SettlementModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Settlements/pageable?";
        if (nodeId !== undefined && nodeId !== null)
            url_ += "NodeId=" + encodeURIComponent("" + nodeId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable12(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable12(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettlementModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettlementModelPaginationResultResponse>;
        }));
    }

    protected processPageable12(response: HttpResponseBase): Observable<SettlementModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettlementModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SettlementModelPaginationResultResponse>(null as any);
    }

    /**
     * @param settlementId (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    pageableHistory(settlementId: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, desc: boolean | undefined, orderBy: string | null | undefined): Observable<SettlementModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Settlements/pageable-history?";
        if (settlementId === null)
            throw new Error("The parameter 'settlementId' cannot be null.");
        else if (settlementId !== undefined)
            url_ += "SettlementId=" + encodeURIComponent("" + settlementId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageableHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageableHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettlementModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettlementModelPaginationResultResponse>;
        }));
    }

    protected processPageableHistory(response: HttpResponseBase): Observable<SettlementModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettlementModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SettlementModelPaginationResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    specialAdditivesPOST(body: AddSpecialAdditiveCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SpecialAdditives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialAdditivesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialAdditivesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSpecialAdditivesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    specialAdditivesPUT(body: UpdateSpecialAdditiveCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SpecialAdditives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialAdditivesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialAdditivesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSpecialAdditivesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    specialAdditivesDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SpecialAdditives/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialAdditivesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialAdditivesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSpecialAdditivesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    specialAdditivesGET(id: string): Observable<SpecialAdditivesSelectModelResponse> {
        let url_ = this.baseUrl + "/api/SpecialAdditives/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialAdditivesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialAdditivesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialAdditivesSelectModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialAdditivesSelectModelResponse>;
        }));
    }

    protected processSpecialAdditivesGET(response: HttpResponseBase): Observable<SpecialAdditivesSelectModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialAdditivesSelectModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SpecialAdditivesSelectModelResponse>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable13(customerId: string | null | undefined, desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<SpecialAdditivesSelectModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/SpecialAdditives/pageable?";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable13(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable13(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialAdditivesSelectModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialAdditivesSelectModelPaginationResultResponse>;
        }));
    }

    protected processPageable13(response: HttpResponseBase): Observable<SpecialAdditivesSelectModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialAdditivesSelectModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SpecialAdditivesSelectModelPaginationResultResponse>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param isForHigherClass (optional) 
     * @return Success
     */
    getSpecialAdditivesForSelect(customerId: string | null | undefined, isForHigherClass: boolean | null | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/SpecialAdditives/getSpecialAdditivesForSelect?";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (isForHigherClass !== undefined && isForHigherClass !== null)
            url_ += "IsForHigherClass=" + encodeURIComponent("" + isForHigherClass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialAdditivesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialAdditivesForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetSpecialAdditivesForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    structuralElementsPOST(body: AddStructuralElementCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/StructuralElements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStructuralElementsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStructuralElementsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStructuralElementsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    structuralElementsPUT(body: UpdateStructuralElementCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/StructuralElements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStructuralElementsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStructuralElementsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStructuralElementsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    structuralElementsGET(): Observable<StructuralElementModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/StructuralElements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStructuralElementsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStructuralElementsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructuralElementModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructuralElementModelIEnumerableResponse>;
        }));
    }

    protected processStructuralElementsGET(response: HttpResponseBase): Observable<StructuralElementModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructuralElementModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StructuralElementModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    structuralElementsGET2(id: string): Observable<StructuralElementModelResponse> {
        let url_ = this.baseUrl + "/api/StructuralElements/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStructuralElementsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStructuralElementsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructuralElementModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructuralElementModelResponse>;
        }));
    }

    protected processStructuralElementsGET2(response: HttpResponseBase): Observable<StructuralElementModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructuralElementModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StructuralElementModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    structuralElementsDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/StructuralElements/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStructuralElementsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStructuralElementsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStructuralElementsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable14(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<StructuralElementModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/StructuralElements/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable14(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable14(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructuralElementModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructuralElementModelPaginationResultResponse>;
        }));
    }

    protected processPageable14(response: HttpResponseBase): Observable<StructuralElementModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructuralElementModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StructuralElementModelPaginationResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suppliesPOST(body: AddSupplyCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuppliesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuppliesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSuppliesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suppliesPUT(body: UpdateSupplyCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuppliesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuppliesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSuppliesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    suppliesGET(): Observable<SupplyModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Supplies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuppliesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuppliesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyModelIEnumerableResponse>;
        }));
    }

    protected processSuppliesGET(response: HttpResponseBase): Observable<SupplyModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyModelIEnumerableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    openGate(body: OpenGateCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplies/OpenGate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenGate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenGate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpenGate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addWeighting(body: AddWeightingCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplies/AddWeighting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWeighting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWeighting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddWeighting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    suppliesDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplies/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuppliesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuppliesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSuppliesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    suppliesGET2(id: string): Observable<SupplyModelResponse> {
        let url_ = this.baseUrl + "/api/Supplies/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuppliesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuppliesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyModelResponse>;
        }));
    }

    protected processSuppliesGET2(response: HttpResponseBase): Observable<SupplyModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCarAndDate(body: UpdateSupplyCarAndDateCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplies/UpdateCarAndDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCarAndDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCarAndDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCarAndDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    withOrderDates(id: string): Observable<SupplyWithOrderDatesModelResponse> {
        let url_ = this.baseUrl + "/api/Supplies/WithOrderDates/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithOrderDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithOrderDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyWithOrderDatesModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyWithOrderDatesModelResponse>;
        }));
    }

    protected processWithOrderDates(response: HttpResponseBase): Observable<SupplyWithOrderDatesModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyWithOrderDatesModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyWithOrderDatesModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable15(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<SupplyModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Supplies/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable15(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable15(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyModelPaginationResultResponse>;
        }));
    }

    protected processPageable15(response: HttpResponseBase): Observable<SupplyModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyModelPaginationResultResponse>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param employeeId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return Success
     */
    fordriver(pageNumber: number | undefined, pageSize: number | undefined, employeeId: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined): Observable<SupplyForDriverModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Supplies/fordriver?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFordriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFordriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyForDriverModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyForDriverModelIEnumerableResponse>;
        }));
    }

    protected processFordriver(response: HttpResponseBase): Observable<SupplyForDriverModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyForDriverModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyForDriverModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    fordriver2(id: string): Observable<SupplyForDriverModelResponse> {
        let url_ = this.baseUrl + "/api/Supplies/{Id}/fordriver";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFordriver2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFordriver2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyForDriverModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyForDriverModelResponse>;
        }));
    }

    protected processFordriver2(response: HttpResponseBase): Observable<SupplyForDriverModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyForDriverModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyForDriverModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    supplyStatus(id: string, supplyStatusId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplies/{Id}/supply-status/{SupplyStatusId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (supplyStatusId === undefined || supplyStatusId === null)
            throw new Error("The parameter 'supplyStatusId' must be defined.");
        url_ = url_.replace("{SupplyStatusId}", encodeURIComponent("" + supplyStatusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplyStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplyStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupplyStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRemainingCount(id: string): Observable<DecimalResponse> {
        let url_ = this.baseUrl + "/api/Supplies/{Id}/GetRemainingCount";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemainingCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemainingCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalResponse>;
        }));
    }

    protected processGetRemainingCount(response: HttpResponseBase): Observable<DecimalResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DecimalResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    supplyStatusesPOST(body: AddSupplyStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SupplyStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplyStatusesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplyStatusesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupplyStatusesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    supplyStatusesPUT(body: UpdateSupplyStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SupplyStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplyStatusesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplyStatusesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupplyStatusesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    supplyStatusesGET(): Observable<SupplyStatusModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/SupplyStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplyStatusesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplyStatusesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyStatusModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyStatusModelIEnumerableResponse>;
        }));
    }

    protected processSupplyStatusesGET(response: HttpResponseBase): Observable<SupplyStatusModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyStatusModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyStatusModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    supplyStatusesDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SupplyStatuses/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplyStatusesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplyStatusesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupplyStatusesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    supplyStatusesGET2(id: string): Observable<SupplyStatusModelResponse> {
        let url_ = this.baseUrl + "/api/SupplyStatuses/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplyStatusesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplyStatusesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyStatusModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyStatusModelResponse>;
        }));
    }

    protected processSupplyStatusesGET2(response: HttpResponseBase): Observable<SupplyStatusModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyStatusModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyStatusModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable16(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<SupplyStatusModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/SupplyStatuses/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable16(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable16(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplyStatusModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplyStatusModelPaginationResultResponse>;
        }));
    }

    protected processPageable16(response: HttpResponseBase): Observable<SupplyStatusModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplyStatusModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplyStatusModelPaginationResultResponse>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getSupplyStatusesForSelect(query: GetSupplyStatusesForSelectQuery | undefined): Observable<SelectModelListResponse> {
        let url_ = this.baseUrl + "/api/SupplyStatuses/getSupplyStatusesForSelect?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyStatusesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyStatusesForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectModelListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectModelListResponse>;
        }));
    }

    protected processGetSupplyStatusesForSelect(response: HttpResponseBase): Observable<SelectModelListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectModelListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModelListResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param attachmentId (optional) 
     * @return Success
     */
    sendCsvFile(file: FileParameter[] | null | undefined, attachmentId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Transaction/sendCsvFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            file.forEach(item_ => content_.append("File", item_.data, item_.fileName ? item_.fileName : "File") );
        if (attachmentId === null || attachmentId === undefined)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else
            content_.append("AttachmentId", attachmentId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCsvFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCsvFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendCsvFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param orderBy (optional) 
     * @param desc (optional) 
     * @return Success
     */
    transaction(pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, orderBy: string | null | undefined, desc: boolean | undefined): Observable<TransactionBaseModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/Transaction?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionBaseModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionBaseModelPaginationResultResponse>;
        }));
    }

    protected processTransaction(response: HttpResponseBase): Observable<TransactionBaseModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionBaseModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionBaseModelPaginationResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    weightsPOST(body: AddWeightCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Weights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWeightsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWeightsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWeightsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    weightsPUT(body: UpdateWeightCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Weights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWeightsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWeightsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWeightsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    weightsGET(): Observable<WeightModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/Weights";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWeightsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWeightsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightModelIEnumerableResponse>;
        }));
    }

    protected processWeightsGET(response: HttpResponseBase): Observable<WeightModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeightModelIEnumerableResponse>(null as any);
    }

    /**
     * @return Success
     */
    weightsDELETE(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Weights/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWeightsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWeightsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWeightsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    wZ(supplyId: string): Observable<OrderSupplyModelResponse> {
        let url_ = this.baseUrl + "/api/WZ/{SupplyId}";
        if (supplyId === undefined || supplyId === null)
            throw new Error("The parameter 'supplyId' must be defined.");
        url_ = url_.replace("{SupplyId}", encodeURIComponent("" + supplyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWZ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWZ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderSupplyModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderSupplyModelResponse>;
        }));
    }

    protected processWZ(response: HttpResponseBase): Observable<OrderSupplyModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderSupplyModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderSupplyModelResponse>(null as any);
    }

    /**
     * @param desc (optional) 
     * @param orderBy (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    pageable17(desc: boolean | undefined, orderBy: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<WZDocumentsModelPaginationResultResponse> {
        let url_ = this.baseUrl + "/api/WZ/pageable?";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPageable17(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageable17(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WZDocumentsModelPaginationResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WZDocumentsModelPaginationResultResponse>;
        }));
    }

    protected processPageable17(response: HttpResponseBase): Observable<WZDocumentsModelPaginationResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WZDocumentsModelPaginationResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WZDocumentsModelPaginationResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    download2(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/WZ/{Id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownload2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    print(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/WZ/{Id}/print";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getWzDocumentsByCustomer(customerId: string): Observable<WZDocumentsModelIEnumerableResponse> {
        let url_ = this.baseUrl + "/api/WZ/getWzDocumentsByCustomer/{CustomerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{CustomerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWzDocumentsByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWzDocumentsByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WZDocumentsModelIEnumerableResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WZDocumentsModelIEnumerableResponse>;
        }));
    }

    protected processGetWzDocumentsByCustomer(response: HttpResponseBase): Observable<WZDocumentsModelIEnumerableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WZDocumentsModelIEnumerableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WZDocumentsModelIEnumerableResponse>(null as any);
    }
}

@Injectable()
export class UpdateApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    employee(body: UpdateEmployeeIdCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Cars/update_employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MerchantApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    limit(body: UpdateMerchantLimitCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer/update_merchant_limit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLimit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AddAddressCommand implements IAddAddressCommand {
    id?: string;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;

    constructor(data?: IAddAddressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.managerName = _data["managerName"];
            this.isMainAddress = _data["isMainAddress"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): AddAddressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddAddressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        data["managerName"] = this.managerName;
        data["isMainAddress"] = this.isMainAddress;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IAddAddressCommand {
    id?: string;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;
}

export class UpdateAddressCommand implements IUpdateAddressCommand {
    id?: string;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;

    constructor(data?: IUpdateAddressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.managerName = _data["managerName"];
            this.isMainAddress = _data["isMainAddress"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): UpdateAddressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        data["managerName"] = this.managerName;
        data["isMainAddress"] = this.isMainAddress;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IUpdateAddressCommand {
    id?: string;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;
}

export class CustomerModel implements ICustomerModel {
    id?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    email?: string | undefined;
    isBlackListed?: boolean;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.pesel = _data["pesel"];
            this.companyShortName = _data["companyShortName"];
            this.companyFullName = _data["companyFullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.nip = _data["nip"];
            this.email = _data["email"];
            this.isBlackListed = _data["isBlackListed"];
            this.isCompany = _data["isCompany"];
            this.isIndividual = _data["isIndividual"];
            this.merchantLimit = _data["merchantLimit"];
            this.bricklayer = _data["bricklayer"];
            this.uniqueAbbreviation = _data["uniqueAbbreviation"];
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["pesel"] = this.pesel;
        data["companyShortName"] = this.companyShortName;
        data["companyFullName"] = this.companyFullName;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["nip"] = this.nip;
        data["email"] = this.email;
        data["isBlackListed"] = this.isBlackListed;
        data["isCompany"] = this.isCompany;
        data["isIndividual"] = this.isIndividual;
        data["merchantLimit"] = this.merchantLimit;
        data["bricklayer"] = this.bricklayer;
        data["uniqueAbbreviation"] = this.uniqueAbbreviation;
        return data;
    }
}

export interface ICustomerModel {
    id?: string;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    email?: string | undefined;
    isBlackListed?: boolean;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;
}

export class AddressModel implements IAddressModel {
    id?: string;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;
    customer?: CustomerModel;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.managerName = _data["managerName"];
            this.isMainAddress = _data["isMainAddress"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        data["managerName"] = this.managerName;
        data["isMainAddress"] = this.isMainAddress;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddressModel {
    id?: string;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;
    customer?: CustomerModel;
}

export class AddressModelResponse implements IAddressModelResponse {
    result?: AddressModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IAddressModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? AddressModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): AddressModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IAddressModelResponse {
    result?: AddressModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddressModelPaginationResult implements IAddressModelPaginationResult {
    readonly result?: AddressModel[] | undefined;
    total?: number;

    constructor(data?: IAddressModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(AddressModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AddressModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IAddressModelPaginationResult {
    result?: AddressModel[] | undefined;
    total?: number;
}

export class AddressModelPaginationResultResponse implements IAddressModelPaginationResultResponse {
    result?: AddressModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IAddressModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? AddressModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): AddressModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IAddressModelPaginationResultResponse {
    result?: AddressModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SelectModel implements ISelectModel {
    id?: string;
    label?: string | undefined;

    constructor(data?: ISelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface ISelectModel {
    id?: string;
    label?: string | undefined;
}

export class SelectModelListResponse implements ISelectModelListResponse {
    readonly result?: SelectModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISelectModelListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SelectModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SelectModelListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SelectModelListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISelectModelListResponse {
    result?: SelectModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddCarCommand implements IAddCarCommand {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    carNodes?: string[] | undefined;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;

    constructor(data?: IAddCarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.registrationNumber = _data["registrationNumber"];
            this.pricePerKilometer = _data["pricePerKilometer"];
            this.nodeId = _data["nodeId"];
            this.nodeName = _data["nodeName"];
            this.volume = _data["volume"];
            this.maxVolume = _data["maxVolume"];
            this.volumeTon = _data["volumeTon"];
            this.maxVolumeTon = _data["maxVolumeTon"];
            if (Array.isArray(_data["carNodes"])) {
                this.carNodes = [] as any;
                for (let item of _data["carNodes"])
                    this.carNodes!.push(item);
            }
            this.mainNodeId = _data["mainNodeId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): AddCarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["registrationNumber"] = this.registrationNumber;
        data["pricePerKilometer"] = this.pricePerKilometer;
        data["nodeId"] = this.nodeId;
        data["nodeName"] = this.nodeName;
        data["volume"] = this.volume;
        data["maxVolume"] = this.maxVolume;
        data["volumeTon"] = this.volumeTon;
        data["maxVolumeTon"] = this.maxVolumeTon;
        if (Array.isArray(this.carNodes)) {
            data["carNodes"] = [];
            for (let item of this.carNodes)
                data["carNodes"].push(item);
        }
        data["mainNodeId"] = this.mainNodeId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        return data;
    }
}

export interface IAddCarCommand {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    carNodes?: string[] | undefined;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
}

export class UpdateCarCommand implements IUpdateCarCommand {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    carNodes?: string[] | undefined;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;

    constructor(data?: IUpdateCarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.registrationNumber = _data["registrationNumber"];
            this.pricePerKilometer = _data["pricePerKilometer"];
            this.nodeId = _data["nodeId"];
            this.nodeName = _data["nodeName"];
            this.volume = _data["volume"];
            this.maxVolume = _data["maxVolume"];
            this.volumeTon = _data["volumeTon"];
            this.maxVolumeTon = _data["maxVolumeTon"];
            if (Array.isArray(_data["carNodes"])) {
                this.carNodes = [] as any;
                for (let item of _data["carNodes"])
                    this.carNodes!.push(item);
            }
            this.mainNodeId = _data["mainNodeId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): UpdateCarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["registrationNumber"] = this.registrationNumber;
        data["pricePerKilometer"] = this.pricePerKilometer;
        data["nodeId"] = this.nodeId;
        data["nodeName"] = this.nodeName;
        data["volume"] = this.volume;
        data["maxVolume"] = this.maxVolume;
        data["volumeTon"] = this.volumeTon;
        data["maxVolumeTon"] = this.maxVolumeTon;
        if (Array.isArray(this.carNodes)) {
            data["carNodes"] = [];
            for (let item of this.carNodes)
                data["carNodes"].push(item);
        }
        data["mainNodeId"] = this.mainNodeId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        return data;
    }
}

export interface IUpdateCarCommand {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    carNodes?: string[] | undefined;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
}

export class CarModel implements ICarModel {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    carNodes?: string[] | undefined;

    constructor(data?: ICarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.registrationNumber = _data["registrationNumber"];
            this.pricePerKilometer = _data["pricePerKilometer"];
            this.nodeId = _data["nodeId"];
            this.nodeName = _data["nodeName"];
            this.volume = _data["volume"];
            this.maxVolume = _data["maxVolume"];
            this.volumeTon = _data["volumeTon"];
            this.maxVolumeTon = _data["maxVolumeTon"];
            this.mainNodeId = _data["mainNodeId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["carNodes"])) {
                this.carNodes = [] as any;
                for (let item of _data["carNodes"])
                    this.carNodes!.push(item);
            }
        }
    }

    static fromJS(data: any): CarModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["registrationNumber"] = this.registrationNumber;
        data["pricePerKilometer"] = this.pricePerKilometer;
        data["nodeId"] = this.nodeId;
        data["nodeName"] = this.nodeName;
        data["volume"] = this.volume;
        data["maxVolume"] = this.maxVolume;
        data["volumeTon"] = this.volumeTon;
        data["maxVolumeTon"] = this.maxVolumeTon;
        data["mainNodeId"] = this.mainNodeId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.carNodes)) {
            data["carNodes"] = [];
            for (let item of this.carNodes)
                data["carNodes"].push(item);
        }
        return data;
    }
}

export interface ICarModel {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    carNodes?: string[] | undefined;
}

export class CarModelIEnumerableResponse implements ICarModelIEnumerableResponse {
    readonly result?: CarModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICarModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(CarModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CarModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICarModelIEnumerableResponse {
    result?: CarModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class CarModelResponse implements ICarModelResponse {
    result?: CarModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICarModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CarModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CarModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICarModelResponse {
    result?: CarModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class UpdateEmployeeIdCommand implements IUpdateEmployeeIdCommand {
    employeeId?: string;
    id?: string;

    constructor(data?: IUpdateEmployeeIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEmployeeIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateEmployeeIdCommand {
    employeeId?: string;
    id?: string;
}

export class CarModelPaginationResult implements ICarModelPaginationResult {
    readonly result?: CarModel[] | undefined;
    total?: number;

    constructor(data?: ICarModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(CarModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CarModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ICarModelPaginationResult {
    result?: CarModel[] | undefined;
    total?: number;
}

export class CarModelPaginationResultResponse implements ICarModelPaginationResultResponse {
    result?: CarModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICarModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CarModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CarModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICarModelPaginationResultResponse {
    result?: CarModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class GetCarTypesForSelectQuery implements IGetCarTypesForSelectQuery {

    constructor(data?: IGetCarTypesForSelectQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCarTypesForSelectQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCarTypesForSelectQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCarTypesForSelectQuery {
}

export class AddCustomerCommand implements IAddCustomerCommand {
    id?: string;
    name?: string | undefined;
    nodeId?: string | undefined;
    firstName?: string | undefined;
    lastname?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    isBlackListed?: boolean;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;

    constructor(data?: IAddCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nodeId = _data["nodeId"];
            this.firstName = _data["firstName"];
            this.lastname = _data["lastname"];
            this.pesel = _data["pesel"];
            this.companyShortName = _data["companyShortName"];
            this.companyFullName = _data["companyFullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.nip = _data["nip"];
            this.isBlackListed = _data["isBlackListed"];
            this.isCompany = _data["isCompany"];
            this.isIndividual = _data["isIndividual"];
            this.merchantLimit = _data["merchantLimit"];
            this.bricklayer = _data["bricklayer"];
            this.uniqueAbbreviation = _data["uniqueAbbreviation"];
        }
    }

    static fromJS(data: any): AddCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nodeId"] = this.nodeId;
        data["firstName"] = this.firstName;
        data["lastname"] = this.lastname;
        data["pesel"] = this.pesel;
        data["companyShortName"] = this.companyShortName;
        data["companyFullName"] = this.companyFullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["nip"] = this.nip;
        data["isBlackListed"] = this.isBlackListed;
        data["isCompany"] = this.isCompany;
        data["isIndividual"] = this.isIndividual;
        data["merchantLimit"] = this.merchantLimit;
        data["bricklayer"] = this.bricklayer;
        data["uniqueAbbreviation"] = this.uniqueAbbreviation;
        return data;
    }
}

export interface IAddCustomerCommand {
    id?: string;
    name?: string | undefined;
    nodeId?: string | undefined;
    firstName?: string | undefined;
    lastname?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    isBlackListed?: boolean;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;
}

export class UpdateCustomerCommand implements IUpdateCustomerCommand {
    id?: string;
    name?: string | undefined;
    nodeId?: string | undefined;
    firstName?: string | undefined;
    lastname?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    isBlackListed?: boolean;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;

    constructor(data?: IUpdateCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nodeId = _data["nodeId"];
            this.firstName = _data["firstName"];
            this.lastname = _data["lastname"];
            this.pesel = _data["pesel"];
            this.companyShortName = _data["companyShortName"];
            this.companyFullName = _data["companyFullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.nip = _data["nip"];
            this.isBlackListed = _data["isBlackListed"];
            this.isCompany = _data["isCompany"];
            this.isIndividual = _data["isIndividual"];
            this.merchantLimit = _data["merchantLimit"];
            this.bricklayer = _data["bricklayer"];
            this.uniqueAbbreviation = _data["uniqueAbbreviation"];
        }
    }

    static fromJS(data: any): UpdateCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nodeId"] = this.nodeId;
        data["firstName"] = this.firstName;
        data["lastname"] = this.lastname;
        data["pesel"] = this.pesel;
        data["companyShortName"] = this.companyShortName;
        data["companyFullName"] = this.companyFullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["nip"] = this.nip;
        data["isBlackListed"] = this.isBlackListed;
        data["isCompany"] = this.isCompany;
        data["isIndividual"] = this.isIndividual;
        data["merchantLimit"] = this.merchantLimit;
        data["bricklayer"] = this.bricklayer;
        data["uniqueAbbreviation"] = this.uniqueAbbreviation;
        return data;
    }
}

export interface IUpdateCustomerCommand {
    id?: string;
    name?: string | undefined;
    nodeId?: string | undefined;
    firstName?: string | undefined;
    lastname?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    isBlackListed?: boolean;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;
}

export class CustomerModelIEnumerableResponse implements ICustomerModelIEnumerableResponse {
    readonly result?: CustomerModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICustomerModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(CustomerModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CustomerModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICustomerModelIEnumerableResponse {
    result?: CustomerModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddCustomerAliasCommand implements IAddCustomerAliasCommand {
    id?: string;
    alias?: string | undefined;
    customerId?: string;

    constructor(data?: IAddCustomerAliasCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): AddCustomerAliasCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerAliasCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IAddCustomerAliasCommand {
    id?: string;
    alias?: string | undefined;
    customerId?: string;
}

export class UpdateMerchantLimitCommand implements IUpdateMerchantLimitCommand {
    id?: string;
    merchantLimit?: number;

    constructor(data?: IUpdateMerchantLimitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantLimit = _data["merchantLimit"];
        }
    }

    static fromJS(data: any): UpdateMerchantLimitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMerchantLimitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantLimit"] = this.merchantLimit;
        return data;
    }
}

export interface IUpdateMerchantLimitCommand {
    id?: string;
    merchantLimit?: number;
}

export class CustomerModelResponse implements ICustomerModelResponse {
    result?: CustomerModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICustomerModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CustomerModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CustomerModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICustomerModelResponse {
    result?: CustomerModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class ContractorExternalViewModel implements IContractorExternalViewModel {
    capital?: number | undefined;
    city?: string | undefined;
    country?: string | undefined;
    disctrictCourtAddress?: string | undefined;
    economicDepartment?: string | undefined;
    email?: string | undefined;
    krs?: string | undefined;
    name?: string | undefined;
    nip?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumber2?: string | undefined;
    postalCode?: string | undefined;
    province?: string | undefined;
    regon?: string | undefined;
    source?: string | undefined;
    street?: string | undefined;
    website?: string | undefined;

    constructor(data?: IContractorExternalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capital = _data["capital"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.disctrictCourtAddress = _data["disctrictCourtAddress"];
            this.economicDepartment = _data["economicDepartment"];
            this.email = _data["email"];
            this.krs = _data["krs"];
            this.name = _data["name"];
            this.nip = _data["nip"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumber2 = _data["phoneNumber2"];
            this.postalCode = _data["postalCode"];
            this.province = _data["province"];
            this.regon = _data["regon"];
            this.source = _data["source"];
            this.street = _data["street"];
            this.website = _data["website"];
        }
    }

    static fromJS(data: any): ContractorExternalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractorExternalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capital"] = this.capital;
        data["city"] = this.city;
        data["country"] = this.country;
        data["disctrictCourtAddress"] = this.disctrictCourtAddress;
        data["economicDepartment"] = this.economicDepartment;
        data["email"] = this.email;
        data["krs"] = this.krs;
        data["name"] = this.name;
        data["nip"] = this.nip;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumber2"] = this.phoneNumber2;
        data["postalCode"] = this.postalCode;
        data["province"] = this.province;
        data["regon"] = this.regon;
        data["source"] = this.source;
        data["street"] = this.street;
        data["website"] = this.website;
        return data;
    }
}

export interface IContractorExternalViewModel {
    capital?: number | undefined;
    city?: string | undefined;
    country?: string | undefined;
    disctrictCourtAddress?: string | undefined;
    economicDepartment?: string | undefined;
    email?: string | undefined;
    krs?: string | undefined;
    name?: string | undefined;
    nip?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumber2?: string | undefined;
    postalCode?: string | undefined;
    province?: string | undefined;
    regon?: string | undefined;
    source?: string | undefined;
    street?: string | undefined;
    website?: string | undefined;
}

export class ContractorExternalViewModelResponse implements IContractorExternalViewModelResponse {
    result?: ContractorExternalViewModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IContractorExternalViewModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ContractorExternalViewModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ContractorExternalViewModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContractorExternalViewModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IContractorExternalViewModelResponse {
    result?: ContractorExternalViewModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class BooleanResponse implements IBooleanResponse {
    readonly result?: boolean;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IBooleanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"];
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): BooleanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IBooleanResponse {
    result?: boolean;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class CustomerModelPaginationResult implements ICustomerModelPaginationResult {
    readonly result?: CustomerModel[] | undefined;
    total?: number;

    constructor(data?: ICustomerModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(CustomerModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CustomerModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ICustomerModelPaginationResult {
    result?: CustomerModel[] | undefined;
    total?: number;
}

export class CustomerModelPaginationResultResponse implements ICustomerModelPaginationResultResponse {
    result?: CustomerModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICustomerModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CustomerModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CustomerModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICustomerModelPaginationResultResponse {
    result?: CustomerModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SearchModel implements ISearchModel {
    id?: string;
    label?: string | undefined;

    constructor(data?: ISearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface ISearchModel {
    id?: string;
    label?: string | undefined;
}

export class SearchModelIEnumerableResponse implements ISearchModelIEnumerableResponse {
    readonly result?: SearchModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISearchModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SearchModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SearchModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISearchModelIEnumerableResponse {
    result?: SearchModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AssignDeliveriesByOrderItemCommand implements IAssignDeliveriesByOrderItemCommand {
    id?: string;

    constructor(data?: IAssignDeliveriesByOrderItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignDeliveriesByOrderItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignDeliveriesByOrderItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAssignDeliveriesByOrderItemCommand {
    id?: string;
}

export class DeliveryItemModel implements IDeliveryItemModel {
    id?: string;
    nodeId: string;
    perUnitPrice?: number;
    unit?: string | undefined;
    count?: number;
    remainingCount?: number;
    itemName?: string | undefined;
    customerName?: string | undefined;
    customerId?: string;
    orderDateFrom?: Date;
    orderDateTo?: Date;
    address?: AddressModel;
    comments?: string | undefined;

    constructor(data?: IDeliveryItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nodeId = _data["nodeId"];
            this.perUnitPrice = _data["perUnitPrice"];
            this.unit = _data["unit"];
            this.count = _data["count"];
            this.remainingCount = _data["remainingCount"];
            this.itemName = _data["itemName"];
            this.customerName = _data["customerName"];
            this.customerId = _data["customerId"];
            this.orderDateFrom = _data["orderDateFrom"] ? new Date(_data["orderDateFrom"].toString()) : <any>undefined;
            this.orderDateTo = _data["orderDateTo"] ? new Date(_data["orderDateTo"].toString()) : <any>undefined;
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DeliveryItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nodeId"] = this.nodeId;
        data["perUnitPrice"] = this.perUnitPrice;
        data["unit"] = this.unit;
        data["count"] = this.count;
        data["remainingCount"] = this.remainingCount;
        data["itemName"] = this.itemName;
        data["customerName"] = this.customerName;
        data["customerId"] = this.customerId;
        data["orderDateFrom"] = this.orderDateFrom ? this.orderDateFrom.toISOString() : <any>undefined;
        data["orderDateTo"] = this.orderDateTo ? this.orderDateTo.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDeliveryItemModel {
    id?: string;
    nodeId: string;
    perUnitPrice?: number;
    unit?: string | undefined;
    count?: number;
    remainingCount?: number;
    itemName?: string | undefined;
    customerName?: string | undefined;
    customerId?: string;
    orderDateFrom?: Date;
    orderDateTo?: Date;
    address?: AddressModel;
    comments?: string | undefined;
}

export class DeliveryItemModelResponse implements IDeliveryItemModelResponse {
    result?: DeliveryItemModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IDeliveryItemModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DeliveryItemModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): DeliveryItemModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryItemModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IDeliveryItemModelResponse {
    result?: DeliveryItemModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class ExistingDeliveryModel implements IExistingDeliveryModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    address?: AddressModel;
    customerId?: string | undefined;
    customerName?: string | undefined;
    supplyStatusId?: string | undefined;
    car?: CarModel;
    orderItemsIds?: string[] | undefined;

    constructor(data?: IExistingDeliveryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.supplyStatusId = _data["supplyStatusId"];
            this.car = _data["car"] ? CarModel.fromJS(_data["car"]) : <any>undefined;
            if (Array.isArray(_data["orderItemsIds"])) {
                this.orderItemsIds = [] as any;
                for (let item of _data["orderItemsIds"])
                    this.orderItemsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExistingDeliveryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExistingDeliveryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["price"] = this.price;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["supplyStatusId"] = this.supplyStatusId;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemsIds)) {
            data["orderItemsIds"] = [];
            for (let item of this.orderItemsIds)
                data["orderItemsIds"].push(item);
        }
        return data;
    }
}

export interface IExistingDeliveryModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    address?: AddressModel;
    customerId?: string | undefined;
    customerName?: string | undefined;
    supplyStatusId?: string | undefined;
    car?: CarModel;
    orderItemsIds?: string[] | undefined;
}

export class ExistingDeliveryModelIEnumerableResponse implements IExistingDeliveryModelIEnumerableResponse {
    readonly result?: ExistingDeliveryModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IExistingDeliveryModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(ExistingDeliveryModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ExistingDeliveryModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExistingDeliveryModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IExistingDeliveryModelIEnumerableResponse {
    result?: ExistingDeliveryModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class DeliveryItemModelPaginationResult implements IDeliveryItemModelPaginationResult {
    readonly result?: DeliveryItemModel[] | undefined;
    total?: number;

    constructor(data?: IDeliveryItemModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(DeliveryItemModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): DeliveryItemModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryItemModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IDeliveryItemModelPaginationResult {
    result?: DeliveryItemModel[] | undefined;
    total?: number;
}

export class DeliveryItemModelPaginationResultResponse implements IDeliveryItemModelPaginationResultResponse {
    result?: DeliveryItemModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IDeliveryItemModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DeliveryItemModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): DeliveryItemModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryItemModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IDeliveryItemModelPaginationResultResponse {
    result?: DeliveryItemModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class DeliveriesAssignedToPumpModel implements IDeliveriesAssignedToPumpModel {
    address?: string | undefined;
    orderNo?: string | undefined;
    id?: string;
    count?: number;
    price?: number;
    dateFrom?: Date;
    dateTo?: Date;
    customerName?: string | undefined;
    car?: CarModel;
    statusColor?: string | undefined;
    payment?: string | undefined;
    items?: string | undefined;

    constructor(data?: IDeliveriesAssignedToPumpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.orderNo = _data["orderNo"];
            this.id = _data["id"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.car = _data["car"] ? CarModel.fromJS(_data["car"]) : <any>undefined;
            this.statusColor = _data["statusColor"];
            this.payment = _data["payment"];
            this.items = _data["items"];
        }
    }

    static fromJS(data: any): DeliveriesAssignedToPumpModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveriesAssignedToPumpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["orderNo"] = this.orderNo;
        data["id"] = this.id;
        data["count"] = this.count;
        data["price"] = this.price;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        data["statusColor"] = this.statusColor;
        data["payment"] = this.payment;
        data["items"] = this.items;
        return data;
    }
}

export interface IDeliveriesAssignedToPumpModel {
    address?: string | undefined;
    orderNo?: string | undefined;
    id?: string;
    count?: number;
    price?: number;
    dateFrom?: Date;
    dateTo?: Date;
    customerName?: string | undefined;
    car?: CarModel;
    statusColor?: string | undefined;
    payment?: string | undefined;
    items?: string | undefined;
}

export class DeliveriesAssignedToPumpModelIEnumerableResponse implements IDeliveriesAssignedToPumpModelIEnumerableResponse {
    readonly result?: DeliveriesAssignedToPumpModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IDeliveriesAssignedToPumpModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(DeliveriesAssignedToPumpModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): DeliveriesAssignedToPumpModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveriesAssignedToPumpModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IDeliveriesAssignedToPumpModelIEnumerableResponse {
    result?: DeliveriesAssignedToPumpModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddIngredientCommand implements IAddIngredientCommand {
    id?: string;
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    nodeId?: string;

    constructor(data?: IAddIngredientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.ingredientTypeId = _data["ingredientTypeId"];
            this.nodeId = _data["nodeId"];
        }
    }

    static fromJS(data: any): AddIngredientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddIngredientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["ingredientTypeId"] = this.ingredientTypeId;
        data["nodeId"] = this.nodeId;
        return data;
    }
}

export interface IAddIngredientCommand {
    id?: string;
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    nodeId?: string;
}

export class UpdateIngredientCommand implements IUpdateIngredientCommand {
    id?: string;
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    nodeId?: string;

    constructor(data?: IUpdateIngredientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.ingredientTypeId = _data["ingredientTypeId"];
            this.nodeId = _data["nodeId"];
        }
    }

    static fromJS(data: any): UpdateIngredientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIngredientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["ingredientTypeId"] = this.ingredientTypeId;
        data["nodeId"] = this.nodeId;
        return data;
    }
}

export interface IUpdateIngredientCommand {
    id?: string;
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    nodeId?: string;
}

export enum IngredientType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class IngredientModel implements IIngredientModel {
    id?: string;
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    ingredientType?: IngredientType;
    ingredientTypeName?: string | undefined;
    nodeId?: string;
    nodeName?: string | undefined;

    constructor(data?: IIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.ingredientTypeId = _data["ingredientTypeId"];
            this.ingredientType = _data["ingredientType"];
            this.ingredientTypeName = _data["ingredientTypeName"];
            this.nodeId = _data["nodeId"];
            this.nodeName = _data["nodeName"];
        }
    }

    static fromJS(data: any): IngredientModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["ingredientTypeId"] = this.ingredientTypeId;
        data["ingredientType"] = this.ingredientType;
        data["ingredientTypeName"] = this.ingredientTypeName;
        data["nodeId"] = this.nodeId;
        data["nodeName"] = this.nodeName;
        return data;
    }
}

export interface IIngredientModel {
    id?: string;
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    ingredientType?: IngredientType;
    ingredientTypeName?: string | undefined;
    nodeId?: string;
    nodeName?: string | undefined;
}

export class IngredientModelResponse implements IIngredientModelResponse {
    result?: IngredientModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IIngredientModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IngredientModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): IngredientModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IIngredientModelResponse {
    result?: IngredientModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class IngredientModelPaginationResult implements IIngredientModelPaginationResult {
    readonly result?: IngredientModel[] | undefined;
    total?: number;

    constructor(data?: IIngredientModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(IngredientModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): IngredientModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IIngredientModelPaginationResult {
    result?: IngredientModel[] | undefined;
    total?: number;
}

export class IngredientModelPaginationResultResponse implements IIngredientModelPaginationResultResponse {
    result?: IngredientModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IIngredientModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IngredientModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): IngredientModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IIngredientModelPaginationResultResponse {
    result?: IngredientModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class IngredientTypeModel implements IIngredientTypeModel {
    id?: string;
    name?: string | undefined;
    type?: IngredientType;
    ingredients?: IngredientModel[] | undefined;

    constructor(data?: IIngredientTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IngredientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IngredientTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIngredientTypeModel {
    id?: string;
    name?: string | undefined;
    type?: IngredientType;
    ingredients?: IngredientModel[] | undefined;
}

export class IngredientTypeModelPaginationResult implements IIngredientTypeModelPaginationResult {
    readonly result?: IngredientTypeModel[] | undefined;
    total?: number;

    constructor(data?: IIngredientTypeModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(IngredientTypeModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): IngredientTypeModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IIngredientTypeModelPaginationResult {
    result?: IngredientTypeModel[] | undefined;
    total?: number;
}

export class IngredientTypeModelPaginationResultResponse implements IIngredientTypeModelPaginationResultResponse {
    result?: IngredientTypeModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IIngredientTypeModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IngredientTypeModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): IngredientTypeModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IIngredientTypeModelPaginationResultResponse {
    result?: IngredientTypeModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class GetAllIngredientTypesQuery implements IGetAllIngredientTypesQuery {

    constructor(data?: IGetAllIngredientTypesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllIngredientTypesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllIngredientTypesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllIngredientTypesQuery {
}

export class IngredientTypeModelIEnumerableResponse implements IIngredientTypeModelIEnumerableResponse {
    readonly result?: IngredientTypeModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IIngredientTypeModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(IngredientTypeModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): IngredientTypeModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IIngredientTypeModelIEnumerableResponse {
    result?: IngredientTypeModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export enum ExternalSystems {
    _0 = 0,
}

export class AddItemCommand implements IAddItemCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    unit?: string | undefined;
    itemTypeId?: string | undefined;
    recipeCostId?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    nodeId?: string | undefined;
    customerId?: string | undefined;
    addressId?: string | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;

    constructor(data?: IAddItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.recipeNumber = _data["recipeNumber"];
            this.unit = _data["unit"];
            this.itemTypeId = _data["itemTypeId"];
            this.recipeCostId = _data["recipeCostId"];
            this.unitPrice = _data["unitPrice"];
            this.isProduct = _data["isProduct"];
            this.isService = _data["isService"];
            this.isWet = _data["isWet"];
            this.nodeId = _data["nodeId"];
            this.customerId = _data["customerId"];
            this.addressId = _data["addressId"];
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
        }
    }

    static fromJS(data: any): AddItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["recipeNumber"] = this.recipeNumber;
        data["unit"] = this.unit;
        data["itemTypeId"] = this.itemTypeId;
        data["recipeCostId"] = this.recipeCostId;
        data["unitPrice"] = this.unitPrice;
        data["isProduct"] = this.isProduct;
        data["isService"] = this.isService;
        data["isWet"] = this.isWet;
        data["nodeId"] = this.nodeId;
        data["customerId"] = this.customerId;
        data["addressId"] = this.addressId;
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        return data;
    }
}

export interface IAddItemCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    unit?: string | undefined;
    itemTypeId?: string | undefined;
    recipeCostId?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    nodeId?: string | undefined;
    customerId?: string | undefined;
    addressId?: string | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
}

export class UpdateItemCommand implements IUpdateItemCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    unit?: string | undefined;
    itemTypeId?: string | undefined;
    recipeCostId?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    nodeId?: string | undefined;
    customerId?: string | undefined;
    addressId?: string | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;

    constructor(data?: IUpdateItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.recipeNumber = _data["recipeNumber"];
            this.unit = _data["unit"];
            this.itemTypeId = _data["itemTypeId"];
            this.recipeCostId = _data["recipeCostId"];
            this.unitPrice = _data["unitPrice"];
            this.isProduct = _data["isProduct"];
            this.isService = _data["isService"];
            this.isWet = _data["isWet"];
            this.nodeId = _data["nodeId"];
            this.customerId = _data["customerId"];
            this.addressId = _data["addressId"];
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
        }
    }

    static fromJS(data: any): UpdateItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["recipeNumber"] = this.recipeNumber;
        data["unit"] = this.unit;
        data["itemTypeId"] = this.itemTypeId;
        data["recipeCostId"] = this.recipeCostId;
        data["unitPrice"] = this.unitPrice;
        data["isProduct"] = this.isProduct;
        data["isService"] = this.isService;
        data["isWet"] = this.isWet;
        data["nodeId"] = this.nodeId;
        data["customerId"] = this.customerId;
        data["addressId"] = this.addressId;
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        return data;
    }
}

export interface IUpdateItemCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    unit?: string | undefined;
    itemTypeId?: string | undefined;
    recipeCostId?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    nodeId?: string | undefined;
    customerId?: string | undefined;
    addressId?: string | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
}

export class ItemModel implements IItemModel {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    productOrService?: string | undefined;
    recipeNumber?: string | undefined;
    itemTypeId?: string | undefined;
    itemTypeName?: string | undefined;
    nodeId?: string | undefined;
    recipeCostId?: string | undefined;
    nodeName?: string | undefined;
    recipeCost?: number | undefined;
    customerId?: string | undefined;
    address?: AddressModel;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    isActive?: boolean;

    constructor(data?: IItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.isProduct = _data["isProduct"];
            this.isService = _data["isService"];
            this.isWet = _data["isWet"];
            this.productOrService = _data["productOrService"];
            this.recipeNumber = _data["recipeNumber"];
            this.itemTypeId = _data["itemTypeId"];
            this.itemTypeName = _data["itemTypeName"];
            this.nodeId = _data["nodeId"];
            this.recipeCostId = _data["recipeCostId"];
            this.nodeName = _data["nodeName"];
            this.recipeCost = _data["recipeCost"];
            this.customerId = _data["customerId"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["isProduct"] = this.isProduct;
        data["isService"] = this.isService;
        data["isWet"] = this.isWet;
        data["productOrService"] = this.productOrService;
        data["recipeNumber"] = this.recipeNumber;
        data["itemTypeId"] = this.itemTypeId;
        data["itemTypeName"] = this.itemTypeName;
        data["nodeId"] = this.nodeId;
        data["recipeCostId"] = this.recipeCostId;
        data["nodeName"] = this.nodeName;
        data["recipeCost"] = this.recipeCost;
        data["customerId"] = this.customerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IItemModel {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    productOrService?: string | undefined;
    recipeNumber?: string | undefined;
    itemTypeId?: string | undefined;
    itemTypeName?: string | undefined;
    nodeId?: string | undefined;
    recipeCostId?: string | undefined;
    nodeName?: string | undefined;
    recipeCost?: number | undefined;
    customerId?: string | undefined;
    address?: AddressModel;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    isActive?: boolean;
}

export class ItemModelIEnumerableResponse implements IItemModelIEnumerableResponse {
    readonly result?: ItemModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IItemModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(ItemModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ItemModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IItemModelIEnumerableResponse {
    result?: ItemModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class ItemModelResponse implements IItemModelResponse {
    result?: ItemModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IItemModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ItemModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ItemModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IItemModelResponse {
    result?: ItemModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class ItemModelPaginationResult implements IItemModelPaginationResult {
    readonly result?: ItemModel[] | undefined;
    total?: number;

    constructor(data?: IItemModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(ItemModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ItemModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IItemModelPaginationResult {
    result?: ItemModel[] | undefined;
    total?: number;
}

export class ItemModelPaginationResultResponse implements IItemModelPaginationResultResponse {
    result?: ItemModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IItemModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ItemModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ItemModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IItemModelPaginationResultResponse {
    result?: ItemModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class GetItemTypesForSelectQuery implements IGetItemTypesForSelectQuery {

    constructor(data?: IGetItemTypesForSelectQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetItemTypesForSelectQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetItemTypesForSelectQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetItemTypesForSelectQuery {
}

export class ItemByNodeModel implements IItemByNodeModel {
    id?: string;
    nodeId?: string | undefined;
    itemId?: string;
    item?: ItemModel;

    constructor(data?: IItemByNodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nodeId = _data["nodeId"];
            this.itemId = _data["itemId"];
            this.item = _data["item"] ? ItemModel.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemByNodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemByNodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nodeId"] = this.nodeId;
        data["itemId"] = this.itemId;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemByNodeModel {
    id?: string;
    nodeId?: string | undefined;
    itemId?: string;
    item?: ItemModel;
}

export class ItemByNodeModelIEnumerableResponse implements IItemByNodeModelIEnumerableResponse {
    readonly result?: ItemByNodeModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IItemByNodeModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(ItemByNodeModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ItemByNodeModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ItemByNodeModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IItemByNodeModelIEnumerableResponse {
    result?: ItemByNodeModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class ItemByCustomerModel implements IItemByCustomerModel {
    item?: ItemModel;

    constructor(data?: IItemByCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? ItemModel.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemByCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemByCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemByCustomerModel {
    item?: ItemModel;
}

export class ItemByCustomerModelIEnumerableResponse implements IItemByCustomerModelIEnumerableResponse {
    readonly result?: ItemByCustomerModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IItemByCustomerModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(ItemByCustomerModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ItemByCustomerModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ItemByCustomerModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IItemByCustomerModelIEnumerableResponse {
    result?: ItemByCustomerModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class MobileVersionModel implements IMobileVersionModel {
    version?: string | undefined;

    constructor(data?: IMobileVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): MobileVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobileVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        return data;
    }
}

export interface IMobileVersionModel {
    version?: string | undefined;
}

export class MobileVersionModelResponse implements IMobileVersionModelResponse {
    result?: MobileVersionModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IMobileVersionModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? MobileVersionModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): MobileVersionModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MobileVersionModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IMobileVersionModelResponse {
    result?: MobileVersionModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export enum NodeType {
    _1 = 1,
    _2 = 2,
}

export class AddNodeCommand implements IAddNodeCommand {
    id?: string;
    name?: string | undefined;
    nodeType?: NodeType;

    constructor(data?: IAddNodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nodeType = _data["nodeType"];
        }
    }

    static fromJS(data: any): AddNodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddNodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nodeType"] = this.nodeType;
        return data;
    }
}

export interface IAddNodeCommand {
    id?: string;
    name?: string | undefined;
    nodeType?: NodeType;
}

export class UpdateNodeCommand implements IUpdateNodeCommand {
    id?: string;
    name?: string | undefined;
    nodeType?: NodeType;

    constructor(data?: IUpdateNodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nodeType = _data["nodeType"];
        }
    }

    static fromJS(data: any): UpdateNodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nodeType"] = this.nodeType;
        return data;
    }
}

export interface IUpdateNodeCommand {
    id?: string;
    name?: string | undefined;
    nodeType?: NodeType;
}

export class NodeModel implements INodeModel {
    id?: string;
    name?: string | undefined;
    nodeType?: NodeType;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;

    constructor(data?: INodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nodeType = _data["nodeType"];
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
        }
    }

    static fromJS(data: any): NodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new NodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nodeType"] = this.nodeType;
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        return data;
    }
}

export interface INodeModel {
    id?: string;
    name?: string | undefined;
    nodeType?: NodeType;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
}

export class NodeModelIEnumerableResponse implements INodeModelIEnumerableResponse {
    readonly result?: NodeModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: INodeModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(NodeModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): NodeModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NodeModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface INodeModelIEnumerableResponse {
    result?: NodeModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class NodeModelResponse implements INodeModelResponse {
    result?: NodeModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: INodeModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? NodeModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): NodeModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NodeModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface INodeModelResponse {
    result?: NodeModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class NodeModelPaginationResult implements INodeModelPaginationResult {
    readonly result?: NodeModel[] | undefined;
    total?: number;

    constructor(data?: INodeModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(NodeModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): NodeModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new NodeModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface INodeModelPaginationResult {
    result?: NodeModel[] | undefined;
    total?: number;
}

export class NodeModelPaginationResultResponse implements INodeModelPaginationResultResponse {
    result?: NodeModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: INodeModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? NodeModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): NodeModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NodeModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface INodeModelPaginationResultResponse {
    result?: NodeModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class GetNodesForSelectQuery implements IGetNodesForSelectQuery {

    constructor(data?: IGetNodesForSelectQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetNodesForSelectQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNodesForSelectQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetNodesForSelectQuery {
}

export enum PaymentType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class OfferItemModel implements IOfferItemModel {
    id?: string;
    concreteClass?: string | undefined;
    consistencyClass?: string | undefined;
    exposureClass?: string | undefined;
    vat?: number;
    gutterPriceNetto?: number | undefined;
    gutterPriceBrutto?: number | undefined;
    pumpPriceNetto?: number | undefined;
    pumpPriceBrutto?: number | undefined;
    additives?: string | undefined;

    constructor(data?: IOfferItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.concreteClass = _data["concreteClass"];
            this.consistencyClass = _data["consistencyClass"];
            this.exposureClass = _data["exposureClass"];
            this.vat = _data["vat"];
            this.gutterPriceNetto = _data["gutterPriceNetto"];
            this.gutterPriceBrutto = _data["gutterPriceBrutto"];
            this.pumpPriceNetto = _data["pumpPriceNetto"];
            this.pumpPriceBrutto = _data["pumpPriceBrutto"];
            this.additives = _data["additives"];
        }
    }

    static fromJS(data: any): OfferItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["concreteClass"] = this.concreteClass;
        data["consistencyClass"] = this.consistencyClass;
        data["exposureClass"] = this.exposureClass;
        data["vat"] = this.vat;
        data["gutterPriceNetto"] = this.gutterPriceNetto;
        data["gutterPriceBrutto"] = this.gutterPriceBrutto;
        data["pumpPriceNetto"] = this.pumpPriceNetto;
        data["pumpPriceBrutto"] = this.pumpPriceBrutto;
        data["additives"] = this.additives;
        return data;
    }
}

export interface IOfferItemModel {
    id?: string;
    concreteClass?: string | undefined;
    consistencyClass?: string | undefined;
    exposureClass?: string | undefined;
    vat?: number;
    gutterPriceNetto?: number | undefined;
    gutterPriceBrutto?: number | undefined;
    pumpPriceNetto?: number | undefined;
    pumpPriceBrutto?: number | undefined;
    additives?: string | undefined;
}

export class CreateOfferCommand implements ICreateOfferCommand {
    id?: string;
    number?: string | undefined;
    date?: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    customerNip?: string | undefined;
    customerPesel?: string | undefined;
    customerContactAddress?: string | undefined;
    customerPhoneNumber1?: string | undefined;
    customerPhoneNumber2?: string | undefined;
    customerSupplyAddress?: string | undefined;
    customerEmail?: string | undefined;
    authorizedPersonName?: string | undefined;
    authorizedPersonPhoneNumber?: string | undefined;
    priceOfferNumber?: string | undefined;
    priceOfferDate?: Date | undefined;
    finalPaymentType?: PaymentType;
    finalPaymentDays?: number | undefined;
    prePaymentType?: PaymentType;
    prePaymentDays?: number | undefined;
    priceSum?: number | undefined;
    supplyFromDate?: Date | undefined;
    supplyToDate?: Date | undefined;
    bankAccountNumber?: string | undefined;
    bankName?: string | undefined;
    purchaserSignature?: string | undefined;
    items?: OfferItemModel[] | undefined;

    constructor(data?: ICreateOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerAddress = _data["customerAddress"];
            this.customerNip = _data["customerNip"];
            this.customerPesel = _data["customerPesel"];
            this.customerContactAddress = _data["customerContactAddress"];
            this.customerPhoneNumber1 = _data["customerPhoneNumber1"];
            this.customerPhoneNumber2 = _data["customerPhoneNumber2"];
            this.customerSupplyAddress = _data["customerSupplyAddress"];
            this.customerEmail = _data["customerEmail"];
            this.authorizedPersonName = _data["authorizedPersonName"];
            this.authorizedPersonPhoneNumber = _data["authorizedPersonPhoneNumber"];
            this.priceOfferNumber = _data["priceOfferNumber"];
            this.priceOfferDate = _data["priceOfferDate"] ? new Date(_data["priceOfferDate"].toString()) : <any>undefined;
            this.finalPaymentType = _data["finalPaymentType"];
            this.finalPaymentDays = _data["finalPaymentDays"];
            this.prePaymentType = _data["prePaymentType"];
            this.prePaymentDays = _data["prePaymentDays"];
            this.priceSum = _data["priceSum"];
            this.supplyFromDate = _data["supplyFromDate"] ? new Date(_data["supplyFromDate"].toString()) : <any>undefined;
            this.supplyToDate = _data["supplyToDate"] ? new Date(_data["supplyToDate"].toString()) : <any>undefined;
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankName = _data["bankName"];
            this.purchaserSignature = _data["purchaserSignature"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OfferItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerAddress"] = this.customerAddress;
        data["customerNip"] = this.customerNip;
        data["customerPesel"] = this.customerPesel;
        data["customerContactAddress"] = this.customerContactAddress;
        data["customerPhoneNumber1"] = this.customerPhoneNumber1;
        data["customerPhoneNumber2"] = this.customerPhoneNumber2;
        data["customerSupplyAddress"] = this.customerSupplyAddress;
        data["customerEmail"] = this.customerEmail;
        data["authorizedPersonName"] = this.authorizedPersonName;
        data["authorizedPersonPhoneNumber"] = this.authorizedPersonPhoneNumber;
        data["priceOfferNumber"] = this.priceOfferNumber;
        data["priceOfferDate"] = this.priceOfferDate ? this.priceOfferDate.toISOString() : <any>undefined;
        data["finalPaymentType"] = this.finalPaymentType;
        data["finalPaymentDays"] = this.finalPaymentDays;
        data["prePaymentType"] = this.prePaymentType;
        data["prePaymentDays"] = this.prePaymentDays;
        data["priceSum"] = this.priceSum;
        data["supplyFromDate"] = this.supplyFromDate ? this.supplyFromDate.toISOString() : <any>undefined;
        data["supplyToDate"] = this.supplyToDate ? this.supplyToDate.toISOString() : <any>undefined;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankName"] = this.bankName;
        data["purchaserSignature"] = this.purchaserSignature;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOfferCommand {
    id?: string;
    number?: string | undefined;
    date?: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    customerNip?: string | undefined;
    customerPesel?: string | undefined;
    customerContactAddress?: string | undefined;
    customerPhoneNumber1?: string | undefined;
    customerPhoneNumber2?: string | undefined;
    customerSupplyAddress?: string | undefined;
    customerEmail?: string | undefined;
    authorizedPersonName?: string | undefined;
    authorizedPersonPhoneNumber?: string | undefined;
    priceOfferNumber?: string | undefined;
    priceOfferDate?: Date | undefined;
    finalPaymentType?: PaymentType;
    finalPaymentDays?: number | undefined;
    prePaymentType?: PaymentType;
    prePaymentDays?: number | undefined;
    priceSum?: number | undefined;
    supplyFromDate?: Date | undefined;
    supplyToDate?: Date | undefined;
    bankAccountNumber?: string | undefined;
    bankName?: string | undefined;
    purchaserSignature?: string | undefined;
    items?: OfferItemModel[] | undefined;
}

export class UpdateOfferCommand implements IUpdateOfferCommand {
    id?: string;
    number?: string | undefined;
    date?: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    customerNip?: string | undefined;
    customerPesel?: string | undefined;
    customerContactAddress?: string | undefined;
    customerPhoneNumber1?: string | undefined;
    customerPhoneNumber2?: string | undefined;
    customerSupplyAddress?: string | undefined;
    customerEmail?: string | undefined;
    authorizedPersonName?: string | undefined;
    authorizedPersonPhoneNumber?: string | undefined;
    priceOfferNumber?: string | undefined;
    priceOfferDate?: Date | undefined;
    finalPaymentType?: PaymentType;
    finalPaymentDays?: number | undefined;
    prePaymentType?: PaymentType;
    prePaymentDays?: number | undefined;
    priceSum?: number | undefined;
    supplyFromDate?: Date | undefined;
    supplyToDate?: Date | undefined;
    bankAccountNumber?: string | undefined;
    bankName?: string | undefined;
    purchaserSignature?: string | undefined;
    items?: OfferItemModel[] | undefined;

    constructor(data?: IUpdateOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerAddress = _data["customerAddress"];
            this.customerNip = _data["customerNip"];
            this.customerPesel = _data["customerPesel"];
            this.customerContactAddress = _data["customerContactAddress"];
            this.customerPhoneNumber1 = _data["customerPhoneNumber1"];
            this.customerPhoneNumber2 = _data["customerPhoneNumber2"];
            this.customerSupplyAddress = _data["customerSupplyAddress"];
            this.customerEmail = _data["customerEmail"];
            this.authorizedPersonName = _data["authorizedPersonName"];
            this.authorizedPersonPhoneNumber = _data["authorizedPersonPhoneNumber"];
            this.priceOfferNumber = _data["priceOfferNumber"];
            this.priceOfferDate = _data["priceOfferDate"] ? new Date(_data["priceOfferDate"].toString()) : <any>undefined;
            this.finalPaymentType = _data["finalPaymentType"];
            this.finalPaymentDays = _data["finalPaymentDays"];
            this.prePaymentType = _data["prePaymentType"];
            this.prePaymentDays = _data["prePaymentDays"];
            this.priceSum = _data["priceSum"];
            this.supplyFromDate = _data["supplyFromDate"] ? new Date(_data["supplyFromDate"].toString()) : <any>undefined;
            this.supplyToDate = _data["supplyToDate"] ? new Date(_data["supplyToDate"].toString()) : <any>undefined;
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankName = _data["bankName"];
            this.purchaserSignature = _data["purchaserSignature"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OfferItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerAddress"] = this.customerAddress;
        data["customerNip"] = this.customerNip;
        data["customerPesel"] = this.customerPesel;
        data["customerContactAddress"] = this.customerContactAddress;
        data["customerPhoneNumber1"] = this.customerPhoneNumber1;
        data["customerPhoneNumber2"] = this.customerPhoneNumber2;
        data["customerSupplyAddress"] = this.customerSupplyAddress;
        data["customerEmail"] = this.customerEmail;
        data["authorizedPersonName"] = this.authorizedPersonName;
        data["authorizedPersonPhoneNumber"] = this.authorizedPersonPhoneNumber;
        data["priceOfferNumber"] = this.priceOfferNumber;
        data["priceOfferDate"] = this.priceOfferDate ? this.priceOfferDate.toISOString() : <any>undefined;
        data["finalPaymentType"] = this.finalPaymentType;
        data["finalPaymentDays"] = this.finalPaymentDays;
        data["prePaymentType"] = this.prePaymentType;
        data["prePaymentDays"] = this.prePaymentDays;
        data["priceSum"] = this.priceSum;
        data["supplyFromDate"] = this.supplyFromDate ? this.supplyFromDate.toISOString() : <any>undefined;
        data["supplyToDate"] = this.supplyToDate ? this.supplyToDate.toISOString() : <any>undefined;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankName"] = this.bankName;
        data["purchaserSignature"] = this.purchaserSignature;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateOfferCommand {
    id?: string;
    number?: string | undefined;
    date?: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    customerNip?: string | undefined;
    customerPesel?: string | undefined;
    customerContactAddress?: string | undefined;
    customerPhoneNumber1?: string | undefined;
    customerPhoneNumber2?: string | undefined;
    customerSupplyAddress?: string | undefined;
    customerEmail?: string | undefined;
    authorizedPersonName?: string | undefined;
    authorizedPersonPhoneNumber?: string | undefined;
    priceOfferNumber?: string | undefined;
    priceOfferDate?: Date | undefined;
    finalPaymentType?: PaymentType;
    finalPaymentDays?: number | undefined;
    prePaymentType?: PaymentType;
    prePaymentDays?: number | undefined;
    priceSum?: number | undefined;
    supplyFromDate?: Date | undefined;
    supplyToDate?: Date | undefined;
    bankAccountNumber?: string | undefined;
    bankName?: string | undefined;
    purchaserSignature?: string | undefined;
    items?: OfferItemModel[] | undefined;
}

export class OfferModel implements IOfferModel {
    id?: string;
    number?: string | undefined;
    date?: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    customerNip?: string | undefined;
    customerPesel?: string | undefined;
    customerContactAddress?: string | undefined;
    customerPhoneNumber1?: string | undefined;
    customerPhoneNumber2?: string | undefined;
    customerSupplyAddress?: string | undefined;
    customerEmail?: string | undefined;
    authorizedPersonName?: string | undefined;
    authorizedPersonPhoneNumber?: string | undefined;
    priceOfferNumber?: string | undefined;
    priceOfferDate?: Date | undefined;
    finalPaymentType?: PaymentType;
    finalPaymentDays?: number | undefined;
    prePaymentType?: PaymentType;
    prePaymentDays?: number | undefined;
    priceSum?: number | undefined;
    supplyFromDate?: Date | undefined;
    supplyToDate?: Date | undefined;
    bankAccountNumber?: string | undefined;
    bankName?: string | undefined;
    purchaserSignature?: string | undefined;
    createUserId?: string | undefined;
    items?: OfferItemModel[] | undefined;
   
    constructor(data?: IOfferModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerAddress = _data["customerAddress"];
            this.customerNip = _data["customerNip"];
            this.customerPesel = _data["customerPesel"];
            this.customerContactAddress = _data["customerContactAddress"];
            this.customerPhoneNumber1 = _data["customerPhoneNumber1"];
            this.customerPhoneNumber2 = _data["customerPhoneNumber2"];
            this.customerSupplyAddress = _data["customerSupplyAddress"];
            this.customerEmail = _data["customerEmail"];
            this.authorizedPersonName = _data["authorizedPersonName"];
            this.authorizedPersonPhoneNumber = _data["authorizedPersonPhoneNumber"];
            this.priceOfferNumber = _data["priceOfferNumber"];
            this.priceOfferDate = _data["priceOfferDate"] ? new Date(_data["priceOfferDate"].toString()) : <any>undefined;
            this.finalPaymentType = _data["finalPaymentType"];
            this.finalPaymentDays = _data["finalPaymentDays"];
            this.prePaymentType = _data["prePaymentType"];
            this.prePaymentDays = _data["prePaymentDays"];
            this.priceSum = _data["priceSum"];
            this.supplyFromDate = _data["supplyFromDate"] ? new Date(_data["supplyFromDate"].toString()) : <any>undefined;
            this.supplyToDate = _data["supplyToDate"] ? new Date(_data["supplyToDate"].toString()) : <any>undefined;
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankName = _data["bankName"];
            this.purchaserSignature = _data["purchaserSignature"];
            this.createUserId = _data["createUserId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OfferItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfferModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerAddress"] = this.customerAddress;
        data["customerNip"] = this.customerNip;
        data["customerPesel"] = this.customerPesel;
        data["customerContactAddress"] = this.customerContactAddress;
        data["customerPhoneNumber1"] = this.customerPhoneNumber1;
        data["customerPhoneNumber2"] = this.customerPhoneNumber2;
        data["customerSupplyAddress"] = this.customerSupplyAddress;
        data["customerEmail"] = this.customerEmail;
        data["authorizedPersonName"] = this.authorizedPersonName;
        data["authorizedPersonPhoneNumber"] = this.authorizedPersonPhoneNumber;
        data["priceOfferNumber"] = this.priceOfferNumber;
        data["priceOfferDate"] = this.priceOfferDate ? this.priceOfferDate.toISOString() : <any>undefined;
        data["finalPaymentType"] = this.finalPaymentType;
        data["finalPaymentDays"] = this.finalPaymentDays;
        data["prePaymentType"] = this.prePaymentType;
        data["prePaymentDays"] = this.prePaymentDays;
        data["priceSum"] = this.priceSum;
        data["supplyFromDate"] = this.supplyFromDate ? this.supplyFromDate.toISOString() : <any>undefined;
        data["supplyToDate"] = this.supplyToDate ? this.supplyToDate.toISOString() : <any>undefined;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankName"] = this.bankName;
        data["purchaserSignature"] = this.purchaserSignature;
        data["createUserId"] = this.createUserId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfferModel {
    id?: string;
    number?: string | undefined;
    date?: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    customerNip?: string | undefined;
    customerPesel?: string | undefined;
    customerContactAddress?: string | undefined;
    customerPhoneNumber1?: string | undefined;
    customerPhoneNumber2?: string | undefined;
    customerSupplyAddress?: string | undefined;
    customerEmail?: string | undefined;
    authorizedPersonName?: string | undefined;
    authorizedPersonPhoneNumber?: string | undefined;
    priceOfferNumber?: string | undefined;
    priceOfferDate?: Date | undefined;
    finalPaymentType?: PaymentType;
    finalPaymentDays?: number | undefined;
    prePaymentType?: PaymentType;
    prePaymentDays?: number | undefined;
    priceSum?: number | undefined;
    supplyFromDate?: Date | undefined;
    supplyToDate?: Date | undefined;
    bankAccountNumber?: string | undefined;
    bankName?: string | undefined;
    purchaserSignature?: string | undefined;
    createUserId?: string | undefined;
    items?: OfferItemModel[] | undefined;
}

export class OfferModelResponse implements IOfferModelResponse {
    result?: OfferModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOfferModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OfferModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OfferModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OfferModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOfferModelResponse {
    result?: OfferModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OfferModelPaginationResult implements IOfferModelPaginationResult {
    readonly result?: OfferModel[] | undefined;
    total?: number;

    constructor(data?: IOfferModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OfferModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): OfferModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OfferModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IOfferModelPaginationResult {
    result?: OfferModel[] | undefined;
    total?: number;
}

export class OfferModelPaginationResultResponse implements IOfferModelPaginationResultResponse {
    result?: OfferModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOfferModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OfferModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OfferModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OfferModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOfferModelPaginationResultResponse {
    result?: OfferModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class StringResponse implements IStringResponse {
    readonly result?: string | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IStringResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"];
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): StringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StringResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IStringResponse {
    result?: string | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SendOfferPdfByMailCommand implements ISendOfferPdfByMailCommand {
    id?: string;

    constructor(data?: ISendOfferPdfByMailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SendOfferPdfByMailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendOfferPdfByMailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISendOfferPdfByMailCommand {
    id?: string;
}

export class CreateOrderExecutionQueueItemCommand implements ICreateOrderExecutionQueueItemCommand {
    id?: string;
    nodeId?: string;
    date?: Date;
    orderId?: string;
    supplyId?: string | undefined;
    nextOrderExecutionQueueItemId?: string | undefined;
    prevOrderExecutionQueueItemId?: string | undefined;

    constructor(data?: ICreateOrderExecutionQueueItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nodeId = _data["nodeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            this.supplyId = _data["supplyId"];
            this.nextOrderExecutionQueueItemId = _data["nextOrderExecutionQueueItemId"];
            this.prevOrderExecutionQueueItemId = _data["prevOrderExecutionQueueItemId"];
        }
    }

    static fromJS(data: any): CreateOrderExecutionQueueItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderExecutionQueueItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nodeId"] = this.nodeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["supplyId"] = this.supplyId;
        data["nextOrderExecutionQueueItemId"] = this.nextOrderExecutionQueueItemId;
        data["prevOrderExecutionQueueItemId"] = this.prevOrderExecutionQueueItemId;
        return data;
    }
}

export interface ICreateOrderExecutionQueueItemCommand {
    id?: string;
    nodeId?: string;
    date?: Date;
    orderId?: string;
    supplyId?: string | undefined;
    nextOrderExecutionQueueItemId?: string | undefined;
    prevOrderExecutionQueueItemId?: string | undefined;
}

export class UpdateOrderExecutionQueueItemCommand implements IUpdateOrderExecutionQueueItemCommand {
    id?: string;
    nodeId?: string;
    date?: Date;
    orderId?: string;
    supplyId?: string | undefined;
    nextOrderExecutionQueueItemId?: string | undefined;
    prevOrderExecutionQueueItemId?: string | undefined;

    constructor(data?: IUpdateOrderExecutionQueueItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nodeId = _data["nodeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            this.supplyId = _data["supplyId"];
            this.nextOrderExecutionQueueItemId = _data["nextOrderExecutionQueueItemId"];
            this.prevOrderExecutionQueueItemId = _data["prevOrderExecutionQueueItemId"];
        }
    }

    static fromJS(data: any): UpdateOrderExecutionQueueItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderExecutionQueueItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nodeId"] = this.nodeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["supplyId"] = this.supplyId;
        data["nextOrderExecutionQueueItemId"] = this.nextOrderExecutionQueueItemId;
        data["prevOrderExecutionQueueItemId"] = this.prevOrderExecutionQueueItemId;
        return data;
    }
}

export interface IUpdateOrderExecutionQueueItemCommand {
    id?: string;
    nodeId?: string;
    date?: Date;
    orderId?: string;
    supplyId?: string | undefined;
    nextOrderExecutionQueueItemId?: string | undefined;
    prevOrderExecutionQueueItemId?: string | undefined;
}

export enum OrderType {
    _1 = 1,
    _2 = 2,
}

export class SupplyStatusEntity implements ISupplyStatusEntity {
    name?: string | undefined;
    idState?: number;
    color?: string | undefined;
    supplies?: SupplyEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ISupplyStatusEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.idState = _data["idState"];
            this.color = _data["color"];
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(SupplyEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): SupplyStatusEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyStatusEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["idState"] = this.idState;
        data["color"] = this.color;
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ISupplyStatusEntity {
    name?: string | undefined;
    idState?: number;
    color?: string | undefined;
    supplies?: SupplyEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class CarTypeEntity implements ICarTypeEntity {
    name?: string | undefined;
    cars?: CarEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ICarTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["cars"])) {
                this.cars = [] as any;
                for (let item of _data["cars"])
                    this.cars!.push(CarEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): CarTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CarTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.cars)) {
            data["cars"] = [];
            for (let item of this.cars)
                data["cars"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ICarTypeEntity {
    name?: string | undefined;
    cars?: CarEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class ItemTypeEntity implements IItemTypeEntity {
    name?: string | undefined;
    items?: ItemEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IItemTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): ItemTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ItemTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IItemTypeEntity {
    name?: string | undefined;
    items?: ItemEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class IngredientTypeEntity implements IIngredientTypeEntity {
    name?: string | undefined;
    type?: IngredientType;
    ingredients?: IngredientEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IIngredientTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IngredientEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): IngredientTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IIngredientTypeEntity {
    name?: string | undefined;
    type?: IngredientType;
    ingredients?: IngredientEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class IngredientEntity implements IIngredientEntity {
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    ingredientType?: IngredientTypeEntity;
    nodeId?: string;
    node?: NodeEntity;
    recipeIngredient?: RecipeIngredientEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IIngredientEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.ingredientTypeId = _data["ingredientTypeId"];
            this.ingredientType = _data["ingredientType"] ? IngredientTypeEntity.fromJS(_data["ingredientType"]) : <any>undefined;
            this.nodeId = _data["nodeId"];
            this.node = _data["node"] ? NodeEntity.fromJS(_data["node"]) : <any>undefined;
            if (Array.isArray(_data["recipeIngredient"])) {
                this.recipeIngredient = [] as any;
                for (let item of _data["recipeIngredient"])
                    this.recipeIngredient!.push(RecipeIngredientEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): IngredientEntity {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["ingredientTypeId"] = this.ingredientTypeId;
        data["ingredientType"] = this.ingredientType ? this.ingredientType.toJSON() : <any>undefined;
        data["nodeId"] = this.nodeId;
        data["node"] = this.node ? this.node.toJSON() : <any>undefined;
        if (Array.isArray(this.recipeIngredient)) {
            data["recipeIngredient"] = [];
            for (let item of this.recipeIngredient)
                data["recipeIngredient"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IIngredientEntity {
    name?: string | undefined;
    value?: number;
    ingredientTypeId?: string;
    ingredientType?: IngredientTypeEntity;
    nodeId?: string;
    node?: NodeEntity;
    recipeIngredient?: RecipeIngredientEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class RecipeIngredientEntity implements IRecipeIngredientEntity {
    recipeCostId?: string;
    recipeCost?: RecipeCostEntity;
    ingredientId?: string;
    ingredient?: IngredientEntity;
    quantity?: number;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IRecipeIngredientEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipeCostId = _data["recipeCostId"];
            this.recipeCost = _data["recipeCost"] ? RecipeCostEntity.fromJS(_data["recipeCost"]) : <any>undefined;
            this.ingredientId = _data["ingredientId"];
            this.ingredient = _data["ingredient"] ? IngredientEntity.fromJS(_data["ingredient"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): RecipeIngredientEntity {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeIngredientEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeCostId"] = this.recipeCostId;
        data["recipeCost"] = this.recipeCost ? this.recipeCost.toJSON() : <any>undefined;
        data["ingredientId"] = this.ingredientId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IRecipeIngredientEntity {
    recipeCostId?: string;
    recipeCost?: RecipeCostEntity;
    ingredientId?: string;
    ingredient?: IngredientEntity;
    quantity?: number;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class RecipeCostEntity implements IRecipeCostEntity {
    recipeNumber?: string | undefined;
    name?: string | undefined;
    cost?: number;
    itemId?: string | undefined;
    item?: ItemEntity;
    recipeIngredient?: RecipeIngredientEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IRecipeCostEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipeNumber = _data["recipeNumber"];
            this.name = _data["name"];
            this.cost = _data["cost"];
            this.itemId = _data["itemId"];
            this.item = _data["item"] ? ItemEntity.fromJS(_data["item"]) : <any>undefined;
            if (Array.isArray(_data["recipeIngredient"])) {
                this.recipeIngredient = [] as any;
                for (let item of _data["recipeIngredient"])
                    this.recipeIngredient!.push(RecipeIngredientEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): RecipeCostEntity {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCostEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeNumber"] = this.recipeNumber;
        data["name"] = this.name;
        data["cost"] = this.cost;
        data["itemId"] = this.itemId;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        if (Array.isArray(this.recipeIngredient)) {
            data["recipeIngredient"] = [];
            for (let item of this.recipeIngredient)
                data["recipeIngredient"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IRecipeCostEntity {
    recipeNumber?: string | undefined;
    name?: string | undefined;
    cost?: number;
    itemId?: string | undefined;
    item?: ItemEntity;
    recipeIngredient?: RecipeIngredientEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class OrderItemSupplyEntity implements IOrderItemSupplyEntity {
    orderItemId?: string;
    supplyId?: string;
    orderItem?: OrderItemEntity;
    supply?: SupplyEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IOrderItemSupplyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderItemId = _data["orderItemId"];
            this.supplyId = _data["supplyId"];
            this.orderItem = _data["orderItem"] ? OrderItemEntity.fromJS(_data["orderItem"]) : <any>undefined;
            this.supply = _data["supply"] ? SupplyEntity.fromJS(_data["supply"]) : <any>undefined;
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): OrderItemSupplyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemSupplyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderItemId"] = this.orderItemId;
        data["supplyId"] = this.supplyId;
        data["orderItem"] = this.orderItem ? this.orderItem.toJSON() : <any>undefined;
        data["supply"] = this.supply ? this.supply.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IOrderItemSupplyEntity {
    orderItemId?: string;
    supplyId?: string;
    orderItem?: OrderItemEntity;
    supply?: SupplyEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class OrderItemEntity implements IOrderItemEntity {
    itemId?: string;
    orderId?: string;
    perUnitPrice?: number;
    count?: number;
    recipe?: string | undefined;
    item?: ItemEntity;
    order?: OrderEntity;
    orderItemSupplies?: OrderItemSupplyEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IOrderItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.orderId = _data["orderId"];
            this.perUnitPrice = _data["perUnitPrice"];
            this.count = _data["count"];
            this.recipe = _data["recipe"];
            this.item = _data["item"] ? ItemEntity.fromJS(_data["item"]) : <any>undefined;
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : <any>undefined;
            if (Array.isArray(_data["orderItemSupplies"])) {
                this.orderItemSupplies = [] as any;
                for (let item of _data["orderItemSupplies"])
                    this.orderItemSupplies!.push(OrderItemSupplyEntity.fromJS(item));
            }
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): OrderItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["orderId"] = this.orderId;
        data["perUnitPrice"] = this.perUnitPrice;
        data["count"] = this.count;
        data["recipe"] = this.recipe;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemSupplies)) {
            data["orderItemSupplies"] = [];
            for (let item of this.orderItemSupplies)
                data["orderItemSupplies"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IOrderItemEntity {
    itemId?: string;
    orderId?: string;
    perUnitPrice?: number;
    count?: number;
    recipe?: string | undefined;
    item?: ItemEntity;
    order?: OrderEntity;
    orderItemSupplies?: OrderItemSupplyEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class ItemEntity implements IItemEntity {
    name?: string | undefined;
    recipeNumber?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    itemTypeId?: string | undefined;
    itemType?: ItemTypeEntity;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    addressId?: string | undefined;
    address?: AddressEntity;
    recipeCostId?: string | undefined;
    recipeCost?: RecipeCostEntity;
    orderItems?: OrderItemEntity[] | undefined;
    itemNodes?: ItemNodeEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.recipeNumber = _data["recipeNumber"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.isProduct = _data["isProduct"];
            this.isService = _data["isService"];
            this.isWet = _data["isWet"];
            this.itemTypeId = _data["itemTypeId"];
            this.itemType = _data["itemType"] ? ItemTypeEntity.fromJS(_data["itemType"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressEntity.fromJS(_data["address"]) : <any>undefined;
            this.recipeCostId = _data["recipeCostId"];
            this.recipeCost = _data["recipeCost"] ? RecipeCostEntity.fromJS(_data["recipeCost"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemEntity.fromJS(item));
            }
            if (Array.isArray(_data["itemNodes"])) {
                this.itemNodes = [] as any;
                for (let item of _data["itemNodes"])
                    this.itemNodes!.push(ItemNodeEntity.fromJS(item));
            }
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): ItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["recipeNumber"] = this.recipeNumber;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["isProduct"] = this.isProduct;
        data["isService"] = this.isService;
        data["isWet"] = this.isWet;
        data["itemTypeId"] = this.itemTypeId;
        data["itemType"] = this.itemType ? this.itemType.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["recipeCostId"] = this.recipeCostId;
        data["recipeCost"] = this.recipeCost ? this.recipeCost.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.itemNodes)) {
            data["itemNodes"] = [];
            for (let item of this.itemNodes)
                data["itemNodes"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IItemEntity {
    name?: string | undefined;
    recipeNumber?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    isProduct?: boolean;
    isService?: boolean;
    isWet?: boolean;
    itemTypeId?: string | undefined;
    itemType?: ItemTypeEntity;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    addressId?: string | undefined;
    address?: AddressEntity;
    recipeCostId?: string | undefined;
    recipeCost?: RecipeCostEntity;
    orderItems?: OrderItemEntity[] | undefined;
    itemNodes?: ItemNodeEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class ItemNodeEntity implements IItemNodeEntity {
    itemId?: string;
    nodeId?: string;
    item?: ItemEntity;
    node?: NodeEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IItemNodeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.nodeId = _data["nodeId"];
            this.item = _data["item"] ? ItemEntity.fromJS(_data["item"]) : <any>undefined;
            this.node = _data["node"] ? NodeEntity.fromJS(_data["node"]) : <any>undefined;
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): ItemNodeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ItemNodeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["nodeId"] = this.nodeId;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["node"] = this.node ? this.node.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IItemNodeEntity {
    itemId?: string;
    nodeId?: string;
    item?: ItemEntity;
    node?: NodeEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class NodeEntity implements INodeEntity {
    name?: string | undefined;
    isWhiteListRequired?: boolean;
    nodeType?: NodeType;
    itemNodes?: ItemNodeEntity[] | undefined;
    nodeCars?: NodeCarEntity[] | undefined;
    cars?: CarEntity[] | undefined;
    ingredients?: IngredientEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: INodeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isWhiteListRequired = _data["isWhiteListRequired"];
            this.nodeType = _data["nodeType"];
            if (Array.isArray(_data["itemNodes"])) {
                this.itemNodes = [] as any;
                for (let item of _data["itemNodes"])
                    this.itemNodes!.push(ItemNodeEntity.fromJS(item));
            }
            if (Array.isArray(_data["nodeCars"])) {
                this.nodeCars = [] as any;
                for (let item of _data["nodeCars"])
                    this.nodeCars!.push(NodeCarEntity.fromJS(item));
            }
            if (Array.isArray(_data["cars"])) {
                this.cars = [] as any;
                for (let item of _data["cars"])
                    this.cars!.push(CarEntity.fromJS(item));
            }
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IngredientEntity.fromJS(item));
            }
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): NodeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new NodeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isWhiteListRequired"] = this.isWhiteListRequired;
        data["nodeType"] = this.nodeType;
        if (Array.isArray(this.itemNodes)) {
            data["itemNodes"] = [];
            for (let item of this.itemNodes)
                data["itemNodes"].push(item.toJSON());
        }
        if (Array.isArray(this.nodeCars)) {
            data["nodeCars"] = [];
            for (let item of this.nodeCars)
                data["nodeCars"].push(item.toJSON());
        }
        if (Array.isArray(this.cars)) {
            data["cars"] = [];
            for (let item of this.cars)
                data["cars"].push(item.toJSON());
        }
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface INodeEntity {
    name?: string | undefined;
    isWhiteListRequired?: boolean;
    nodeType?: NodeType;
    itemNodes?: ItemNodeEntity[] | undefined;
    nodeCars?: NodeCarEntity[] | undefined;
    cars?: CarEntity[] | undefined;
    ingredients?: IngredientEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class NodeCarEntity implements INodeCarEntity {
    carId?: string;
    nodeId?: string;
    car?: CarEntity;
    node?: NodeEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: INodeCarEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carId = _data["carId"];
            this.nodeId = _data["nodeId"];
            this.car = _data["car"] ? CarEntity.fromJS(_data["car"]) : <any>undefined;
            this.node = _data["node"] ? NodeEntity.fromJS(_data["node"]) : <any>undefined;
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): NodeCarEntity {
        data = typeof data === 'object' ? data : {};
        let result = new NodeCarEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carId"] = this.carId;
        data["nodeId"] = this.nodeId;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        data["node"] = this.node ? this.node.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface INodeCarEntity {
    carId?: string;
    nodeId?: string;
    car?: CarEntity;
    node?: NodeEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class CarEntity implements ICarEntity {
    name?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    typeId?: string;
    type?: CarTypeEntity;
    mainNodeId?: string;
    nodeCars?: NodeCarEntity[] | undefined;
    node?: NodeEntity;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ICarEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.registrationNumber = _data["registrationNumber"];
            this.pricePerKilometer = _data["pricePerKilometer"];
            this.volume = _data["volume"];
            this.maxVolume = _data["maxVolume"];
            this.volumeTon = _data["volumeTon"];
            this.maxVolumeTon = _data["maxVolumeTon"];
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? CarTypeEntity.fromJS(_data["type"]) : <any>undefined;
            this.mainNodeId = _data["mainNodeId"];
            if (Array.isArray(_data["nodeCars"])) {
                this.nodeCars = [] as any;
                for (let item of _data["nodeCars"])
                    this.nodeCars!.push(NodeCarEntity.fromJS(item));
            }
            this.node = _data["node"] ? NodeEntity.fromJS(_data["node"]) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): CarEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CarEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["registrationNumber"] = this.registrationNumber;
        data["pricePerKilometer"] = this.pricePerKilometer;
        data["volume"] = this.volume;
        data["maxVolume"] = this.maxVolume;
        data["volumeTon"] = this.volumeTon;
        data["maxVolumeTon"] = this.maxVolumeTon;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["mainNodeId"] = this.mainNodeId;
        if (Array.isArray(this.nodeCars)) {
            data["nodeCars"] = [];
            for (let item of this.nodeCars)
                data["nodeCars"].push(item.toJSON());
        }
        data["node"] = this.node ? this.node.toJSON() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ICarEntity {
    name?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    typeId?: string;
    type?: CarTypeEntity;
    mainNodeId?: string;
    nodeCars?: NodeCarEntity[] | undefined;
    node?: NodeEntity;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class WZStatusEntity implements IWZStatusEntity {
    name?: string | undefined;
    wzDocuments?: WZDocumentsEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IWZStatusEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["wzDocuments"])) {
                this.wzDocuments = [] as any;
                for (let item of _data["wzDocuments"])
                    this.wzDocuments!.push(WZDocumentsEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): WZStatusEntity {
        data = typeof data === 'object' ? data : {};
        let result = new WZStatusEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.wzDocuments)) {
            data["wzDocuments"] = [];
            for (let item of this.wzDocuments)
                data["wzDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IWZStatusEntity {
    name?: string | undefined;
    wzDocuments?: WZDocumentsEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class WZDocumentsEntity implements IWZDocumentsEntity {
    name?: string | undefined;
    number?: number;
    supplyId?: string | undefined;
    orderId?: string | undefined;
    supply?: SupplyEntity;
    order?: OrderEntity;
    wzStatusId?: string;
    wzStatus?: WZStatusEntity;
    count?: number;
    productName?: string | undefined;
    unit?: string | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    fileName?: string | undefined;
    orderItems?: OrderItemEntity[] | undefined;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    invoiced?: boolean;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IWZDocumentsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.supplyId = _data["supplyId"];
            this.orderId = _data["orderId"];
            this.supply = _data["supply"] ? SupplyEntity.fromJS(_data["supply"]) : <any>undefined;
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : <any>undefined;
            this.wzStatusId = _data["wzStatusId"];
            this.wzStatus = _data["wzStatus"] ? WZStatusEntity.fromJS(_data["wzStatus"]) : <any>undefined;
            this.count = _data["count"];
            this.productName = _data["productName"];
            this.unit = _data["unit"];
            this.createUserFirstName = _data["createUserFirstName"];
            this.createUserLastName = _data["createUserLastName"];
            this.lmUserFirstName = _data["lmUserFirstName"];
            this.lmUserLastName = _data["lmUserLastName"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemEntity.fromJS(item));
            }
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.invoiced = _data["invoiced"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): WZDocumentsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new WZDocumentsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["supplyId"] = this.supplyId;
        data["orderId"] = this.orderId;
        data["supply"] = this.supply ? this.supply.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["wzStatusId"] = this.wzStatusId;
        data["wzStatus"] = this.wzStatus ? this.wzStatus.toJSON() : <any>undefined;
        data["count"] = this.count;
        data["productName"] = this.productName;
        data["unit"] = this.unit;
        data["createUserFirstName"] = this.createUserFirstName;
        data["createUserLastName"] = this.createUserLastName;
        data["lmUserFirstName"] = this.lmUserFirstName;
        data["lmUserLastName"] = this.lmUserLastName;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["invoiced"] = this.invoiced;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IWZDocumentsEntity {
    name?: string | undefined;
    number?: number;
    supplyId?: string | undefined;
    orderId?: string | undefined;
    supply?: SupplyEntity;
    order?: OrderEntity;
    wzStatusId?: string;
    wzStatus?: WZStatusEntity;
    count?: number;
    productName?: string | undefined;
    unit?: string | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    fileName?: string | undefined;
    orderItems?: OrderItemEntity[] | undefined;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    invoiced?: boolean;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class SupplyEntity implements ISupplyEntity {
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    address?: AddressEntity;
    employeeId?: string | undefined;
    supplyStatusId?: string | undefined;
    distancePrice?: number | undefined;
    supplyStatus?: SupplyStatusEntity;
    car?: CarEntity;
    orderItemSupplies?: OrderItemSupplyEntity[] | undefined;
    wzDocuments?: WZDocumentsEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ISupplyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.price = _data["price"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressEntity.fromJS(_data["address"]) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.supplyStatusId = _data["supplyStatusId"];
            this.distancePrice = _data["distancePrice"];
            this.supplyStatus = _data["supplyStatus"] ? SupplyStatusEntity.fromJS(_data["supplyStatus"]) : <any>undefined;
            this.car = _data["car"] ? CarEntity.fromJS(_data["car"]) : <any>undefined;
            if (Array.isArray(_data["orderItemSupplies"])) {
                this.orderItemSupplies = [] as any;
                for (let item of _data["orderItemSupplies"])
                    this.orderItemSupplies!.push(OrderItemSupplyEntity.fromJS(item));
            }
            if (Array.isArray(_data["wzDocuments"])) {
                this.wzDocuments = [] as any;
                for (let item of _data["wzDocuments"])
                    this.wzDocuments!.push(WZDocumentsEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): SupplyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["price"] = this.price;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["supplyStatusId"] = this.supplyStatusId;
        data["distancePrice"] = this.distancePrice;
        data["supplyStatus"] = this.supplyStatus ? this.supplyStatus.toJSON() : <any>undefined;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemSupplies)) {
            data["orderItemSupplies"] = [];
            for (let item of this.orderItemSupplies)
                data["orderItemSupplies"].push(item.toJSON());
        }
        if (Array.isArray(this.wzDocuments)) {
            data["wzDocuments"] = [];
            for (let item of this.wzDocuments)
                data["wzDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ISupplyEntity {
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    address?: AddressEntity;
    employeeId?: string | undefined;
    supplyStatusId?: string | undefined;
    distancePrice?: number | undefined;
    supplyStatus?: SupplyStatusEntity;
    car?: CarEntity;
    orderItemSupplies?: OrderItemSupplyEntity[] | undefined;
    wzDocuments?: WZDocumentsEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class AddressEntity implements IAddressEntity {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    supplies?: SupplyEntity[] | undefined;
    orders?: OrderEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IAddressEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.managerName = _data["managerName"];
            this.isMainAddress = _data["isMainAddress"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(SupplyEntity.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): AddressEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AddressEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        data["managerName"] = this.managerName;
        data["isMainAddress"] = this.isMainAddress;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IAddressEntity {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    managerName?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    supplies?: SupplyEntity[] | undefined;
    orders?: OrderEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class CsvFileEntity implements ICsvFileEntity {
    name?: string | undefined;
    generateDate?: Date;
    transactions?: TransactionEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ICsvFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.generateDate = _data["generateDate"] ? new Date(_data["generateDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(TransactionEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): CsvFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CsvFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["generateDate"] = this.generateDate ? this.generateDate.toISOString() : <any>undefined;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ICsvFileEntity {
    name?: string | undefined;
    generateDate?: Date;
    transactions?: TransactionEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class TransactionEntity implements ITransactionEntity {
    postingDate?: Date;
    effectiveDate?: Date;
    clientName!: string;
    paymentTitle?: string | undefined;
    amount?: number;
    csvFileId?: string;
    isServed?: boolean;
    csvFile?: CsvFileEntity;
    currentAmount?: number;
    customer?: CustomerEntity;
    customerId?: string | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ITransactionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.clientName = _data["clientName"];
            this.paymentTitle = _data["paymentTitle"];
            this.amount = _data["amount"];
            this.csvFileId = _data["csvFileId"];
            this.isServed = _data["isServed"];
            this.csvFile = _data["csvFile"] ? CsvFileEntity.fromJS(_data["csvFile"]) : <any>undefined;
            this.currentAmount = _data["currentAmount"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): TransactionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["clientName"] = this.clientName;
        data["paymentTitle"] = this.paymentTitle;
        data["amount"] = this.amount;
        data["csvFileId"] = this.csvFileId;
        data["isServed"] = this.isServed;
        data["csvFile"] = this.csvFile ? this.csvFile.toJSON() : <any>undefined;
        data["currentAmount"] = this.currentAmount;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ITransactionEntity {
    postingDate?: Date;
    effectiveDate?: Date;
    clientName: string;
    paymentTitle?: string | undefined;
    amount?: number;
    csvFileId?: string;
    isServed?: boolean;
    csvFile?: CsvFileEntity;
    currentAmount?: number;
    customer?: CustomerEntity;
    customerId?: string | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class CustomerAliasEntity implements ICustomerAliasEntity {
    alias?: string | undefined;
    customerId?: string;
    customer?: CustomerEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ICustomerAliasEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): CustomerAliasEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAliasEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ICustomerAliasEntity {
    alias?: string | undefined;
    customerId?: string;
    customer?: CustomerEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class CustomerEntity implements ICustomerEntity {
    name?: string | undefined;
    firstName?: string | undefined;
    lastname?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    isBlackListed?: boolean;
    email?: string | undefined;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;
    assignedOrders?: OrderEntity[] | undefined;
    addresses?: AddressEntity[] | undefined;
    items?: ItemEntity[] | undefined;
    transactions?: TransactionEntity[] | undefined;
    customerAliases?: CustomerAliasEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ICustomerEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastname = _data["lastname"];
            this.pesel = _data["pesel"];
            this.companyShortName = _data["companyShortName"];
            this.companyFullName = _data["companyFullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.nip = _data["nip"];
            this.isBlackListed = _data["isBlackListed"];
            this.email = _data["email"];
            this.isCompany = _data["isCompany"];
            this.isIndividual = _data["isIndividual"];
            this.merchantLimit = _data["merchantLimit"];
            this.bricklayer = _data["bricklayer"];
            this.uniqueAbbreviation = _data["uniqueAbbreviation"];
            if (Array.isArray(_data["assignedOrders"])) {
                this.assignedOrders = [] as any;
                for (let item of _data["assignedOrders"])
                    this.assignedOrders!.push(OrderEntity.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressEntity.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemEntity.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(TransactionEntity.fromJS(item));
            }
            if (Array.isArray(_data["customerAliases"])) {
                this.customerAliases = [] as any;
                for (let item of _data["customerAliases"])
                    this.customerAliases!.push(CustomerAliasEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): CustomerEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastname"] = this.lastname;
        data["pesel"] = this.pesel;
        data["companyShortName"] = this.companyShortName;
        data["companyFullName"] = this.companyFullName;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["nip"] = this.nip;
        data["isBlackListed"] = this.isBlackListed;
        data["email"] = this.email;
        data["isCompany"] = this.isCompany;
        data["isIndividual"] = this.isIndividual;
        data["merchantLimit"] = this.merchantLimit;
        data["bricklayer"] = this.bricklayer;
        data["uniqueAbbreviation"] = this.uniqueAbbreviation;
        if (Array.isArray(this.assignedOrders)) {
            data["assignedOrders"] = [];
            for (let item of this.assignedOrders)
                data["assignedOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.customerAliases)) {
            data["customerAliases"] = [];
            for (let item of this.customerAliases)
                data["customerAliases"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ICustomerEntity {
    name?: string | undefined;
    firstName?: string | undefined;
    lastname?: string | undefined;
    pesel?: string | undefined;
    companyShortName?: string | undefined;
    companyFullName?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    nip?: number | undefined;
    isBlackListed?: boolean;
    email?: string | undefined;
    isCompany?: boolean;
    isIndividual?: boolean;
    merchantLimit?: number | undefined;
    bricklayer?: boolean;
    uniqueAbbreviation?: string | undefined;
    assignedOrders?: OrderEntity[] | undefined;
    addresses?: AddressEntity[] | undefined;
    items?: ItemEntity[] | undefined;
    transactions?: TransactionEntity[] | undefined;
    customerAliases?: CustomerAliasEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class WeightEntity implements IWeightEntity {
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    order?: OrderEntity;
    supplyId?: string | undefined;
    supply?: SupplyEntity;
    isInTolerance?: boolean;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IWeightEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationNumber = _data["registrationNumber"];
            this.weight = _data["weight"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : <any>undefined;
            this.supplyId = _data["supplyId"];
            this.supply = _data["supply"] ? SupplyEntity.fromJS(_data["supply"]) : <any>undefined;
            this.isInTolerance = _data["isInTolerance"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): WeightEntity {
        data = typeof data === 'object' ? data : {};
        let result = new WeightEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationNumber"] = this.registrationNumber;
        data["weight"] = this.weight;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["supplyId"] = this.supplyId;
        data["supply"] = this.supply ? this.supply.toJSON() : <any>undefined;
        data["isInTolerance"] = this.isInTolerance;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IWeightEntity {
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    order?: OrderEntity;
    supplyId?: string | undefined;
    supply?: SupplyEntity;
    isInTolerance?: boolean;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class OrderPriceHistoryEntity implements IOrderPriceHistoryEntity {
    orderId?: string;
    order?: OrderEntity;
    grossValue?: number;
    calculatedGrossValue?: number;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IOrderPriceHistoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : <any>undefined;
            this.grossValue = _data["grossValue"];
            this.calculatedGrossValue = _data["calculatedGrossValue"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): OrderPriceHistoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPriceHistoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["grossValue"] = this.grossValue;
        data["calculatedGrossValue"] = this.calculatedGrossValue;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IOrderPriceHistoryEntity {
    orderId?: string;
    order?: OrderEntity;
    grossValue?: number;
    calculatedGrossValue?: number;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class OrderStatusEntity implements IOrderStatusEntity {
    name?: string | undefined;
    idState?: number;
    color?: string | undefined;
    orders?: OrderEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IOrderStatusEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.idState = _data["idState"];
            this.color = _data["color"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): OrderStatusEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["idState"] = this.idState;
        data["color"] = this.color;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IOrderStatusEntity {
    name?: string | undefined;
    idState?: number;
    color?: string | undefined;
    orders?: OrderEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class StructuralElementEntity implements IStructuralElementEntity {
    name?: string | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IStructuralElementEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): StructuralElementEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralElementEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IStructuralElementEntity {
    name?: string | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class SpecialAdditivesEntity implements ISpecialAdditivesEntity {
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    addressId?: string | undefined;
    address?: AddressEntity;
    orderSpecialAdditives?: OrderSpecialAdditivesEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ISpecialAdditivesEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.weight = _data["weight"];
            this.isForHigherClass = _data["isForHigherClass"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressEntity.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["orderSpecialAdditives"])) {
                this.orderSpecialAdditives = [] as any;
                for (let item of _data["orderSpecialAdditives"])
                    this.orderSpecialAdditives!.push(OrderSpecialAdditivesEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): SpecialAdditivesEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialAdditivesEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["weight"] = this.weight;
        data["isForHigherClass"] = this.isForHigherClass;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.orderSpecialAdditives)) {
            data["orderSpecialAdditives"] = [];
            for (let item of this.orderSpecialAdditives)
                data["orderSpecialAdditives"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ISpecialAdditivesEntity {
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    customer?: CustomerEntity;
    addressId?: string | undefined;
    address?: AddressEntity;
    orderSpecialAdditives?: OrderSpecialAdditivesEntity[] | undefined;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class OrderSpecialAdditivesEntity implements IOrderSpecialAdditivesEntity {
    specialAdditiveId?: string;
    orderId?: string;
    perUnitPrice?: number;
    specialAdditive?: SpecialAdditivesEntity;
    order?: OrderEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IOrderSpecialAdditivesEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialAdditiveId = _data["specialAdditiveId"];
            this.orderId = _data["orderId"];
            this.perUnitPrice = _data["perUnitPrice"];
            this.specialAdditive = _data["specialAdditive"] ? SpecialAdditivesEntity.fromJS(_data["specialAdditive"]) : <any>undefined;
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : <any>undefined;
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): OrderSpecialAdditivesEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSpecialAdditivesEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialAdditiveId"] = this.specialAdditiveId;
        data["orderId"] = this.orderId;
        data["perUnitPrice"] = this.perUnitPrice;
        data["specialAdditive"] = this.specialAdditive ? this.specialAdditive.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IOrderSpecialAdditivesEntity {
    specialAdditiveId?: string;
    orderId?: string;
    perUnitPrice?: number;
    specialAdditive?: SpecialAdditivesEntity;
    order?: OrderEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export enum SettlementStatuses {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SettlementHistoryEntity implements ISettlementHistoryEntity {
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    settlementId?: string;
    settlement?: SettlementEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ISettlementHistoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.settlementId = _data["settlementId"];
            this.settlement = _data["settlement"] ? SettlementEntity.fromJS(_data["settlement"]) : <any>undefined;
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): SettlementHistoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementHistoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["settlementId"] = this.settlementId;
        data["settlement"] = this.settlement ? this.settlement.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ISettlementHistoryEntity {
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    settlementId?: string;
    settlement?: SettlementEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class SettlementEntity implements ISettlementEntity {
    nodeId?: string;
    orderId?: string | undefined;
    order?: OrderEntity;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentTypeId?: number | undefined;
    paymentType?: PaymentTypeEntity;
    isReceipt?: boolean;
    status?: SettlementStatuses;
    settlementHistories?: SettlementHistoryEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: ISettlementEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : <any>undefined;
            this.wz = _data["wz"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.product = _data["product"];
            this.recipes = _data["recipes"];
            this.itemCount = _data["itemCount"];
            this.itemPrice = _data["itemPrice"];
            this.pumpPrice = _data["pumpPrice"];
            this.chemistryPrice = _data["chemistryPrice"];
            this.reinforcementPrice = _data["reinforcementPrice"];
            this.transportPrice = _data["transportPrice"];
            this.heatingPrice = _data["heatingPrice"];
            this.additionalPrice = _data["additionalPrice"];
            this.sumPrice = _data["sumPrice"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.paymentType = _data["paymentType"] ? PaymentTypeEntity.fromJS(_data["paymentType"]) : <any>undefined;
            this.isReceipt = _data["isReceipt"];
            this.status = _data["status"];
            if (Array.isArray(_data["settlementHistories"])) {
                this.settlementHistories = [] as any;
                for (let item of _data["settlementHistories"])
                    this.settlementHistories!.push(SettlementHistoryEntity.fromJS(item));
            }
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): SettlementEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["wz"] = this.wz;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["product"] = this.product;
        data["recipes"] = this.recipes;
        data["itemCount"] = this.itemCount;
        data["itemPrice"] = this.itemPrice;
        data["pumpPrice"] = this.pumpPrice;
        data["chemistryPrice"] = this.chemistryPrice;
        data["reinforcementPrice"] = this.reinforcementPrice;
        data["transportPrice"] = this.transportPrice;
        data["heatingPrice"] = this.heatingPrice;
        data["additionalPrice"] = this.additionalPrice;
        data["sumPrice"] = this.sumPrice;
        data["paymentTypeId"] = this.paymentTypeId;
        data["paymentType"] = this.paymentType ? this.paymentType.toJSON() : <any>undefined;
        data["isReceipt"] = this.isReceipt;
        data["status"] = this.status;
        if (Array.isArray(this.settlementHistories)) {
            data["settlementHistories"] = [];
            for (let item of this.settlementHistories)
                data["settlementHistories"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface ISettlementEntity {
    nodeId?: string;
    orderId?: string | undefined;
    order?: OrderEntity;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentTypeId?: number | undefined;
    paymentType?: PaymentTypeEntity;
    isReceipt?: boolean;
    status?: SettlementStatuses;
    settlementHistories?: SettlementHistoryEntity[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class OrderEntity implements IOrderEntity {
    type?: OrderType;
    customerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    orderNumber?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    callelationReason?: string | undefined;
    isOpenToEdit?: boolean;
    isReceipt?: boolean;
    customer?: CustomerEntity;
    orderItems?: OrderItemEntity[] | undefined;
    weights?: WeightEntity[] | undefined;
    orderPriceHistory?: OrderPriceHistoryEntity[] | undefined;
    orderStatusId?: string | undefined;
    nodeId?: string;
    addressId?: string | undefined;
    node?: NodeEntity;
    paymentsTypeEntity?: PaymentTypeEntity;
    orderStatus?: OrderStatusEntity;
    address?: AddressEntity;
    structuralElement?: StructuralElementEntity;
    orderSpecialAdditives?: OrderSpecialAdditivesEntity[] | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    wzCount?: number | undefined;
    wzDocuments?: WZDocumentsEntity[] | undefined;
    settlementId?: string | undefined;
    settlement?: SettlementEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IOrderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.customerId = _data["customerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.netValue = _data["netValue"];
            this.grossValue = _data["grossValue"];
            this.discountValue = _data["discountValue"];
            this.isOffer = _data["isOffer"];
            this.hasIndividualPrice = _data["hasIndividualPrice"];
            this.orderNumber = _data["orderNumber"];
            this.distancePrice = _data["distancePrice"];
            this.transportFee = _data["transportFee"];
            this.distance = _data["distance"];
            this.personalPickup = _data["personalPickup"];
            this.registrationNumber = _data["registrationNumber"];
            this.comments = _data["comments"];
            this.vatRate = _data["vatRate"];
            this.calculatedGrossValue = _data["calculatedGrossValue"];
            this.structuralElementId = _data["structuralElementId"];
            this.callelationReason = _data["callelationReason"];
            this.isOpenToEdit = _data["isOpenToEdit"];
            this.isReceipt = _data["isReceipt"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemEntity.fromJS(item));
            }
            if (Array.isArray(_data["weights"])) {
                this.weights = [] as any;
                for (let item of _data["weights"])
                    this.weights!.push(WeightEntity.fromJS(item));
            }
            if (Array.isArray(_data["orderPriceHistory"])) {
                this.orderPriceHistory = [] as any;
                for (let item of _data["orderPriceHistory"])
                    this.orderPriceHistory!.push(OrderPriceHistoryEntity.fromJS(item));
            }
            this.orderStatusId = _data["orderStatusId"];
            this.nodeId = _data["nodeId"];
            this.addressId = _data["addressId"];
            this.node = _data["node"] ? NodeEntity.fromJS(_data["node"]) : <any>undefined;
            this.paymentsTypeEntity = _data["paymentsTypeEntity"] ? PaymentTypeEntity.fromJS(_data["paymentsTypeEntity"]) : <any>undefined;
            this.orderStatus = _data["orderStatus"] ? OrderStatusEntity.fromJS(_data["orderStatus"]) : <any>undefined;
            this.address = _data["address"] ? AddressEntity.fromJS(_data["address"]) : <any>undefined;
            this.structuralElement = _data["structuralElement"] ? StructuralElementEntity.fromJS(_data["structuralElement"]) : <any>undefined;
            if (Array.isArray(_data["orderSpecialAdditives"])) {
                this.orderSpecialAdditives = [] as any;
                for (let item of _data["orderSpecialAdditives"])
                    this.orderSpecialAdditives!.push(OrderSpecialAdditivesEntity.fromJS(item));
            }
            this.createUserFirstName = _data["createUserFirstName"];
            this.createUserLastName = _data["createUserLastName"];
            this.lmUserFirstName = _data["lmUserFirstName"];
            this.lmUserLastName = _data["lmUserLastName"];
            this.wzCount = _data["wzCount"];
            if (Array.isArray(_data["wzDocuments"])) {
                this.wzDocuments = [] as any;
                for (let item of _data["wzDocuments"])
                    this.wzDocuments!.push(WZDocumentsEntity.fromJS(item));
            }
            this.settlementId = _data["settlementId"];
            this.settlement = _data["settlement"] ? SettlementEntity.fromJS(_data["settlement"]) : <any>undefined;
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): OrderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["customerId"] = this.customerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["netValue"] = this.netValue;
        data["grossValue"] = this.grossValue;
        data["discountValue"] = this.discountValue;
        data["isOffer"] = this.isOffer;
        data["hasIndividualPrice"] = this.hasIndividualPrice;
        data["orderNumber"] = this.orderNumber;
        data["distancePrice"] = this.distancePrice;
        data["transportFee"] = this.transportFee;
        data["distance"] = this.distance;
        data["personalPickup"] = this.personalPickup;
        data["registrationNumber"] = this.registrationNumber;
        data["comments"] = this.comments;
        data["vatRate"] = this.vatRate;
        data["calculatedGrossValue"] = this.calculatedGrossValue;
        data["structuralElementId"] = this.structuralElementId;
        data["callelationReason"] = this.callelationReason;
        data["isOpenToEdit"] = this.isOpenToEdit;
        data["isReceipt"] = this.isReceipt;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.weights)) {
            data["weights"] = [];
            for (let item of this.weights)
                data["weights"].push(item.toJSON());
        }
        if (Array.isArray(this.orderPriceHistory)) {
            data["orderPriceHistory"] = [];
            for (let item of this.orderPriceHistory)
                data["orderPriceHistory"].push(item.toJSON());
        }
        data["orderStatusId"] = this.orderStatusId;
        data["nodeId"] = this.nodeId;
        data["addressId"] = this.addressId;
        data["node"] = this.node ? this.node.toJSON() : <any>undefined;
        data["paymentsTypeEntity"] = this.paymentsTypeEntity ? this.paymentsTypeEntity.toJSON() : <any>undefined;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["structuralElement"] = this.structuralElement ? this.structuralElement.toJSON() : <any>undefined;
        if (Array.isArray(this.orderSpecialAdditives)) {
            data["orderSpecialAdditives"] = [];
            for (let item of this.orderSpecialAdditives)
                data["orderSpecialAdditives"].push(item.toJSON());
        }
        data["createUserFirstName"] = this.createUserFirstName;
        data["createUserLastName"] = this.createUserLastName;
        data["lmUserFirstName"] = this.lmUserFirstName;
        data["lmUserLastName"] = this.lmUserLastName;
        data["wzCount"] = this.wzCount;
        if (Array.isArray(this.wzDocuments)) {
            data["wzDocuments"] = [];
            for (let item of this.wzDocuments)
                data["wzDocuments"].push(item.toJSON());
        }
        data["settlementId"] = this.settlementId;
        data["settlement"] = this.settlement ? this.settlement.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IOrderEntity {
    type?: OrderType;
    customerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    orderNumber?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    callelationReason?: string | undefined;
    isOpenToEdit?: boolean;
    isReceipt?: boolean;
    customer?: CustomerEntity;
    orderItems?: OrderItemEntity[] | undefined;
    weights?: WeightEntity[] | undefined;
    orderPriceHistory?: OrderPriceHistoryEntity[] | undefined;
    orderStatusId?: string | undefined;
    nodeId?: string;
    addressId?: string | undefined;
    node?: NodeEntity;
    paymentsTypeEntity?: PaymentTypeEntity;
    orderStatus?: OrderStatusEntity;
    address?: AddressEntity;
    structuralElement?: StructuralElementEntity;
    orderSpecialAdditives?: OrderSpecialAdditivesEntity[] | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    wzCount?: number | undefined;
    wzDocuments?: WZDocumentsEntity[] | undefined;
    settlementId?: string | undefined;
    settlement?: SettlementEntity;
    id?: string;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class PaymentTypeEntity implements IPaymentTypeEntity {
    name?: string | undefined;
    orders?: OrderEntity[] | undefined;
    id?: number;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;

    constructor(data?: IPaymentTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderEntity.fromJS(item));
            }
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createUserId = _data["createUserId"];
            this.isActive = _data["isActive"];
            this.lmDate = _data["lmDate"] ? new Date(_data["lmDate"].toString()) : <any>undefined;
            this.lmUserId = _data["lmUserId"];
        }
    }

    static fromJS(data: any): PaymentTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["isActive"] = this.isActive;
        data["lmDate"] = this.lmDate ? this.lmDate.toISOString() : <any>undefined;
        data["lmUserId"] = this.lmUserId;
        return data;
    }
}

export interface IPaymentTypeEntity {
    name?: string | undefined;
    orders?: OrderEntity[] | undefined;
    id?: number;
    createDate?: Date;
    createUserId?: string | undefined;
    isActive?: boolean;
    lmDate?: Date;
    lmUserId?: string | undefined;
}

export class OrderStatusModel implements IOrderStatusModel {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;

    constructor(data?: IOrderStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.idState = _data["idState"];
        }
    }

    static fromJS(data: any): OrderStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["idState"] = this.idState;
        return data;
    }
}

export interface IOrderStatusModel {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;
}

export class CarModelForOrder implements ICarModelForOrder {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    carNodes?: string[] | undefined;

    constructor(data?: ICarModelForOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.registrationNumber = _data["registrationNumber"];
            this.pricePerKilometer = _data["pricePerKilometer"];
            this.nodeId = _data["nodeId"];
            this.nodeName = _data["nodeName"];
            this.volume = _data["volume"];
            this.maxVolume = _data["maxVolume"];
            this.volumeTon = _data["volumeTon"];
            this.maxVolumeTon = _data["maxVolumeTon"];
            this.mainNodeId = _data["mainNodeId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["carNodes"])) {
                this.carNodes = [] as any;
                for (let item of _data["carNodes"])
                    this.carNodes!.push(item);
            }
        }
    }

    static fromJS(data: any): CarModelForOrder {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelForOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["registrationNumber"] = this.registrationNumber;
        data["pricePerKilometer"] = this.pricePerKilometer;
        data["nodeId"] = this.nodeId;
        data["nodeName"] = this.nodeName;
        data["volume"] = this.volume;
        data["maxVolume"] = this.maxVolume;
        data["volumeTon"] = this.volumeTon;
        data["maxVolumeTon"] = this.maxVolumeTon;
        data["mainNodeId"] = this.mainNodeId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.carNodes)) {
            data["carNodes"] = [];
            for (let item of this.carNodes)
                data["carNodes"].push(item);
        }
        return data;
    }
}

export interface ICarModelForOrder {
    id?: string;
    name?: string | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    registrationNumber?: string | undefined;
    pricePerKilometer?: number | undefined;
    nodeId?: string | undefined;
    nodeName?: string | undefined;
    volume?: number;
    maxVolume?: number;
    volumeTon?: number;
    maxVolumeTon?: number;
    mainNodeId?: string;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    carNodes?: string[] | undefined;
}

export class SupplyStatusModel implements ISupplyStatusModel {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;

    constructor(data?: ISupplyStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.idState = _data["idState"];
        }
    }

    static fromJS(data: any): SupplyStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["idState"] = this.idState;
        return data;
    }
}

export interface ISupplyStatusModel {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;
}

export class SupplyForOrderModel implements ISupplyForOrderModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    supplyStatusId?: string | undefined;
    distancePrice?: number | undefined;
    address?: AddressModel;
    car?: CarModelForOrder;
    supplyStatus?: SupplyStatusModel;
    orderItemsIds?: string[] | undefined;

    constructor(data?: ISupplyForOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.addressId = _data["addressId"];
            this.supplyStatusId = _data["supplyStatusId"];
            this.distancePrice = _data["distancePrice"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.car = _data["car"] ? CarModelForOrder.fromJS(_data["car"]) : <any>undefined;
            this.supplyStatus = _data["supplyStatus"] ? SupplyStatusModel.fromJS(_data["supplyStatus"]) : <any>undefined;
            if (Array.isArray(_data["orderItemsIds"])) {
                this.orderItemsIds = [] as any;
                for (let item of _data["orderItemsIds"])
                    this.orderItemsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SupplyForOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyForOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["price"] = this.price;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["addressId"] = this.addressId;
        data["supplyStatusId"] = this.supplyStatusId;
        data["distancePrice"] = this.distancePrice;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        data["supplyStatus"] = this.supplyStatus ? this.supplyStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemsIds)) {
            data["orderItemsIds"] = [];
            for (let item of this.orderItemsIds)
                data["orderItemsIds"].push(item);
        }
        return data;
    }
}

export interface ISupplyForOrderModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    supplyStatusId?: string | undefined;
    distancePrice?: number | undefined;
    address?: AddressModel;
    car?: CarModelForOrder;
    supplyStatus?: SupplyStatusModel;
    orderItemsIds?: string[] | undefined;
}

export class OrderItemModel implements IOrderItemModel {
    id?: string;
    itemId?: string;
    orderId?: string;
    supplyId?: string | undefined;
    perUnitPrice?: number;
    count?: number;
    recipe?: string | undefined;
    item?: ItemModel;
    order?: OrderModel;
    supplies?: SupplyForOrderModel[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;

    constructor(data?: IOrderItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.orderId = _data["orderId"];
            this.supplyId = _data["supplyId"];
            this.perUnitPrice = _data["perUnitPrice"];
            this.count = _data["count"];
            this.recipe = _data["recipe"];
            this.item = _data["item"] ? ItemModel.fromJS(_data["item"]) : <any>undefined;
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(SupplyForOrderModel.fromJS(item));
            }
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
        }
    }

    static fromJS(data: any): OrderItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["orderId"] = this.orderId;
        data["supplyId"] = this.supplyId;
        data["perUnitPrice"] = this.perUnitPrice;
        data["count"] = this.count;
        data["recipe"] = this.recipe;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        return data;
    }
}

export interface IOrderItemModel {
    id?: string;
    itemId?: string;
    orderId?: string;
    supplyId?: string | undefined;
    perUnitPrice?: number;
    count?: number;
    recipe?: string | undefined;
    item?: ItemModel;
    order?: OrderModel;
    supplies?: SupplyForOrderModel[] | undefined;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
}

export class SpecialAdditivesSelectModel implements ISpecialAdditivesSelectModel {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    address?: AddressModel;

    constructor(data?: ISpecialAdditivesSelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.weight = _data["weight"];
            this.isForHigherClass = _data["isForHigherClass"];
            this.customerId = _data["customerId"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SpecialAdditivesSelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialAdditivesSelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["weight"] = this.weight;
        data["isForHigherClass"] = this.isForHigherClass;
        data["customerId"] = this.customerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISpecialAdditivesSelectModel {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    address?: AddressModel;
}

export class OrderModel implements IOrderModel {
    id?: string;
    type?: OrderType;
    customerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    orderStatusId?: string | undefined;
    addressId?: string | undefined;
    address?: AddressModel;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    paymentTypeEntity?: PaymentTypeEntity;
    orderStatus?: OrderStatusModel;
    customer?: CustomerModel;
    orderItems?: OrderItemModel[] | undefined;
    specialAdditives?: SpecialAdditivesSelectModel[] | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    wzCount?: number;
    nodeId?: string | undefined;
    orderNumber?: string | undefined;
    isReceipt?: boolean;

    constructor(data?: IOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.customerId = _data["customerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.netValue = _data["netValue"];
            this.grossValue = _data["grossValue"];
            this.discountValue = _data["discountValue"];
            this.isOffer = _data["isOffer"];
            this.hasIndividualPrice = _data["hasIndividualPrice"];
            this.orderStatusId = _data["orderStatusId"];
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.distancePrice = _data["distancePrice"];
            this.transportFee = _data["transportFee"];
            this.distance = _data["distance"];
            this.personalPickup = _data["personalPickup"];
            this.registrationNumber = _data["registrationNumber"];
            this.comments = _data["comments"];
            this.vatRate = _data["vatRate"];
            this.calculatedGrossValue = _data["calculatedGrossValue"];
            this.structuralElementId = _data["structuralElementId"];
            this.paymentTypeEntity = _data["paymentTypeEntity"] ? PaymentTypeEntity.fromJS(_data["paymentTypeEntity"]) : <any>undefined;
            this.orderStatus = _data["orderStatus"] ? OrderStatusModel.fromJS(_data["orderStatus"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemModel.fromJS(item));
            }
            if (Array.isArray(_data["specialAdditives"])) {
                this.specialAdditives = [] as any;
                for (let item of _data["specialAdditives"])
                    this.specialAdditives!.push(SpecialAdditivesSelectModel.fromJS(item));
            }
            this.createUserFirstName = _data["createUserFirstName"];
            this.createUserLastName = _data["createUserLastName"];
            this.lmUserFirstName = _data["lmUserFirstName"];
            this.lmUserLastName = _data["lmUserLastName"];
            this.wzCount = _data["wzCount"];
            this.nodeId = _data["nodeId"];
            this.orderNumber = _data["orderNumber"];
            this.isReceipt = _data["isReceipt"];
        }
    }

    static fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["customerId"] = this.customerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["netValue"] = this.netValue;
        data["grossValue"] = this.grossValue;
        data["discountValue"] = this.discountValue;
        data["isOffer"] = this.isOffer;
        data["hasIndividualPrice"] = this.hasIndividualPrice;
        data["orderStatusId"] = this.orderStatusId;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["distancePrice"] = this.distancePrice;
        data["transportFee"] = this.transportFee;
        data["distance"] = this.distance;
        data["personalPickup"] = this.personalPickup;
        data["registrationNumber"] = this.registrationNumber;
        data["comments"] = this.comments;
        data["vatRate"] = this.vatRate;
        data["calculatedGrossValue"] = this.calculatedGrossValue;
        data["structuralElementId"] = this.structuralElementId;
        data["paymentTypeEntity"] = this.paymentTypeEntity ? this.paymentTypeEntity.toJSON() : <any>undefined;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.specialAdditives)) {
            data["specialAdditives"] = [];
            for (let item of this.specialAdditives)
                data["specialAdditives"].push(item.toJSON());
        }
        data["createUserFirstName"] = this.createUserFirstName;
        data["createUserLastName"] = this.createUserLastName;
        data["lmUserFirstName"] = this.lmUserFirstName;
        data["lmUserLastName"] = this.lmUserLastName;
        data["wzCount"] = this.wzCount;
        data["nodeId"] = this.nodeId;
        data["orderNumber"] = this.orderNumber;
        data["isReceipt"] = this.isReceipt;
        return data;
    }
}

export interface IOrderModel {
    id?: string;
    type?: OrderType;
    customerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    orderStatusId?: string | undefined;
    addressId?: string | undefined;
    address?: AddressModel;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    paymentTypeEntity?: PaymentTypeEntity;
    orderStatus?: OrderStatusModel;
    customer?: CustomerModel;
    orderItems?: OrderItemModel[] | undefined;
    specialAdditives?: SpecialAdditivesSelectModel[] | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    wzCount?: number;
    nodeId?: string | undefined;
    orderNumber?: string | undefined;
    isReceipt?: boolean;
}

export class SupplyModel implements ISupplyModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    supplyStatusId?: string | undefined;
    distancePrice?: number | undefined;
    address?: AddressModel;
    car?: CarModel;
    supplyStatus?: SupplyStatusModel;
    orderItemsIds?: string[] | undefined;

    constructor(data?: ISupplyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.addressId = _data["addressId"];
            this.supplyStatusId = _data["supplyStatusId"];
            this.distancePrice = _data["distancePrice"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.car = _data["car"] ? CarModel.fromJS(_data["car"]) : <any>undefined;
            this.supplyStatus = _data["supplyStatus"] ? SupplyStatusModel.fromJS(_data["supplyStatus"]) : <any>undefined;
            if (Array.isArray(_data["orderItemsIds"])) {
                this.orderItemsIds = [] as any;
                for (let item of _data["orderItemsIds"])
                    this.orderItemsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SupplyModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["price"] = this.price;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["addressId"] = this.addressId;
        data["supplyStatusId"] = this.supplyStatusId;
        data["distancePrice"] = this.distancePrice;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        data["supplyStatus"] = this.supplyStatus ? this.supplyStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemsIds)) {
            data["orderItemsIds"] = [];
            for (let item of this.orderItemsIds)
                data["orderItemsIds"].push(item);
        }
        return data;
    }
}

export interface ISupplyModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    supplyStatusId?: string | undefined;
    distancePrice?: number | undefined;
    address?: AddressModel;
    car?: CarModel;
    supplyStatus?: SupplyStatusModel;
    orderItemsIds?: string[] | undefined;
}

export class OrderExecutionQueueItemModel implements IOrderExecutionQueueItemModel {
    id?: string;
    nodeId?: string;
    date?: Date;
    order?: OrderModel;
    supply?: SupplyModel;
    nextOrderExecutionQueueItemId?: string | undefined;
    prevOrderExecutionQueueItemId?: string | undefined;

    constructor(data?: IOrderExecutionQueueItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nodeId = _data["nodeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.supply = _data["supply"] ? SupplyModel.fromJS(_data["supply"]) : <any>undefined;
            this.nextOrderExecutionQueueItemId = _data["nextOrderExecutionQueueItemId"];
            this.prevOrderExecutionQueueItemId = _data["prevOrderExecutionQueueItemId"];
        }
    }

    static fromJS(data: any): OrderExecutionQueueItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderExecutionQueueItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nodeId"] = this.nodeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["supply"] = this.supply ? this.supply.toJSON() : <any>undefined;
        data["nextOrderExecutionQueueItemId"] = this.nextOrderExecutionQueueItemId;
        data["prevOrderExecutionQueueItemId"] = this.prevOrderExecutionQueueItemId;
        return data;
    }
}

export interface IOrderExecutionQueueItemModel {
    id?: string;
    nodeId?: string;
    date?: Date;
    order?: OrderModel;
    supply?: SupplyModel;
    nextOrderExecutionQueueItemId?: string | undefined;
    prevOrderExecutionQueueItemId?: string | undefined;
}

export class OrderExecutionQueueItemModelIEnumerableResponse implements IOrderExecutionQueueItemModelIEnumerableResponse {
    readonly result?: OrderExecutionQueueItemModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderExecutionQueueItemModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OrderExecutionQueueItemModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderExecutionQueueItemModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderExecutionQueueItemModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderExecutionQueueItemModelIEnumerableResponse {
    result?: OrderExecutionQueueItemModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddOrderItemModel implements IAddOrderItemModel {
    id?: string;
    itemId?: string;
    itemName?: string | undefined;
    recipe?: string | undefined;
    supplyIds?: string[] | undefined;
    count?: number;
    perUnitPrice?: number;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;

    constructor(data?: IAddOrderItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.recipe = _data["recipe"];
            if (Array.isArray(_data["supplyIds"])) {
                this.supplyIds = [] as any;
                for (let item of _data["supplyIds"])
                    this.supplyIds!.push(item);
            }
            this.count = _data["count"];
            this.perUnitPrice = _data["perUnitPrice"];
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
        }
    }

    static fromJS(data: any): AddOrderItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["recipe"] = this.recipe;
        if (Array.isArray(this.supplyIds)) {
            data["supplyIds"] = [];
            for (let item of this.supplyIds)
                data["supplyIds"].push(item);
        }
        data["count"] = this.count;
        data["perUnitPrice"] = this.perUnitPrice;
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        return data;
    }
}

export interface IAddOrderItemModel {
    id?: string;
    itemId?: string;
    itemName?: string | undefined;
    recipe?: string | undefined;
    supplyIds?: string[] | undefined;
    count?: number;
    perUnitPrice?: number;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
}

export class AddAddressModel implements IAddAddressModel {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;

    constructor(data?: IAddAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.isMainAddress = _data["isMainAddress"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): AddAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        data["isMainAddress"] = this.isMainAddress;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IAddAddressModel {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    phoneNumber?: string | undefined;
    isMainAddress?: boolean;
    customerId?: string | undefined;
}

export class AddSupplyModel implements IAddSupplyModel {
    id?: string;
    carId?: string | undefined;
    price?: number;
    count?: number;
    dateFrom?: Date;
    dateTo?: Date;
    supplyStatusId?: string;
    addressId?: string | undefined;
    address?: AddAddressModel;
    distancePrice?: number | undefined;

    constructor(data?: IAddSupplyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carId = _data["carId"];
            this.price = _data["price"];
            this.count = _data["count"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.supplyStatusId = _data["supplyStatusId"];
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddAddressModel.fromJS(_data["address"]) : <any>undefined;
            this.distancePrice = _data["distancePrice"];
        }
    }

    static fromJS(data: any): AddSupplyModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddSupplyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carId"] = this.carId;
        data["price"] = this.price;
        data["count"] = this.count;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["supplyStatusId"] = this.supplyStatusId;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["distancePrice"] = this.distancePrice;
        return data;
    }
}

export interface IAddSupplyModel {
    id?: string;
    carId?: string | undefined;
    price?: number;
    count?: number;
    dateFrom?: Date;
    dateTo?: Date;
    supplyStatusId?: string;
    addressId?: string | undefined;
    address?: AddAddressModel;
    distancePrice?: number | undefined;
}

export class OrderSpecialAdditive implements IOrderSpecialAdditive {
    id?: string;
    perUnitPrice?: number;

    constructor(data?: IOrderSpecialAdditive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.perUnitPrice = _data["perUnitPrice"];
        }
    }

    static fromJS(data: any): OrderSpecialAdditive {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSpecialAdditive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["perUnitPrice"] = this.perUnitPrice;
        return data;
    }
}

export interface IOrderSpecialAdditive {
    id?: string;
    perUnitPrice?: number;
}

export class AddOrderCommand implements IAddOrderCommand {
    id?: string;
    type?: OrderType;
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    orderStatusId?: string;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    nodeId?: string;
    addressId?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    orderItems?: AddOrderItemModel[] | undefined;
    supplies?: AddSupplyModel[] | undefined;
    specialAdditives?: OrderSpecialAdditive[] | undefined;
    customer?: CustomerModel;
    wzCount?: number;
    userId?: string | undefined;
    isReceipt?: boolean;

    constructor(data?: IAddOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.customerId = _data["customerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.paymentType = _data["paymentType"];
            this.netValue = _data["netValue"];
            this.grossValue = _data["grossValue"];
            this.discountValue = _data["discountValue"];
            this.isOffer = _data["isOffer"];
            this.hasIndividualPrice = _data["hasIndividualPrice"];
            this.nodeId = _data["nodeId"];
            this.addressId = _data["addressId"];
            this.distancePrice = _data["distancePrice"];
            this.transportFee = _data["transportFee"];
            this.distance = _data["distance"];
            this.personalPickup = _data["personalPickup"];
            this.registrationNumber = _data["registrationNumber"];
            this.comments = _data["comments"];
            this.vatRate = _data["vatRate"];
            this.calculatedGrossValue = _data["calculatedGrossValue"];
            this.structuralElementId = _data["structuralElementId"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(AddOrderItemModel.fromJS(item));
            }
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(AddSupplyModel.fromJS(item));
            }
            if (Array.isArray(_data["specialAdditives"])) {
                this.specialAdditives = [] as any;
                for (let item of _data["specialAdditives"])
                    this.specialAdditives!.push(OrderSpecialAdditive.fromJS(item));
            }
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.wzCount = _data["wzCount"];
            this.userId = _data["userId"];
            this.isReceipt = _data["isReceipt"];
        }
    }

    static fromJS(data: any): AddOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["customerId"] = this.customerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["paymentType"] = this.paymentType;
        data["netValue"] = this.netValue;
        data["grossValue"] = this.grossValue;
        data["discountValue"] = this.discountValue;
        data["isOffer"] = this.isOffer;
        data["hasIndividualPrice"] = this.hasIndividualPrice;
        data["nodeId"] = this.nodeId;
        data["addressId"] = this.addressId;
        data["distancePrice"] = this.distancePrice;
        data["transportFee"] = this.transportFee;
        data["distance"] = this.distance;
        data["personalPickup"] = this.personalPickup;
        data["registrationNumber"] = this.registrationNumber;
        data["comments"] = this.comments;
        data["vatRate"] = this.vatRate;
        data["calculatedGrossValue"] = this.calculatedGrossValue;
        data["structuralElementId"] = this.structuralElementId;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        if (Array.isArray(this.specialAdditives)) {
            data["specialAdditives"] = [];
            for (let item of this.specialAdditives)
                data["specialAdditives"].push(item.toJSON());
        }
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["wzCount"] = this.wzCount;
        data["userId"] = this.userId;
        data["isReceipt"] = this.isReceipt;
        return data;
    }
}

export interface IAddOrderCommand {
    id?: string;
    type?: OrderType;
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    orderStatusId?: string;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    nodeId?: string;
    addressId?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    orderItems?: AddOrderItemModel[] | undefined;
    supplies?: AddSupplyModel[] | undefined;
    specialAdditives?: OrderSpecialAdditive[] | undefined;
    customer?: CustomerModel;
    wzCount?: number;
    userId?: string | undefined;
    isReceipt?: boolean;
}

export class UpdateOrderCommand implements IUpdateOrderCommand {
    id?: string;
    type?: OrderType;
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    orderStatusId?: string;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    nodeId?: string;
    addressId?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    orderItems?: AddOrderItemModel[] | undefined;
    supplies?: AddSupplyModel[] | undefined;
    specialAdditives?: OrderSpecialAdditive[] | undefined;
    customer?: CustomerModel;
    wzCount?: number;
    userId?: string | undefined;
    isReceipt?: boolean;

    constructor(data?: IUpdateOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.customerId = _data["customerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.paymentType = _data["paymentType"];
            this.netValue = _data["netValue"];
            this.grossValue = _data["grossValue"];
            this.discountValue = _data["discountValue"];
            this.isOffer = _data["isOffer"];
            this.hasIndividualPrice = _data["hasIndividualPrice"];
            this.nodeId = _data["nodeId"];
            this.addressId = _data["addressId"];
            this.distancePrice = _data["distancePrice"];
            this.transportFee = _data["transportFee"];
            this.distance = _data["distance"];
            this.personalPickup = _data["personalPickup"];
            this.registrationNumber = _data["registrationNumber"];
            this.comments = _data["comments"];
            this.vatRate = _data["vatRate"];
            this.calculatedGrossValue = _data["calculatedGrossValue"];
            this.structuralElementId = _data["structuralElementId"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(AddOrderItemModel.fromJS(item));
            }
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(AddSupplyModel.fromJS(item));
            }
            if (Array.isArray(_data["specialAdditives"])) {
                this.specialAdditives = [] as any;
                for (let item of _data["specialAdditives"])
                    this.specialAdditives!.push(OrderSpecialAdditive.fromJS(item));
            }
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.wzCount = _data["wzCount"];
            this.userId = _data["userId"];
            this.isReceipt = _data["isReceipt"];
        }
    }

    static fromJS(data: any): UpdateOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["customerId"] = this.customerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["paymentType"] = this.paymentType;
        data["netValue"] = this.netValue;
        data["grossValue"] = this.grossValue;
        data["discountValue"] = this.discountValue;
        data["isOffer"] = this.isOffer;
        data["hasIndividualPrice"] = this.hasIndividualPrice;
        data["nodeId"] = this.nodeId;
        data["addressId"] = this.addressId;
        data["distancePrice"] = this.distancePrice;
        data["transportFee"] = this.transportFee;
        data["distance"] = this.distance;
        data["personalPickup"] = this.personalPickup;
        data["registrationNumber"] = this.registrationNumber;
        data["comments"] = this.comments;
        data["vatRate"] = this.vatRate;
        data["calculatedGrossValue"] = this.calculatedGrossValue;
        data["structuralElementId"] = this.structuralElementId;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        if (Array.isArray(this.specialAdditives)) {
            data["specialAdditives"] = [];
            for (let item of this.specialAdditives)
                data["specialAdditives"].push(item.toJSON());
        }
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["wzCount"] = this.wzCount;
        data["userId"] = this.userId;
        data["isReceipt"] = this.isReceipt;
        return data;
    }
}

export interface IUpdateOrderCommand {
    id?: string;
    type?: OrderType;
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    orderStatusId?: string;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    nodeId?: string;
    addressId?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    orderItems?: AddOrderItemModel[] | undefined;
    supplies?: AddSupplyModel[] | undefined;
    specialAdditives?: OrderSpecialAdditive[] | undefined;
    customer?: CustomerModel;
    wzCount?: number;
    userId?: string | undefined;
    isReceipt?: boolean;
}

export class OrderModelIEnumerableResponse implements IOrderModelIEnumerableResponse {
    readonly result?: OrderModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OrderModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderModelIEnumerableResponse {
    result?: OrderModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddCopyOrderCommand implements IAddCopyOrderCommand {
    id?: string;
    type?: OrderType;
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    orderStatusId?: string;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    nodeId?: string;
    addressId?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    orderItems?: AddOrderItemModel[] | undefined;
    supplies?: AddSupplyModel[] | undefined;
    specialAdditives?: OrderSpecialAdditive[] | undefined;
    customer?: CustomerModel;
    wzCount?: number;
    userId?: string | undefined;
    isReceipt?: boolean;

    constructor(data?: IAddCopyOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.customerId = _data["customerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.paymentType = _data["paymentType"];
            this.netValue = _data["netValue"];
            this.grossValue = _data["grossValue"];
            this.discountValue = _data["discountValue"];
            this.isOffer = _data["isOffer"];
            this.hasIndividualPrice = _data["hasIndividualPrice"];
            this.nodeId = _data["nodeId"];
            this.addressId = _data["addressId"];
            this.distancePrice = _data["distancePrice"];
            this.transportFee = _data["transportFee"];
            this.distance = _data["distance"];
            this.personalPickup = _data["personalPickup"];
            this.registrationNumber = _data["registrationNumber"];
            this.comments = _data["comments"];
            this.vatRate = _data["vatRate"];
            this.calculatedGrossValue = _data["calculatedGrossValue"];
            this.structuralElementId = _data["structuralElementId"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(AddOrderItemModel.fromJS(item));
            }
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(AddSupplyModel.fromJS(item));
            }
            if (Array.isArray(_data["specialAdditives"])) {
                this.specialAdditives = [] as any;
                for (let item of _data["specialAdditives"])
                    this.specialAdditives!.push(OrderSpecialAdditive.fromJS(item));
            }
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.wzCount = _data["wzCount"];
            this.userId = _data["userId"];
            this.isReceipt = _data["isReceipt"];
        }
    }

    static fromJS(data: any): AddCopyOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCopyOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["customerId"] = this.customerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["paymentType"] = this.paymentType;
        data["netValue"] = this.netValue;
        data["grossValue"] = this.grossValue;
        data["discountValue"] = this.discountValue;
        data["isOffer"] = this.isOffer;
        data["hasIndividualPrice"] = this.hasIndividualPrice;
        data["nodeId"] = this.nodeId;
        data["addressId"] = this.addressId;
        data["distancePrice"] = this.distancePrice;
        data["transportFee"] = this.transportFee;
        data["distance"] = this.distance;
        data["personalPickup"] = this.personalPickup;
        data["registrationNumber"] = this.registrationNumber;
        data["comments"] = this.comments;
        data["vatRate"] = this.vatRate;
        data["calculatedGrossValue"] = this.calculatedGrossValue;
        data["structuralElementId"] = this.structuralElementId;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        if (Array.isArray(this.specialAdditives)) {
            data["specialAdditives"] = [];
            for (let item of this.specialAdditives)
                data["specialAdditives"].push(item.toJSON());
        }
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["wzCount"] = this.wzCount;
        data["userId"] = this.userId;
        data["isReceipt"] = this.isReceipt;
        return data;
    }
}

export interface IAddCopyOrderCommand {
    id?: string;
    type?: OrderType;
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    orderStatusId?: string;
    paymentType?: number;
    netValue?: number;
    grossValue?: number;
    discountValue?: number;
    isOffer?: boolean;
    hasIndividualPrice?: boolean;
    nodeId?: string;
    addressId?: string | undefined;
    distancePrice?: number | undefined;
    transportFee?: number | undefined;
    distance?: number | undefined;
    personalPickup?: boolean;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
    vatRate?: number;
    calculatedGrossValue?: number | undefined;
    structuralElementId?: string | undefined;
    orderItems?: AddOrderItemModel[] | undefined;
    supplies?: AddSupplyModel[] | undefined;
    specialAdditives?: OrderSpecialAdditive[] | undefined;
    customer?: CustomerModel;
    wzCount?: number;
    userId?: string | undefined;
    isReceipt?: boolean;
}

export class UpdateOrderDateCommand implements IUpdateOrderDateCommand {
    id?: string;
    dateFrom?: Date;
    dateTo?: Date;
    nodeId?: string;

    constructor(data?: IUpdateOrderDateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.nodeId = _data["nodeId"];
        }
    }

    static fromJS(data: any): UpdateOrderDateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderDateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["nodeId"] = this.nodeId;
        return data;
    }
}

export interface IUpdateOrderDateCommand {
    id?: string;
    dateFrom?: Date;
    dateTo?: Date;
    nodeId?: string;
}

export class UpdateOrderStateCommand implements IUpdateOrderStateCommand {
    id?: string;
    orderStatusId?: string;

    constructor(data?: IUpdateOrderStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderStatusId = _data["orderStatusId"];
        }
    }

    static fromJS(data: any): UpdateOrderStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderStatusId"] = this.orderStatusId;
        return data;
    }
}

export interface IUpdateOrderStateCommand {
    id?: string;
    orderStatusId?: string;
}

export class UpdateOrderSettlementCommand implements IUpdateOrderSettlementCommand {
    id?: string;
    grossValue?: number;
    comments?: string | undefined;
    orderItems?: AddOrderItemModel;

    constructor(data?: IUpdateOrderSettlementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.grossValue = _data["grossValue"];
            this.comments = _data["comments"];
            this.orderItems = _data["orderItems"] ? AddOrderItemModel.fromJS(_data["orderItems"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateOrderSettlementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderSettlementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grossValue"] = this.grossValue;
        data["comments"] = this.comments;
        data["orderItems"] = this.orderItems ? this.orderItems.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateOrderSettlementCommand {
    id?: string;
    grossValue?: number;
    comments?: string | undefined;
    orderItems?: AddOrderItemModel;
}

export class OrderModelResponse implements IOrderModelResponse {
    result?: OrderModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrderModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderModelResponse {
    result?: OrderModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddCommentOfDayCommand implements IAddCommentOfDayCommand {
    id?: string;
    content?: string | undefined;
    commentDay?: Date;

    constructor(data?: IAddCommentOfDayCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.commentDay = _data["commentDay"] ? new Date(_data["commentDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCommentOfDayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCommentOfDayCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["commentDay"] = this.commentDay ? this.commentDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAddCommentOfDayCommand {
    id?: string;
    content?: string | undefined;
    commentDay?: Date;
}

export class UpdateCancellationReasonCommand implements IUpdateCancellationReasonCommand {
    id?: string;
    content?: string | undefined;
    orderStatusId?: string;

    constructor(data?: IUpdateCancellationReasonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.orderStatusId = _data["orderStatusId"];
        }
    }

    static fromJS(data: any): UpdateCancellationReasonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCancellationReasonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["orderStatusId"] = this.orderStatusId;
        return data;
    }
}

export interface IUpdateCancellationReasonCommand {
    id?: string;
    content?: string | undefined;
    orderStatusId?: string;
}

export class UpdateRegistrationNumberCommand implements IUpdateRegistrationNumberCommand {
    id?: string;
    registrationNumber?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IUpdateRegistrationNumberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationNumber = _data["registrationNumber"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateRegistrationNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegistrationNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationNumber"] = this.registrationNumber;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUpdateRegistrationNumberCommand {
    id?: string;
    registrationNumber?: string | undefined;
    userId?: string | undefined;
}

export class OrderActivationCommand implements IOrderActivationCommand {
    orderId?: string;

    constructor(data?: IOrderActivationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): OrderActivationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OrderActivationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        return data;
    }
}

export interface IOrderActivationCommand {
    orderId?: string;
}

export class OrderModelPaginationResult implements IOrderModelPaginationResult {
    readonly result?: OrderModel[] | undefined;
    total?: number;

    constructor(data?: IOrderModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OrderModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): OrderModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IOrderModelPaginationResult {
    result?: OrderModel[] | undefined;
    total?: number;
}

export class OrderModelPaginationResultResponse implements IOrderModelPaginationResultResponse {
    result?: OrderModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrderModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderModelPaginationResultResponse {
    result?: OrderModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OrderItemModelByDate implements IOrderItemModelByDate {
    id?: string;
    itemId?: string;
    orderId?: string;
    supplyId?: string | undefined;
    perUnitPrice?: number;
    count?: number;
    item?: ItemModel;
    supplies?: SupplyModel[] | undefined;

    constructor(data?: IOrderItemModelByDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.orderId = _data["orderId"];
            this.supplyId = _data["supplyId"];
            this.perUnitPrice = _data["perUnitPrice"];
            this.count = _data["count"];
            this.item = _data["item"] ? ItemModel.fromJS(_data["item"]) : <any>undefined;
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(SupplyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderItemModelByDate {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemModelByDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["orderId"] = this.orderId;
        data["supplyId"] = this.supplyId;
        data["perUnitPrice"] = this.perUnitPrice;
        data["count"] = this.count;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderItemModelByDate {
    id?: string;
    itemId?: string;
    orderId?: string;
    supplyId?: string | undefined;
    perUnitPrice?: number;
    count?: number;
    item?: ItemModel;
    supplies?: SupplyModel[] | undefined;
}

export class OrderModelByDate implements IOrderModelByDate {
    id?: string;
    type?: OrderType;
    customerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: string | undefined;
    netValue?: number;
    grossValue?: number;
    isOffer?: boolean;
    orderStatusId?: string | undefined;
    orderNumber?: string | undefined;
    paymentTypeEntity?: PaymentTypeEntity;
    orderStatus?: OrderStatusModel;
    customer?: CustomerModel;
    orderItems?: OrderItemModelByDate[] | undefined;

    constructor(data?: IOrderModelByDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.customerId = _data["customerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.netValue = _data["netValue"];
            this.grossValue = _data["grossValue"];
            this.isOffer = _data["isOffer"];
            this.orderStatusId = _data["orderStatusId"];
            this.orderNumber = _data["orderNumber"];
            this.paymentTypeEntity = _data["paymentTypeEntity"] ? PaymentTypeEntity.fromJS(_data["paymentTypeEntity"]) : <any>undefined;
            this.orderStatus = _data["orderStatus"] ? OrderStatusModel.fromJS(_data["orderStatus"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemModelByDate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderModelByDate {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelByDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["customerId"] = this.customerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["netValue"] = this.netValue;
        data["grossValue"] = this.grossValue;
        data["isOffer"] = this.isOffer;
        data["orderStatusId"] = this.orderStatusId;
        data["orderNumber"] = this.orderNumber;
        data["paymentTypeEntity"] = this.paymentTypeEntity ? this.paymentTypeEntity.toJSON() : <any>undefined;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderModelByDate {
    id?: string;
    type?: OrderType;
    customerId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: string | undefined;
    netValue?: number;
    grossValue?: number;
    isOffer?: boolean;
    orderStatusId?: string | undefined;
    orderNumber?: string | undefined;
    paymentTypeEntity?: PaymentTypeEntity;
    orderStatus?: OrderStatusModel;
    customer?: CustomerModel;
    orderItems?: OrderItemModelByDate[] | undefined;
}

export class OrderModelByDateResponse implements IOrderModelByDateResponse {
    result?: OrderModelByDate;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderModelByDateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrderModelByDate.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderModelByDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelByDateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderModelByDateResponse {
    result?: OrderModelByDate;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SuppliesForOrderModel implements ISuppliesForOrderModel {
    id?: string;
    count?: number;
    driverName?: string | undefined;
    carRegistration?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    statusName?: string | undefined;
    statusColor?: string | undefined;

    constructor(data?: ISuppliesForOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.driverName = _data["driverName"];
            this.carRegistration = _data["carRegistration"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.statusName = _data["statusName"];
            this.statusColor = _data["statusColor"];
        }
    }

    static fromJS(data: any): SuppliesForOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuppliesForOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["driverName"] = this.driverName;
        data["carRegistration"] = this.carRegistration;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["statusName"] = this.statusName;
        data["statusColor"] = this.statusColor;
        return data;
    }
}

export interface ISuppliesForOrderModel {
    id?: string;
    count?: number;
    driverName?: string | undefined;
    carRegistration?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    statusName?: string | undefined;
    statusColor?: string | undefined;
}

export class ForDeliveryStatusesOrderModel implements IForDeliveryStatusesOrderModel {
    id?: string;
    type?: OrderType;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: string | undefined;
    netValue?: number;
    grossValue?: number;
    isOffer?: boolean;
    orderStatusId?: string | undefined;
    orderNumber?: string | undefined;
    customerName?: string | undefined;
    structuralElement?: string | undefined;
    isPersonalPickup?: boolean;
    address?: string | undefined;
    orderStatus?: OrderStatusModel;
    paymentTypeEntity?: PaymentTypeEntity;
    supplies?: SuppliesForOrderModel[] | undefined;
    orderItems?: OrderItemModelByDate[] | undefined;

    constructor(data?: IForDeliveryStatusesOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.netValue = _data["netValue"];
            this.grossValue = _data["grossValue"];
            this.isOffer = _data["isOffer"];
            this.orderStatusId = _data["orderStatusId"];
            this.orderNumber = _data["orderNumber"];
            this.customerName = _data["customerName"];
            this.structuralElement = _data["structuralElement"];
            this.isPersonalPickup = _data["isPersonalPickup"];
            this.address = _data["address"];
            this.orderStatus = _data["orderStatus"] ? OrderStatusModel.fromJS(_data["orderStatus"]) : <any>undefined;
            this.paymentTypeEntity = _data["paymentTypeEntity"] ? PaymentTypeEntity.fromJS(_data["paymentTypeEntity"]) : <any>undefined;
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(SuppliesForOrderModel.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemModelByDate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ForDeliveryStatusesOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForDeliveryStatusesOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["netValue"] = this.netValue;
        data["grossValue"] = this.grossValue;
        data["isOffer"] = this.isOffer;
        data["orderStatusId"] = this.orderStatusId;
        data["orderNumber"] = this.orderNumber;
        data["customerName"] = this.customerName;
        data["structuralElement"] = this.structuralElement;
        data["isPersonalPickup"] = this.isPersonalPickup;
        data["address"] = this.address;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["paymentTypeEntity"] = this.paymentTypeEntity ? this.paymentTypeEntity.toJSON() : <any>undefined;
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForDeliveryStatusesOrderModel {
    id?: string;
    type?: OrderType;
    dateFrom?: Date;
    dateTo?: Date;
    paymentType?: string | undefined;
    netValue?: number;
    grossValue?: number;
    isOffer?: boolean;
    orderStatusId?: string | undefined;
    orderNumber?: string | undefined;
    customerName?: string | undefined;
    structuralElement?: string | undefined;
    isPersonalPickup?: boolean;
    address?: string | undefined;
    orderStatus?: OrderStatusModel;
    paymentTypeEntity?: PaymentTypeEntity;
    supplies?: SuppliesForOrderModel[] | undefined;
    orderItems?: OrderItemModelByDate[] | undefined;
}

export class ForDeliveryStatusesOrderModelResponse implements IForDeliveryStatusesOrderModelResponse {
    result?: ForDeliveryStatusesOrderModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IForDeliveryStatusesOrderModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ForDeliveryStatusesOrderModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ForDeliveryStatusesOrderModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForDeliveryStatusesOrderModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IForDeliveryStatusesOrderModelResponse {
    result?: ForDeliveryStatusesOrderModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class ItemPriceModel implements IItemPriceModel {
    name?: string | undefined;
    price?: number;

    constructor(data?: IItemPriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ItemPriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        return data;
    }
}

export interface IItemPriceModel {
    name?: string | undefined;
    price?: number;
}

export class SimpleOrderModel implements ISimpleOrderModel {
    id?: string;
    date?: Date;
    orderNo?: string | undefined;
    grossValue?: number;
    nodeName?: string | undefined;
    customerName?: string | undefined;
    contactPhone?: string | undefined;
    author?: string | undefined;
    isOffer?: boolean;
    paymentType?: string | undefined;
    address?: string | undefined;
    orderStatus?: OrderStatusModel;
    itemId?: string;
    itemName?: string | undefined;
    itemCount?: number;
    itemUnit?: string | undefined;
    itemUnitPrice?: number;
    servicePrices?: ItemPriceModel[] | undefined;
    specialAdditives?: ItemPriceModel[] | undefined;
    recipeNumber?: string | undefined;
    hour?: string | undefined;
    nodeId?: string;
    nodeType?: NodeType;
    registrationNumber?: string | undefined;
    employeeName?: string | undefined;
    isPump?: boolean;
    structuralElement?: string | undefined;
    cancellationReason?: string | undefined;
    comments?: string | undefined;
    wzName?: string | undefined;
    wzCount?: number | undefined;
    personalPickup?: boolean;
    isOpenToEdit?: boolean;

    constructor(data?: ISimpleOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.orderNo = _data["orderNo"];
            this.grossValue = _data["grossValue"];
            this.nodeName = _data["nodeName"];
            this.customerName = _data["customerName"];
            this.contactPhone = _data["contactPhone"];
            this.author = _data["author"];
            this.isOffer = _data["isOffer"];
            this.paymentType = _data["paymentType"];
            this.address = _data["address"];
            this.orderStatus = _data["orderStatus"] ? OrderStatusModel.fromJS(_data["orderStatus"]) : <any>undefined;
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.itemCount = _data["itemCount"];
            this.itemUnit = _data["itemUnit"];
            this.itemUnitPrice = _data["itemUnitPrice"];
            if (Array.isArray(_data["servicePrices"])) {
                this.servicePrices = [] as any;
                for (let item of _data["servicePrices"])
                    this.servicePrices!.push(ItemPriceModel.fromJS(item));
            }
            if (Array.isArray(_data["specialAdditives"])) {
                this.specialAdditives = [] as any;
                for (let item of _data["specialAdditives"])
                    this.specialAdditives!.push(ItemPriceModel.fromJS(item));
            }
            this.recipeNumber = _data["recipeNumber"];
            this.hour = _data["hour"];
            this.nodeId = _data["nodeId"];
            this.nodeType = _data["nodeType"];
            this.registrationNumber = _data["registrationNumber"];
            this.employeeName = _data["employeeName"];
            this.isPump = _data["isPump"];
            this.structuralElement = _data["structuralElement"];
            this.cancellationReason = _data["cancellationReason"];
            this.comments = _data["comments"];
            this.wzName = _data["wzName"];
            this.wzCount = _data["wzCount"];
            this.personalPickup = _data["personalPickup"];
            this.isOpenToEdit = _data["isOpenToEdit"];
        }
    }

    static fromJS(data: any): SimpleOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["orderNo"] = this.orderNo;
        data["grossValue"] = this.grossValue;
        data["nodeName"] = this.nodeName;
        data["customerName"] = this.customerName;
        data["contactPhone"] = this.contactPhone;
        data["author"] = this.author;
        data["isOffer"] = this.isOffer;
        data["paymentType"] = this.paymentType;
        data["address"] = this.address;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["itemCount"] = this.itemCount;
        data["itemUnit"] = this.itemUnit;
        data["itemUnitPrice"] = this.itemUnitPrice;
        if (Array.isArray(this.servicePrices)) {
            data["servicePrices"] = [];
            for (let item of this.servicePrices)
                data["servicePrices"].push(item.toJSON());
        }
        if (Array.isArray(this.specialAdditives)) {
            data["specialAdditives"] = [];
            for (let item of this.specialAdditives)
                data["specialAdditives"].push(item.toJSON());
        }
        data["recipeNumber"] = this.recipeNumber;
        data["hour"] = this.hour;
        data["nodeId"] = this.nodeId;
        data["nodeType"] = this.nodeType;
        data["registrationNumber"] = this.registrationNumber;
        data["employeeName"] = this.employeeName;
        data["isPump"] = this.isPump;
        data["structuralElement"] = this.structuralElement;
        data["cancellationReason"] = this.cancellationReason;
        data["comments"] = this.comments;
        data["wzName"] = this.wzName;
        data["wzCount"] = this.wzCount;
        data["personalPickup"] = this.personalPickup;
        data["isOpenToEdit"] = this.isOpenToEdit;
        return data;
    }
}

export interface ISimpleOrderModel {
    id?: string;
    date?: Date;
    orderNo?: string | undefined;
    grossValue?: number;
    nodeName?: string | undefined;
    customerName?: string | undefined;
    contactPhone?: string | undefined;
    author?: string | undefined;
    isOffer?: boolean;
    paymentType?: string | undefined;
    address?: string | undefined;
    orderStatus?: OrderStatusModel;
    itemId?: string;
    itemName?: string | undefined;
    itemCount?: number;
    itemUnit?: string | undefined;
    itemUnitPrice?: number;
    servicePrices?: ItemPriceModel[] | undefined;
    specialAdditives?: ItemPriceModel[] | undefined;
    recipeNumber?: string | undefined;
    hour?: string | undefined;
    nodeId?: string;
    nodeType?: NodeType;
    registrationNumber?: string | undefined;
    employeeName?: string | undefined;
    isPump?: boolean;
    structuralElement?: string | undefined;
    cancellationReason?: string | undefined;
    comments?: string | undefined;
    wzName?: string | undefined;
    wzCount?: number | undefined;
    personalPickup?: boolean;
    isOpenToEdit?: boolean;
}

export class OrdersByHourModel implements IOrdersByHourModel {
    count?: number;
    hour?: string | undefined;
    orders?: SimpleOrderModel[] | undefined;

    constructor(data?: IOrdersByHourModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.hour = _data["hour"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(SimpleOrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrdersByHourModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersByHourModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["hour"] = this.hour;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrdersByHourModel {
    count?: number;
    hour?: string | undefined;
    orders?: SimpleOrderModel[] | undefined;
}

export class OrdersByHourModelResponse implements IOrdersByHourModelResponse {
    result?: OrdersByHourModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrdersByHourModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrdersByHourModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrdersByHourModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersByHourModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrdersByHourModelResponse {
    result?: OrdersByHourModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class CommentsOfDayModel implements ICommentsOfDayModel {
    content?: string | undefined;
    id?: string;

    constructor(data?: ICommentsOfDayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommentsOfDayModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentsOfDayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommentsOfDayModel {
    content?: string | undefined;
    id?: string;
}

export class CommentsOfDayModelResponse implements ICommentsOfDayModelResponse {
    result?: CommentsOfDayModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICommentsOfDayModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CommentsOfDayModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CommentsOfDayModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommentsOfDayModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICommentsOfDayModelResponse {
    result?: CommentsOfDayModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class CustomerOrdersHistoryModel implements ICustomerOrdersHistoryModel {
    orderDate?: Date;
    productName?: string | undefined;
    unitPrice?: number;
    grossValue?: number;
    nodeName?: string | undefined;
    count?: number;
    statusName?: string | undefined;

    constructor(data?: ICustomerOrdersHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.productName = _data["productName"];
            this.unitPrice = _data["unitPrice"];
            this.grossValue = _data["grossValue"];
            this.nodeName = _data["nodeName"];
            this.count = _data["count"];
            this.statusName = _data["statusName"];
        }
    }

    static fromJS(data: any): CustomerOrdersHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOrdersHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["productName"] = this.productName;
        data["unitPrice"] = this.unitPrice;
        data["grossValue"] = this.grossValue;
        data["nodeName"] = this.nodeName;
        data["count"] = this.count;
        data["statusName"] = this.statusName;
        return data;
    }
}

export interface ICustomerOrdersHistoryModel {
    orderDate?: Date;
    productName?: string | undefined;
    unitPrice?: number;
    grossValue?: number;
    nodeName?: string | undefined;
    count?: number;
    statusName?: string | undefined;
}

export class CustomerOrdersHistoryModelResponse implements ICustomerOrdersHistoryModelResponse {
    result?: CustomerOrdersHistoryModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ICustomerOrdersHistoryModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CustomerOrdersHistoryModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): CustomerOrdersHistoryModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOrdersHistoryModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ICustomerOrdersHistoryModelResponse {
    result?: CustomerOrdersHistoryModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SimpleOrderModelPaginationResult implements ISimpleOrderModelPaginationResult {
    readonly result?: SimpleOrderModel[] | undefined;
    total?: number;

    constructor(data?: ISimpleOrderModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SimpleOrderModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SimpleOrderModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleOrderModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ISimpleOrderModelPaginationResult {
    result?: SimpleOrderModel[] | undefined;
    total?: number;
}

export class SimpleOrderModelPaginationResultResponse implements ISimpleOrderModelPaginationResultResponse {
    result?: SimpleOrderModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISimpleOrderModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SimpleOrderModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SimpleOrderModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleOrderModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISimpleOrderModelPaginationResultResponse {
    result?: SimpleOrderModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class ExternalUserOrderModel implements IExternalUserOrderModel {
    id?: string;
    orderNo?: string | undefined;
    nodeName?: string | undefined;
    author?: string | undefined;
    orderStatus?: OrderStatusModel;
    itemName?: string | undefined;
    itemCount?: number;
    itemUnit?: string | undefined;
    hour?: string | undefined;
    nodeId?: string;
    nodeType?: NodeType;
    registrationNumber?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IExternalUserOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.nodeName = _data["nodeName"];
            this.author = _data["author"];
            this.orderStatus = _data["orderStatus"] ? OrderStatusModel.fromJS(_data["orderStatus"]) : <any>undefined;
            this.itemName = _data["itemName"];
            this.itemCount = _data["itemCount"];
            this.itemUnit = _data["itemUnit"];
            this.hour = _data["hour"];
            this.nodeId = _data["nodeId"];
            this.nodeType = _data["nodeType"];
            this.registrationNumber = _data["registrationNumber"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ExternalUserOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["nodeName"] = this.nodeName;
        data["author"] = this.author;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["itemName"] = this.itemName;
        data["itemCount"] = this.itemCount;
        data["itemUnit"] = this.itemUnit;
        data["hour"] = this.hour;
        data["nodeId"] = this.nodeId;
        data["nodeType"] = this.nodeType;
        data["registrationNumber"] = this.registrationNumber;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IExternalUserOrderModel {
    id?: string;
    orderNo?: string | undefined;
    nodeName?: string | undefined;
    author?: string | undefined;
    orderStatus?: OrderStatusModel;
    itemName?: string | undefined;
    itemCount?: number;
    itemUnit?: string | undefined;
    hour?: string | undefined;
    nodeId?: string;
    nodeType?: NodeType;
    registrationNumber?: string | undefined;
    comments?: string | undefined;
}

export class ExternalUserOrderModelPaginationResult implements IExternalUserOrderModelPaginationResult {
    readonly result?: ExternalUserOrderModel[] | undefined;
    total?: number;

    constructor(data?: IExternalUserOrderModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(ExternalUserOrderModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ExternalUserOrderModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserOrderModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IExternalUserOrderModelPaginationResult {
    result?: ExternalUserOrderModel[] | undefined;
    total?: number;
}

export class ExternalUserOrderModelPaginationResultResponse implements IExternalUserOrderModelPaginationResultResponse {
    result?: ExternalUserOrderModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IExternalUserOrderModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ExternalUserOrderModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): ExternalUserOrderModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserOrderModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IExternalUserOrderModelPaginationResultResponse {
    result?: ExternalUserOrderModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OrdersByNodesCallendarModel implements IOrdersByNodesCallendarModel {
    id?: string;
    dateFrom?: Date;
    dateTo?: Date;
    customerName?: string | undefined;
    address?: string | undefined;
    statusColor?: string | undefined;
    pumpName?: string | undefined;
    pearName?: string | undefined;
    itemName?: string | undefined;
    itemCount?: string | undefined;
    nodeId?: string;
    nodeType?: NodeType;
    orderNumber?: string | undefined;

    constructor(data?: IOrdersByNodesCallendarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.address = _data["address"];
            this.statusColor = _data["statusColor"];
            this.pumpName = _data["pumpName"];
            this.pearName = _data["pearName"];
            this.itemName = _data["itemName"];
            this.itemCount = _data["itemCount"];
            this.nodeId = _data["nodeId"];
            this.nodeType = _data["nodeType"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): OrdersByNodesCallendarModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersByNodesCallendarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["address"] = this.address;
        data["statusColor"] = this.statusColor;
        data["pumpName"] = this.pumpName;
        data["pearName"] = this.pearName;
        data["itemName"] = this.itemName;
        data["itemCount"] = this.itemCount;
        data["nodeId"] = this.nodeId;
        data["nodeType"] = this.nodeType;
        data["orderNumber"] = this.orderNumber;
        return data;
    }
}

export interface IOrdersByNodesCallendarModel {
    id?: string;
    dateFrom?: Date;
    dateTo?: Date;
    customerName?: string | undefined;
    address?: string | undefined;
    statusColor?: string | undefined;
    pumpName?: string | undefined;
    pearName?: string | undefined;
    itemName?: string | undefined;
    itemCount?: string | undefined;
    nodeId?: string;
    nodeType?: NodeType;
    orderNumber?: string | undefined;
}

export class OrdersByNodesCallendarModelIEnumerableResponse implements IOrdersByNodesCallendarModelIEnumerableResponse {
    readonly result?: OrdersByNodesCallendarModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrdersByNodesCallendarModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OrdersByNodesCallendarModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrdersByNodesCallendarModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersByNodesCallendarModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrdersByNodesCallendarModelIEnumerableResponse {
    result?: OrdersByNodesCallendarModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OrderEditHistoryModel implements IOrderEditHistoryModel {
    date?: Date;
    user?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IOrderEditHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): OrderEditHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEditHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IOrderEditHistoryModel {
    date?: Date;
    user?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class OrderEditHistoryModelPaginationResult implements IOrderEditHistoryModelPaginationResult {
    readonly result?: OrderEditHistoryModel[] | undefined;
    total?: number;

    constructor(data?: IOrderEditHistoryModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OrderEditHistoryModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): OrderEditHistoryModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEditHistoryModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IOrderEditHistoryModelPaginationResult {
    result?: OrderEditHistoryModel[] | undefined;
    total?: number;
}

export class OrderEditHistoryModelPaginationResultResponse implements IOrderEditHistoryModelPaginationResultResponse {
    result?: OrderEditHistoryModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderEditHistoryModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrderEditHistoryModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderEditHistoryModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEditHistoryModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderEditHistoryModelPaginationResultResponse {
    result?: OrderEditHistoryModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddOrderStatusCommand implements IAddOrderStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;

    constructor(data?: IAddOrderStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.idState = _data["idState"];
        }
    }

    static fromJS(data: any): AddOrderStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["idState"] = this.idState;
        return data;
    }
}

export interface IAddOrderStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;
}

export class UpdateOrderStatusCommand implements IUpdateOrderStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;

    constructor(data?: IUpdateOrderStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.idState = _data["idState"];
        }
    }

    static fromJS(data: any): UpdateOrderStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["idState"] = this.idState;
        return data;
    }
}

export interface IUpdateOrderStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;
}

export class OrderStatusModelIEnumerableResponse implements IOrderStatusModelIEnumerableResponse {
    readonly result?: OrderStatusModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderStatusModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OrderStatusModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderStatusModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderStatusModelIEnumerableResponse {
    result?: OrderStatusModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OrderStatusModelResponse implements IOrderStatusModelResponse {
    result?: OrderStatusModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderStatusModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrderStatusModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderStatusModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderStatusModelResponse {
    result?: OrderStatusModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OrderStatusModelPaginationResult implements IOrderStatusModelPaginationResult {
    readonly result?: OrderStatusModel[] | undefined;
    total?: number;

    constructor(data?: IOrderStatusModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(OrderStatusModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): OrderStatusModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IOrderStatusModelPaginationResult {
    result?: OrderStatusModel[] | undefined;
    total?: number;
}

export class OrderStatusModelPaginationResultResponse implements IOrderStatusModelPaginationResultResponse {
    result?: OrderStatusModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderStatusModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrderStatusModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderStatusModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderStatusModelPaginationResultResponse {
    result?: OrderStatusModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class GetOrderStatusesForSelectQuery implements IGetOrderStatusesForSelectQuery {

    constructor(data?: IGetOrderStatusesForSelectQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderStatusesForSelectQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderStatusesForSelectQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrderStatusesForSelectQuery {
}

export class PaymentTypeModel implements IPaymentTypeModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPaymentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPaymentTypeModel {
    id?: number;
    name?: string | undefined;
}

export class PaymentTypeModelIEnumerableResponse implements IPaymentTypeModelIEnumerableResponse {
    readonly result?: PaymentTypeModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IPaymentTypeModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(PaymentTypeModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): PaymentTypeModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IPaymentTypeModelIEnumerableResponse {
    result?: PaymentTypeModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class RecipeCostModel implements IRecipeCostModel {
    id?: string;
    recipeNumber?: string | undefined;
    name?: string | undefined;
    cost?: number;
    recipeIngredients?: RecipeIngredientModel[] | undefined;

    constructor(data?: IRecipeCostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeNumber = _data["recipeNumber"];
            this.name = _data["name"];
            this.cost = _data["cost"];
            if (Array.isArray(_data["recipeIngredients"])) {
                this.recipeIngredients = [] as any;
                for (let item of _data["recipeIngredients"])
                    this.recipeIngredients!.push(RecipeIngredientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipeCostModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeNumber"] = this.recipeNumber;
        data["name"] = this.name;
        data["cost"] = this.cost;
        if (Array.isArray(this.recipeIngredients)) {
            data["recipeIngredients"] = [];
            for (let item of this.recipeIngredients)
                data["recipeIngredients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecipeCostModel {
    id?: string;
    recipeNumber?: string | undefined;
    name?: string | undefined;
    cost?: number;
    recipeIngredients?: RecipeIngredientModel[] | undefined;
}

export class RecipeIngredientModel implements IRecipeIngredientModel {
    id?: string;
    recipeCostId?: string;
    recipeCost?: RecipeCostModel;
    ingredientId?: string;
    ingredient?: IngredientModel;
    quantity?: number | undefined;

    constructor(data?: IRecipeIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recipeCostId = _data["recipeCostId"];
            this.recipeCost = _data["recipeCost"] ? RecipeCostModel.fromJS(_data["recipeCost"]) : <any>undefined;
            this.ingredientId = _data["ingredientId"];
            this.ingredient = _data["ingredient"] ? IngredientModel.fromJS(_data["ingredient"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): RecipeIngredientModel {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeIngredientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeCostId"] = this.recipeCostId;
        data["recipeCost"] = this.recipeCost ? this.recipeCost.toJSON() : <any>undefined;
        data["ingredientId"] = this.ingredientId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IRecipeIngredientModel {
    id?: string;
    recipeCostId?: string;
    recipeCost?: RecipeCostModel;
    ingredientId?: string;
    ingredient?: IngredientModel;
    quantity?: number | undefined;
}

export class AddRecipeCostCommand implements IAddRecipeCostCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    cost?: number;
    recipeIngredients?: RecipeIngredientModel[] | undefined;

    constructor(data?: IAddRecipeCostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.recipeNumber = _data["recipeNumber"];
            this.cost = _data["cost"];
            if (Array.isArray(_data["recipeIngredients"])) {
                this.recipeIngredients = [] as any;
                for (let item of _data["recipeIngredients"])
                    this.recipeIngredients!.push(RecipeIngredientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddRecipeCostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddRecipeCostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["recipeNumber"] = this.recipeNumber;
        data["cost"] = this.cost;
        if (Array.isArray(this.recipeIngredients)) {
            data["recipeIngredients"] = [];
            for (let item of this.recipeIngredients)
                data["recipeIngredients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddRecipeCostCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    cost?: number;
    recipeIngredients?: RecipeIngredientModel[] | undefined;
}

export class UpdateRecipeCostCommand implements IUpdateRecipeCostCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    cost?: number;
    recipeIngredients?: RecipeIngredientModel[] | undefined;

    constructor(data?: IUpdateRecipeCostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.recipeNumber = _data["recipeNumber"];
            this.cost = _data["cost"];
            if (Array.isArray(_data["recipeIngredients"])) {
                this.recipeIngredients = [] as any;
                for (let item of _data["recipeIngredients"])
                    this.recipeIngredients!.push(RecipeIngredientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRecipeCostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecipeCostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["recipeNumber"] = this.recipeNumber;
        data["cost"] = this.cost;
        if (Array.isArray(this.recipeIngredients)) {
            data["recipeIngredients"] = [];
            for (let item of this.recipeIngredients)
                data["recipeIngredients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateRecipeCostCommand {
    id?: string;
    name?: string | undefined;
    recipeNumber?: string | undefined;
    cost?: number;
    recipeIngredients?: RecipeIngredientModel[] | undefined;
}

export class RecipeCostModelResponse implements IRecipeCostModelResponse {
    result?: RecipeCostModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IRecipeCostModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? RecipeCostModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): RecipeCostModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCostModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IRecipeCostModelResponse {
    result?: RecipeCostModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class RecipeCostModelPaginationResult implements IRecipeCostModelPaginationResult {
    readonly result?: RecipeCostModel[] | undefined;
    total?: number;

    constructor(data?: IRecipeCostModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(RecipeCostModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): RecipeCostModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCostModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IRecipeCostModelPaginationResult {
    result?: RecipeCostModel[] | undefined;
    total?: number;
}

export class RecipeCostModelPaginationResultResponse implements IRecipeCostModelPaginationResultResponse {
    result?: RecipeCostModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IRecipeCostModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? RecipeCostModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): RecipeCostModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCostModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IRecipeCostModelPaginationResultResponse {
    result?: RecipeCostModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class CreateSettlementCommand implements ICreateSettlementCommand {
    nodeId?: string;
    orderId?: string | undefined;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentTypeId?: number | undefined;
    isReceipt?: boolean;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;

    constructor(data?: ICreateSettlementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            this.orderId = _data["orderId"];
            this.wz = _data["wz"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.product = _data["product"];
            this.recipes = _data["recipes"];
            this.itemCount = _data["itemCount"];
            this.itemPrice = _data["itemPrice"];
            this.pumpPrice = _data["pumpPrice"];
            this.chemistryPrice = _data["chemistryPrice"];
            this.reinforcementPrice = _data["reinforcementPrice"];
            this.transportPrice = _data["transportPrice"];
            this.heatingPrice = _data["heatingPrice"];
            this.additionalPrice = _data["additionalPrice"];
            this.sumPrice = _data["sumPrice"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.isReceipt = _data["isReceipt"];
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
        }
    }

    static fromJS(data: any): CreateSettlementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSettlementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["orderId"] = this.orderId;
        data["wz"] = this.wz;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["product"] = this.product;
        data["recipes"] = this.recipes;
        data["itemCount"] = this.itemCount;
        data["itemPrice"] = this.itemPrice;
        data["pumpPrice"] = this.pumpPrice;
        data["chemistryPrice"] = this.chemistryPrice;
        data["reinforcementPrice"] = this.reinforcementPrice;
        data["transportPrice"] = this.transportPrice;
        data["heatingPrice"] = this.heatingPrice;
        data["additionalPrice"] = this.additionalPrice;
        data["sumPrice"] = this.sumPrice;
        data["paymentTypeId"] = this.paymentTypeId;
        data["isReceipt"] = this.isReceipt;
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        return data;
    }
}

export interface ICreateSettlementCommand {
    nodeId?: string;
    orderId?: string | undefined;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentTypeId?: number | undefined;
    isReceipt?: boolean;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
}

export class UpdateSettlementCommand implements IUpdateSettlementCommand {
    id?: string;
    orderId?: string | undefined;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentTypeId?: number | undefined;
    isReceipt?: boolean;
    status?: SettlementStatuses;

    constructor(data?: IUpdateSettlementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.wz = _data["wz"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.product = _data["product"];
            this.recipes = _data["recipes"];
            this.itemCount = _data["itemCount"];
            this.itemPrice = _data["itemPrice"];
            this.pumpPrice = _data["pumpPrice"];
            this.chemistryPrice = _data["chemistryPrice"];
            this.reinforcementPrice = _data["reinforcementPrice"];
            this.transportPrice = _data["transportPrice"];
            this.heatingPrice = _data["heatingPrice"];
            this.additionalPrice = _data["additionalPrice"];
            this.sumPrice = _data["sumPrice"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.isReceipt = _data["isReceipt"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateSettlementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSettlementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["wz"] = this.wz;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["product"] = this.product;
        data["recipes"] = this.recipes;
        data["itemCount"] = this.itemCount;
        data["itemPrice"] = this.itemPrice;
        data["pumpPrice"] = this.pumpPrice;
        data["chemistryPrice"] = this.chemistryPrice;
        data["reinforcementPrice"] = this.reinforcementPrice;
        data["transportPrice"] = this.transportPrice;
        data["heatingPrice"] = this.heatingPrice;
        data["additionalPrice"] = this.additionalPrice;
        data["sumPrice"] = this.sumPrice;
        data["paymentTypeId"] = this.paymentTypeId;
        data["isReceipt"] = this.isReceipt;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateSettlementCommand {
    id?: string;
    orderId?: string | undefined;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentTypeId?: number | undefined;
    isReceipt?: boolean;
    status?: SettlementStatuses;
}

export class SettlementModel implements ISettlementModel {
    id?: string;
    nodeId?: string;
    order?: OrderModel;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentType?: PaymentTypeModel;
    isReceipt?: boolean;
    status?: SettlementStatuses;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;

    constructor(data?: ISettlementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nodeId = _data["nodeId"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.wz = _data["wz"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.product = _data["product"];
            this.recipes = _data["recipes"];
            this.itemCount = _data["itemCount"];
            this.itemPrice = _data["itemPrice"];
            this.pumpPrice = _data["pumpPrice"];
            this.chemistryPrice = _data["chemistryPrice"];
            this.reinforcementPrice = _data["reinforcementPrice"];
            this.transportPrice = _data["transportPrice"];
            this.heatingPrice = _data["heatingPrice"];
            this.additionalPrice = _data["additionalPrice"];
            this.sumPrice = _data["sumPrice"];
            this.paymentType = _data["paymentType"] ? PaymentTypeModel.fromJS(_data["paymentType"]) : <any>undefined;
            this.isReceipt = _data["isReceipt"];
            this.status = _data["status"];
            this.externalId = _data["externalId"];
            this.externalSystem = _data["externalSystem"];
        }
    }

    static fromJS(data: any): SettlementModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nodeId"] = this.nodeId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["wz"] = this.wz;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["product"] = this.product;
        data["recipes"] = this.recipes;
        data["itemCount"] = this.itemCount;
        data["itemPrice"] = this.itemPrice;
        data["pumpPrice"] = this.pumpPrice;
        data["chemistryPrice"] = this.chemistryPrice;
        data["reinforcementPrice"] = this.reinforcementPrice;
        data["transportPrice"] = this.transportPrice;
        data["heatingPrice"] = this.heatingPrice;
        data["additionalPrice"] = this.additionalPrice;
        data["sumPrice"] = this.sumPrice;
        data["paymentType"] = this.paymentType ? this.paymentType.toJSON() : <any>undefined;
        data["isReceipt"] = this.isReceipt;
        data["status"] = this.status;
        data["externalId"] = this.externalId;
        data["externalSystem"] = this.externalSystem;
        return data;
    }
}

export interface ISettlementModel {
    id?: string;
    nodeId?: string;
    order?: OrderModel;
    wz?: string | undefined;
    date?: Date;
    customer?: string | undefined;
    address?: string | undefined;
    product?: string | undefined;
    recipes?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    pumpPrice?: number;
    chemistryPrice?: number;
    reinforcementPrice?: number;
    transportPrice?: number;
    heatingPrice?: number;
    additionalPrice?: number;
    sumPrice?: number;
    paymentType?: PaymentTypeModel;
    isReceipt?: boolean;
    status?: SettlementStatuses;
    externalId?: string | undefined;
    externalSystem?: ExternalSystems;
}

export class SettlementModelPaginationResult implements ISettlementModelPaginationResult {
    readonly result?: SettlementModel[] | undefined;
    total?: number;

    constructor(data?: ISettlementModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SettlementModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SettlementModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ISettlementModelPaginationResult {
    result?: SettlementModel[] | undefined;
    total?: number;
}

export class SettlementModelPaginationResultResponse implements ISettlementModelPaginationResultResponse {
    result?: SettlementModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISettlementModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SettlementModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SettlementModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISettlementModelPaginationResultResponse {
    result?: SettlementModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddSpecialAdditiveCommand implements IAddSpecialAdditiveCommand {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    addressId?: string | undefined;

    constructor(data?: IAddSpecialAdditiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.weight = _data["weight"];
            this.isForHigherClass = _data["isForHigherClass"];
            this.customerId = _data["customerId"];
            this.addressId = _data["addressId"];
        }
    }

    static fromJS(data: any): AddSpecialAdditiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddSpecialAdditiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["weight"] = this.weight;
        data["isForHigherClass"] = this.isForHigherClass;
        data["customerId"] = this.customerId;
        data["addressId"] = this.addressId;
        return data;
    }
}

export interface IAddSpecialAdditiveCommand {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    addressId?: string | undefined;
}

export class UpdateSpecialAdditiveCommand implements IUpdateSpecialAdditiveCommand {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    addressId?: string | undefined;

    constructor(data?: IUpdateSpecialAdditiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.unitPrice = _data["unitPrice"];
            this.weight = _data["weight"];
            this.isForHigherClass = _data["isForHigherClass"];
            this.customerId = _data["customerId"];
            this.addressId = _data["addressId"];
        }
    }

    static fromJS(data: any): UpdateSpecialAdditiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpecialAdditiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["weight"] = this.weight;
        data["isForHigherClass"] = this.isForHigherClass;
        data["customerId"] = this.customerId;
        data["addressId"] = this.addressId;
        return data;
    }
}

export interface IUpdateSpecialAdditiveCommand {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    unitPrice?: number;
    weight?: number;
    isForHigherClass?: boolean;
    customerId?: string | undefined;
    addressId?: string | undefined;
}

export class SpecialAdditivesSelectModelResponse implements ISpecialAdditivesSelectModelResponse {
    result?: SpecialAdditivesSelectModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISpecialAdditivesSelectModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SpecialAdditivesSelectModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SpecialAdditivesSelectModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialAdditivesSelectModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISpecialAdditivesSelectModelResponse {
    result?: SpecialAdditivesSelectModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SpecialAdditivesSelectModelPaginationResult implements ISpecialAdditivesSelectModelPaginationResult {
    readonly result?: SpecialAdditivesSelectModel[] | undefined;
    total?: number;

    constructor(data?: ISpecialAdditivesSelectModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SpecialAdditivesSelectModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SpecialAdditivesSelectModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialAdditivesSelectModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ISpecialAdditivesSelectModelPaginationResult {
    result?: SpecialAdditivesSelectModel[] | undefined;
    total?: number;
}

export class SpecialAdditivesSelectModelPaginationResultResponse implements ISpecialAdditivesSelectModelPaginationResultResponse {
    result?: SpecialAdditivesSelectModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISpecialAdditivesSelectModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SpecialAdditivesSelectModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SpecialAdditivesSelectModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialAdditivesSelectModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISpecialAdditivesSelectModelPaginationResultResponse {
    result?: SpecialAdditivesSelectModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddStructuralElementCommand implements IAddStructuralElementCommand {
    id?: string;
    name?: string | undefined;

    constructor(data?: IAddStructuralElementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddStructuralElementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddStructuralElementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAddStructuralElementCommand {
    id?: string;
    name?: string | undefined;
}

export class UpdateStructuralElementCommand implements IUpdateStructuralElementCommand {
    id?: string;
    name?: string | undefined;

    constructor(data?: IUpdateStructuralElementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStructuralElementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStructuralElementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStructuralElementCommand {
    id?: string;
    name?: string | undefined;
}

export class StructuralElementModel implements IStructuralElementModel {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IStructuralElementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StructuralElementModel {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralElementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStructuralElementModel {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
}

export class StructuralElementModelIEnumerableResponse implements IStructuralElementModelIEnumerableResponse {
    readonly result?: StructuralElementModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IStructuralElementModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(StructuralElementModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): StructuralElementModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralElementModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IStructuralElementModelIEnumerableResponse {
    result?: StructuralElementModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class StructuralElementModelResponse implements IStructuralElementModelResponse {
    result?: StructuralElementModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IStructuralElementModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? StructuralElementModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): StructuralElementModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralElementModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IStructuralElementModelResponse {
    result?: StructuralElementModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class StructuralElementModelPaginationResult implements IStructuralElementModelPaginationResult {
    readonly result?: StructuralElementModel[] | undefined;
    total?: number;

    constructor(data?: IStructuralElementModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(StructuralElementModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): StructuralElementModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralElementModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IStructuralElementModelPaginationResult {
    result?: StructuralElementModel[] | undefined;
    total?: number;
}

export class StructuralElementModelPaginationResultResponse implements IStructuralElementModelPaginationResultResponse {
    result?: StructuralElementModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IStructuralElementModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? StructuralElementModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): StructuralElementModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StructuralElementModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IStructuralElementModelPaginationResultResponse {
    result?: StructuralElementModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddSupplyCommand implements IAddSupplyCommand {
    id?: string;
    count?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    supplyStatusId?: string | undefined;
    orderItemsIds?: string[] | undefined;

    constructor(data?: IAddSupplyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.supplyStatusId = _data["supplyStatusId"];
            if (Array.isArray(_data["orderItemsIds"])) {
                this.orderItemsIds = [] as any;
                for (let item of _data["orderItemsIds"])
                    this.orderItemsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddSupplyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddSupplyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["supplyStatusId"] = this.supplyStatusId;
        if (Array.isArray(this.orderItemsIds)) {
            data["orderItemsIds"] = [];
            for (let item of this.orderItemsIds)
                data["orderItemsIds"].push(item);
        }
        return data;
    }
}

export interface IAddSupplyCommand {
    id?: string;
    count?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    supplyStatusId?: string | undefined;
    orderItemsIds?: string[] | undefined;
}

export class UpdateSupplyCommand implements IUpdateSupplyCommand {
    id?: string;
    count?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    supplyStatusId?: string | undefined;
    orderItemsIds?: string[] | undefined;

    constructor(data?: IUpdateSupplyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.supplyStatusId = _data["supplyStatusId"];
            if (Array.isArray(_data["orderItemsIds"])) {
                this.orderItemsIds = [] as any;
                for (let item of _data["orderItemsIds"])
                    this.orderItemsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSupplyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupplyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["supplyStatusId"] = this.supplyStatusId;
        if (Array.isArray(this.orderItemsIds)) {
            data["orderItemsIds"] = [];
            for (let item of this.orderItemsIds)
                data["orderItemsIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateSupplyCommand {
    id?: string;
    count?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    supplyStatusId?: string | undefined;
    orderItemsIds?: string[] | undefined;
}

export class SupplyModelIEnumerableResponse implements ISupplyModelIEnumerableResponse {
    readonly result?: SupplyModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SupplyModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyModelIEnumerableResponse {
    result?: SupplyModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OpenGateCommand implements IOpenGateCommand {
    nodeId?: string;
    registrationNumber?: string | undefined;

    constructor(data?: IOpenGateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): OpenGateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OpenGateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}

export interface IOpenGateCommand {
    nodeId?: string;
    registrationNumber?: string | undefined;
}

export class AddWeightingCommand implements IAddWeightingCommand {
    nodeId?: string;
    registrationNumber?: string | undefined;

    constructor(data?: IAddWeightingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): AddWeightingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddWeightingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}

export interface IAddWeightingCommand {
    nodeId?: string;
    registrationNumber?: string | undefined;
}

export class SupplyModelResponse implements ISupplyModelResponse {
    result?: SupplyModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SupplyModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyModelResponse {
    result?: SupplyModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class UpdateSupplyCarAndDateCommand implements IUpdateSupplyCarAndDateCommand {
    id?: string;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;

    constructor(data?: IUpdateSupplyCarAndDateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateSupplyCarAndDateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupplyCarAndDateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateSupplyCarAndDateCommand {
    id?: string;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
}

export class SupplyWithOrderDatesModel implements ISupplyWithOrderDatesModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    supplyStatusId?: string | undefined;
    employeeId?: string | undefined;
    address?: AddressModel;
    car?: CarModel;
    supplyStatus?: SupplyStatusModel;
    orderItemsIds?: string[] | undefined;
    orderDateFrom?: Date;
    orderDateTo?: Date;

    constructor(data?: ISupplyWithOrderDatesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.carId = _data["carId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.addressId = _data["addressId"];
            this.supplyStatusId = _data["supplyStatusId"];
            this.employeeId = _data["employeeId"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.car = _data["car"] ? CarModel.fromJS(_data["car"]) : <any>undefined;
            this.supplyStatus = _data["supplyStatus"] ? SupplyStatusModel.fromJS(_data["supplyStatus"]) : <any>undefined;
            if (Array.isArray(_data["orderItemsIds"])) {
                this.orderItemsIds = [] as any;
                for (let item of _data["orderItemsIds"])
                    this.orderItemsIds!.push(item);
            }
            this.orderDateFrom = _data["orderDateFrom"] ? new Date(_data["orderDateFrom"].toString()) : <any>undefined;
            this.orderDateTo = _data["orderDateTo"] ? new Date(_data["orderDateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SupplyWithOrderDatesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyWithOrderDatesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["price"] = this.price;
        data["carId"] = this.carId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["addressId"] = this.addressId;
        data["supplyStatusId"] = this.supplyStatusId;
        data["employeeId"] = this.employeeId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        data["supplyStatus"] = this.supplyStatus ? this.supplyStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemsIds)) {
            data["orderItemsIds"] = [];
            for (let item of this.orderItemsIds)
                data["orderItemsIds"].push(item);
        }
        data["orderDateFrom"] = this.orderDateFrom ? this.orderDateFrom.toISOString() : <any>undefined;
        data["orderDateTo"] = this.orderDateTo ? this.orderDateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISupplyWithOrderDatesModel {
    id?: string;
    count?: number;
    price?: number;
    carId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    addressId?: string | undefined;
    supplyStatusId?: string | undefined;
    employeeId?: string | undefined;
    address?: AddressModel;
    car?: CarModel;
    supplyStatus?: SupplyStatusModel;
    orderItemsIds?: string[] | undefined;
    orderDateFrom?: Date;
    orderDateTo?: Date;
}

export class SupplyWithOrderDatesModelResponse implements ISupplyWithOrderDatesModelResponse {
    result?: SupplyWithOrderDatesModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyWithOrderDatesModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SupplyWithOrderDatesModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyWithOrderDatesModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyWithOrderDatesModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyWithOrderDatesModelResponse {
    result?: SupplyWithOrderDatesModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SupplyModelPaginationResult implements ISupplyModelPaginationResult {
    readonly result?: SupplyModel[] | undefined;
    total?: number;

    constructor(data?: ISupplyModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SupplyModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SupplyModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ISupplyModelPaginationResult {
    result?: SupplyModel[] | undefined;
    total?: number;
}

export class SupplyModelPaginationResultResponse implements ISupplyModelPaginationResultResponse {
    result?: SupplyModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SupplyModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyModelPaginationResultResponse {
    result?: SupplyModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SimpleItemModel implements ISimpleItemModel {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    productOrService?: string | undefined;
    itemTypeName?: string | undefined;
    itemTypeId?: string | undefined;

    constructor(data?: ISimpleItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.productOrService = _data["productOrService"];
            this.itemTypeName = _data["itemTypeName"];
            this.itemTypeId = _data["itemTypeId"];
        }
    }

    static fromJS(data: any): SimpleItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["productOrService"] = this.productOrService;
        data["itemTypeName"] = this.itemTypeName;
        data["itemTypeId"] = this.itemTypeId;
        return data;
    }
}

export interface ISimpleItemModel {
    id?: string;
    name?: string | undefined;
    unit?: string | undefined;
    productOrService?: string | undefined;
    itemTypeName?: string | undefined;
    itemTypeId?: string | undefined;
}

export class SupplyForDriverModel implements ISupplyForDriverModel {
    id?: string;
    orderId?: string;
    supplyStatus?: SupplyStatusModel;
    dateFrom?: Date;
    dateTo?: Date;
    address?: AddressModel;
    car?: CarModel;
    items?: SimpleItemModel[] | undefined;
    price?: number;
    count?: number;
    nodeId?: string;

    constructor(data?: ISupplyForDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.supplyStatus = _data["supplyStatus"] ? SupplyStatusModel.fromJS(_data["supplyStatus"]) : <any>undefined;
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : <any>undefined;
            this.car = _data["car"] ? CarModel.fromJS(_data["car"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleItemModel.fromJS(item));
            }
            this.price = _data["price"];
            this.count = _data["count"];
            this.nodeId = _data["nodeId"];
        }
    }

    static fromJS(data: any): SupplyForDriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyForDriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["supplyStatus"] = this.supplyStatus ? this.supplyStatus.toJSON() : <any>undefined;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["price"] = this.price;
        data["count"] = this.count;
        data["nodeId"] = this.nodeId;
        return data;
    }
}

export interface ISupplyForDriverModel {
    id?: string;
    orderId?: string;
    supplyStatus?: SupplyStatusModel;
    dateFrom?: Date;
    dateTo?: Date;
    address?: AddressModel;
    car?: CarModel;
    items?: SimpleItemModel[] | undefined;
    price?: number;
    count?: number;
    nodeId?: string;
}

export class SupplyForDriverModelIEnumerableResponse implements ISupplyForDriverModelIEnumerableResponse {
    readonly result?: SupplyForDriverModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyForDriverModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SupplyForDriverModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyForDriverModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyForDriverModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyForDriverModelIEnumerableResponse {
    result?: SupplyForDriverModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SupplyForDriverModelResponse implements ISupplyForDriverModelResponse {
    result?: SupplyForDriverModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyForDriverModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SupplyForDriverModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyForDriverModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyForDriverModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyForDriverModelResponse {
    result?: SupplyForDriverModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class DecimalResponse implements IDecimalResponse {
    readonly result?: number;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IDecimalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"];
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): DecimalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IDecimalResponse {
    result?: number;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddSupplyStatusCommand implements IAddSupplyStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;

    constructor(data?: IAddSupplyStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.idState = _data["idState"];
        }
    }

    static fromJS(data: any): AddSupplyStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddSupplyStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["idState"] = this.idState;
        return data;
    }
}

export interface IAddSupplyStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;
}

export class UpdateSupplyStatusCommand implements IUpdateSupplyStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;

    constructor(data?: IUpdateSupplyStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.idState = _data["idState"];
        }
    }

    static fromJS(data: any): UpdateSupplyStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupplyStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["idState"] = this.idState;
        return data;
    }
}

export interface IUpdateSupplyStatusCommand {
    id?: string;
    name?: string | undefined;
    color?: string | undefined;
    idState?: number;
}

export class SupplyStatusModelIEnumerableResponse implements ISupplyStatusModelIEnumerableResponse {
    readonly result?: SupplyStatusModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyStatusModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SupplyStatusModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyStatusModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyStatusModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyStatusModelIEnumerableResponse {
    result?: SupplyStatusModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SupplyStatusModelResponse implements ISupplyStatusModelResponse {
    result?: SupplyStatusModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyStatusModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SupplyStatusModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyStatusModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyStatusModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyStatusModelResponse {
    result?: SupplyStatusModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class SupplyStatusModelPaginationResult implements ISupplyStatusModelPaginationResult {
    readonly result?: SupplyStatusModel[] | undefined;
    total?: number;

    constructor(data?: ISupplyStatusModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(SupplyStatusModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SupplyStatusModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyStatusModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ISupplyStatusModelPaginationResult {
    result?: SupplyStatusModel[] | undefined;
    total?: number;
}

export class SupplyStatusModelPaginationResultResponse implements ISupplyStatusModelPaginationResultResponse {
    result?: SupplyStatusModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ISupplyStatusModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SupplyStatusModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): SupplyStatusModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyStatusModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ISupplyStatusModelPaginationResultResponse {
    result?: SupplyStatusModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class GetSupplyStatusesForSelectQuery implements IGetSupplyStatusesForSelectQuery {

    constructor(data?: IGetSupplyStatusesForSelectQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSupplyStatusesForSelectQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplyStatusesForSelectQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSupplyStatusesForSelectQuery {
}

export class TransactionBaseModel implements ITransactionBaseModel {
    id?: string;
    postingDate?: Date;
    effectiveDate?: Date;
    clientName?: string | undefined;
    paymentTitle?: string | undefined;
    amount?: number;
    balanceAfterPayment?: number;
    currentAmount?: number;
    isServed?: boolean;
    attachmentId?: string;
    customer?: CustomerModel;

    constructor(data?: ITransactionBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.clientName = _data["clientName"];
            this.paymentTitle = _data["paymentTitle"];
            this.amount = _data["amount"];
            this.balanceAfterPayment = _data["balanceAfterPayment"];
            this.currentAmount = _data["currentAmount"];
            this.isServed = _data["isServed"];
            this.attachmentId = _data["attachmentId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["clientName"] = this.clientName;
        data["paymentTitle"] = this.paymentTitle;
        data["amount"] = this.amount;
        data["balanceAfterPayment"] = this.balanceAfterPayment;
        data["currentAmount"] = this.currentAmount;
        data["isServed"] = this.isServed;
        data["attachmentId"] = this.attachmentId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITransactionBaseModel {
    id?: string;
    postingDate?: Date;
    effectiveDate?: Date;
    clientName?: string | undefined;
    paymentTitle?: string | undefined;
    amount?: number;
    balanceAfterPayment?: number;
    currentAmount?: number;
    isServed?: boolean;
    attachmentId?: string;
    customer?: CustomerModel;
}

export class TransactionBaseModelPaginationResult implements ITransactionBaseModelPaginationResult {
    readonly result?: TransactionBaseModel[] | undefined;
    total?: number;

    constructor(data?: ITransactionBaseModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(TransactionBaseModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): TransactionBaseModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionBaseModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ITransactionBaseModelPaginationResult {
    result?: TransactionBaseModel[] | undefined;
    total?: number;
}

export class TransactionBaseModelPaginationResultResponse implements ITransactionBaseModelPaginationResultResponse {
    result?: TransactionBaseModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: ITransactionBaseModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TransactionBaseModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): TransactionBaseModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionBaseModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface ITransactionBaseModelPaginationResultResponse {
    result?: TransactionBaseModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class AddWeightCommand implements IAddWeightCommand {
    id?: string;
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    supplyId?: string | undefined;

    constructor(data?: IAddWeightCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationNumber = _data["registrationNumber"];
            this.weight = _data["weight"];
            this.orderId = _data["orderId"];
            this.supplyId = _data["supplyId"];
        }
    }

    static fromJS(data: any): AddWeightCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddWeightCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationNumber"] = this.registrationNumber;
        data["weight"] = this.weight;
        data["orderId"] = this.orderId;
        data["supplyId"] = this.supplyId;
        return data;
    }
}

export interface IAddWeightCommand {
    id?: string;
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    supplyId?: string | undefined;
}

export class UpdateWeightCommand implements IUpdateWeightCommand {
    id?: string;
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    supplyId?: string | undefined;

    constructor(data?: IUpdateWeightCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationNumber = _data["registrationNumber"];
            this.weight = _data["weight"];
            this.orderId = _data["orderId"];
            this.supplyId = _data["supplyId"];
        }
    }

    static fromJS(data: any): UpdateWeightCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWeightCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationNumber"] = this.registrationNumber;
        data["weight"] = this.weight;
        data["orderId"] = this.orderId;
        data["supplyId"] = this.supplyId;
        return data;
    }
}

export interface IUpdateWeightCommand {
    id?: string;
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    supplyId?: string | undefined;
}

export class WeightModel implements IWeightModel {
    id?: string;
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    order?: OrderModel;
    supplyId?: string | undefined;
    supply?: SupplyModel;

    constructor(data?: IWeightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registrationNumber = _data["registrationNumber"];
            this.weight = _data["weight"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.supplyId = _data["supplyId"];
            this.supply = _data["supply"] ? SupplyModel.fromJS(_data["supply"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WeightModel {
        data = typeof data === 'object' ? data : {};
        let result = new WeightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationNumber"] = this.registrationNumber;
        data["weight"] = this.weight;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["supplyId"] = this.supplyId;
        data["supply"] = this.supply ? this.supply.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWeightModel {
    id?: string;
    registrationNumber?: string | undefined;
    weight?: number;
    orderId?: string;
    order?: OrderModel;
    supplyId?: string | undefined;
    supply?: SupplyModel;
}

export class WeightModelIEnumerableResponse implements IWeightModelIEnumerableResponse {
    readonly result?: WeightModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IWeightModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(WeightModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): WeightModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeightModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IWeightModelIEnumerableResponse {
    result?: WeightModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class OrderSupplyModel implements IOrderSupplyModel {
    fileName?: string | undefined;
    wzDocumentName?: string | undefined;

    constructor(data?: IOrderSupplyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.wzDocumentName = _data["wzDocumentName"];
        }
    }

    static fromJS(data: any): OrderSupplyModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSupplyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["wzDocumentName"] = this.wzDocumentName;
        return data;
    }
}

export interface IOrderSupplyModel {
    fileName?: string | undefined;
    wzDocumentName?: string | undefined;
}

export class OrderSupplyModelResponse implements IOrderSupplyModelResponse {
    result?: OrderSupplyModel;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IOrderSupplyModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrderSupplyModel.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): OrderSupplyModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSupplyModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IOrderSupplyModelResponse {
    result?: OrderSupplyModel;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class WZDocumentsModel implements IWZDocumentsModel {
    id?: string;
    name?: string | undefined;
    number?: number;
    supplyId?: string;
    supply?: SupplyModel;
    wzStatusId?: string;
    wzStatusName?: string | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    createDate?: Date;
    count?: number;
    productName?: string | undefined;
    unit?: string | undefined;
    customerId?: string;
    customer?: CustomerModel;
    invoiced?: boolean;

    constructor(data?: IWZDocumentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.supplyId = _data["supplyId"];
            this.supply = _data["supply"] ? SupplyModel.fromJS(_data["supply"]) : <any>undefined;
            this.wzStatusId = _data["wzStatusId"];
            this.wzStatusName = _data["wzStatusName"];
            this.createUserFirstName = _data["createUserFirstName"];
            this.createUserLastName = _data["createUserLastName"];
            this.lmUserFirstName = _data["lmUserFirstName"];
            this.lmUserLastName = _data["lmUserLastName"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.count = _data["count"];
            this.productName = _data["productName"];
            this.unit = _data["unit"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.invoiced = _data["invoiced"];
        }
    }

    static fromJS(data: any): WZDocumentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new WZDocumentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["supplyId"] = this.supplyId;
        data["supply"] = this.supply ? this.supply.toJSON() : <any>undefined;
        data["wzStatusId"] = this.wzStatusId;
        data["wzStatusName"] = this.wzStatusName;
        data["createUserFirstName"] = this.createUserFirstName;
        data["createUserLastName"] = this.createUserLastName;
        data["lmUserFirstName"] = this.lmUserFirstName;
        data["lmUserLastName"] = this.lmUserLastName;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["count"] = this.count;
        data["productName"] = this.productName;
        data["unit"] = this.unit;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["invoiced"] = this.invoiced;
        return data;
    }
}

export interface IWZDocumentsModel {
    id?: string;
    name?: string | undefined;
    number?: number;
    supplyId?: string;
    supply?: SupplyModel;
    wzStatusId?: string;
    wzStatusName?: string | undefined;
    createUserFirstName?: string | undefined;
    createUserLastName?: string | undefined;
    lmUserFirstName?: string | undefined;
    lmUserLastName?: string | undefined;
    createDate?: Date;
    count?: number;
    productName?: string | undefined;
    unit?: string | undefined;
    customerId?: string;
    customer?: CustomerModel;
    invoiced?: boolean;
}

export class WZDocumentsModelPaginationResult implements IWZDocumentsModelPaginationResult {
    readonly result?: WZDocumentsModel[] | undefined;
    total?: number;

    constructor(data?: IWZDocumentsModelPaginationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(WZDocumentsModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): WZDocumentsModelPaginationResult {
        data = typeof data === 'object' ? data : {};
        let result = new WZDocumentsModelPaginationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IWZDocumentsModelPaginationResult {
    result?: WZDocumentsModel[] | undefined;
    total?: number;
}

export class WZDocumentsModelPaginationResultResponse implements IWZDocumentsModelPaginationResultResponse {
    result?: WZDocumentsModelPaginationResult;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IWZDocumentsModelPaginationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? WZDocumentsModelPaginationResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): WZDocumentsModelPaginationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WZDocumentsModelPaginationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IWZDocumentsModelPaginationResultResponse {
    result?: WZDocumentsModelPaginationResult;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export class WZDocumentsModelIEnumerableResponse implements IWZDocumentsModelIEnumerableResponse {
    readonly result?: WZDocumentsModel[] | undefined;
    readonly code?: number;
    readonly errors?: string[] | undefined;
    readonly isError?: boolean;

    constructor(data?: IWZDocumentsModelIEnumerableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["result"])
                    (<any>this).result!.push(WZDocumentsModel.fromJS(item));
            }
            (<any>this).code = _data["code"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).isError = _data["isError"];
        }
    }

    static fromJS(data: any): WZDocumentsModelIEnumerableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WZDocumentsModelIEnumerableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["code"] = this.code;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isError"] = this.isError;
        return data;
    }
}

export interface IWZDocumentsModelIEnumerableResponse {
    result?: WZDocumentsModel[] | undefined;
    code?: number;
    errors?: string[] | undefined;
    isError?: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}